import { merge, Subject, BehaviorSubject, ReplaySubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r);}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
},{}],2:[function(require,module,exports){
var SDPUtils = {};
SDPUtils.generateIdentifier = function() {
  return Math.random().toString(36).substr(2, 10);
};
SDPUtils.localCName = SDPUtils.generateIdentifier();
SDPUtils.splitLines = function(blob) {
  return blob.trim().split('\n').map(function(line) {
    return line.trim();
  });
};
SDPUtils.splitSections = function(blob) {
  var parts = blob.split('\nm=');
  return parts.map(function(part, index) {
    return (index > 0 ? 'm=' + part : part).trim() + '\r\n';
  });
};
SDPUtils.getDescription = function(blob) {
  var sections = SDPUtils.splitSections(blob);
  return sections && sections[0];
};
SDPUtils.getMediaSections = function(blob) {
  var sections = SDPUtils.splitSections(blob);
  sections.shift();
  return sections;
};
SDPUtils.matchPrefix = function(blob, prefix) {
  return SDPUtils.splitLines(blob).filter(function(line) {
    return line.indexOf(prefix) === 0;
  });
};
SDPUtils.parseCandidate = function(line) {
  var parts;
  if (line.indexOf('a=candidate:') === 0) {
    parts = line.substring(12).split(' ');
  } else {
    parts = line.substring(10).split(' ');
  }
  var candidate = {
    foundation: parts[0],
    component: parseInt(parts[1], 10),
    protocol: parts[2].toLowerCase(),
    priority: parseInt(parts[3], 10),
    ip: parts[4],
    port: parseInt(parts[5], 10),
    type: parts[7]
  };
  for (var i = 8; i < parts.length; i += 2) {
    switch (parts[i]) {
      case 'raddr':
        candidate.relatedAddress = parts[i + 1];
        break;
      case 'rport':
        candidate.relatedPort = parseInt(parts[i + 1], 10);
        break;
      case 'tcptype':
        candidate.tcpType = parts[i + 1];
        break;
      case 'ufrag':
        candidate.ufrag = parts[i + 1];
        candidate.usernameFragment = parts[i + 1];
        break;
      default:
        candidate[parts[i]] = parts[i + 1];
        break;
    }
  }
  return candidate;
};
SDPUtils.writeCandidate = function(candidate) {
  var sdp = [];
  sdp.push(candidate.foundation);
  sdp.push(candidate.component);
  sdp.push(candidate.protocol.toUpperCase());
  sdp.push(candidate.priority);
  sdp.push(candidate.ip);
  sdp.push(candidate.port);
  var type = candidate.type;
  sdp.push('typ');
  sdp.push(type);
  if (type !== 'host' && candidate.relatedAddress &&
      candidate.relatedPort) {
    sdp.push('raddr');
    sdp.push(candidate.relatedAddress);
    sdp.push('rport');
    sdp.push(candidate.relatedPort);
  }
  if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
    sdp.push('tcptype');
    sdp.push(candidate.tcpType);
  }
  if (candidate.usernameFragment || candidate.ufrag) {
    sdp.push('ufrag');
    sdp.push(candidate.usernameFragment || candidate.ufrag);
  }
  return 'candidate:' + sdp.join(' ');
};
SDPUtils.parseIceOptions = function(line) {
  return line.substr(14).split(' ');
};
SDPUtils.parseRtpMap = function(line) {
  var parts = line.substr(9).split(' ');
  var parsed = {
    payloadType: parseInt(parts.shift(), 10)
  };
  parts = parts[0].split('/');
  parsed.name = parts[0];
  parsed.clockRate = parseInt(parts[1], 10);
  parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
  parsed.numChannels = parsed.channels;
  return parsed;
};
SDPUtils.writeRtpMap = function(codec) {
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  var channels = codec.channels || codec.numChannels || 1;
  return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate +
      (channels !== 1 ? '/' + channels : '') + '\r\n';
};
SDPUtils.parseExtmap = function(line) {
  var parts = line.substr(9).split(' ');
  return {
    id: parseInt(parts[0], 10),
    direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
    uri: parts[1]
  };
};
SDPUtils.writeExtmap = function(headerExtension) {
  return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) +
      (headerExtension.direction && headerExtension.direction !== 'sendrecv'
          ? '/' + headerExtension.direction
          : '') +
      ' ' + headerExtension.uri + '\r\n';
};
SDPUtils.parseFmtp = function(line) {
  var parsed = {};
  var kv;
  var parts = line.substr(line.indexOf(' ') + 1).split(';');
  for (var j = 0; j < parts.length; j++) {
    kv = parts[j].trim().split('=');
    parsed[kv[0].trim()] = kv[1];
  }
  return parsed;
};
SDPUtils.writeFmtp = function(codec) {
  var line = '';
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.parameters && Object.keys(codec.parameters).length) {
    var params = [];
    Object.keys(codec.parameters).forEach(function(param) {
      if (codec.parameters[param]) {
        params.push(param + '=' + codec.parameters[param]);
      } else {
        params.push(param);
      }
    });
    line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
  }
  return line;
};
SDPUtils.parseRtcpFb = function(line) {
  var parts = line.substr(line.indexOf(' ') + 1).split(' ');
  return {
    type: parts.shift(),
    parameter: parts.join(' ')
  };
};
SDPUtils.writeRtcpFb = function(codec) {
  var lines = '';
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.rtcpFeedback && codec.rtcpFeedback.length) {
    codec.rtcpFeedback.forEach(function(fb) {
      lines += 'a=rtcp-fb:' + pt + ' ' + fb.type +
      (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') +
          '\r\n';
    });
  }
  return lines;
};
SDPUtils.parseSsrcMedia = function(line) {
  var sp = line.indexOf(' ');
  var parts = {
    ssrc: parseInt(line.substr(7, sp - 7), 10)
  };
  var colon = line.indexOf(':', sp);
  if (colon > -1) {
    parts.attribute = line.substr(sp + 1, colon - sp - 1);
    parts.value = line.substr(colon + 1);
  } else {
    parts.attribute = line.substr(sp + 1);
  }
  return parts;
};
SDPUtils.getMid = function(mediaSection) {
  var mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
  if (mid) {
    return mid.substr(6);
  }
};
SDPUtils.parseFingerprint = function(line) {
  var parts = line.substr(14).split(' ');
  return {
    algorithm: parts[0].toLowerCase(),
    value: parts[1]
  };
};
SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
  var lines = SDPUtils.matchPrefix(mediaSection + sessionpart,
      'a=fingerprint:');
  return {
    role: 'auto',
    fingerprints: lines.map(SDPUtils.parseFingerprint)
  };
};
SDPUtils.writeDtlsParameters = function(params, setupType) {
  var sdp = 'a=setup:' + setupType + '\r\n';
  params.fingerprints.forEach(function(fp) {
    sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
  });
  return sdp;
};
SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
  var lines = SDPUtils.splitLines(mediaSection);
  lines = lines.concat(SDPUtils.splitLines(sessionpart));
  var iceParameters = {
    usernameFragment: lines.filter(function(line) {
      return line.indexOf('a=ice-ufrag:') === 0;
    })[0].substr(12),
    password: lines.filter(function(line) {
      return line.indexOf('a=ice-pwd:') === 0;
    })[0].substr(10)
  };
  return iceParameters;
};
SDPUtils.writeIceParameters = function(params) {
  return 'a=ice-ufrag:' + params.usernameFragment + '\r\n' +
      'a=ice-pwd:' + params.password + '\r\n';
};
SDPUtils.parseRtpParameters = function(mediaSection) {
  var description = {
    codecs: [],
    headerExtensions: [],
    fecMechanisms: [],
    rtcp: []
  };
  var lines = SDPUtils.splitLines(mediaSection);
  var mline = lines[0].split(' ');
  for (var i = 3; i < mline.length; i++) {
    var pt = mline[i];
    var rtpmapline = SDPUtils.matchPrefix(
        mediaSection, 'a=rtpmap:' + pt + ' ')[0];
    if (rtpmapline) {
      var codec = SDPUtils.parseRtpMap(rtpmapline);
      var fmtps = SDPUtils.matchPrefix(
          mediaSection, 'a=fmtp:' + pt + ' ');
      codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
      codec.rtcpFeedback = SDPUtils.matchPrefix(
          mediaSection, 'a=rtcp-fb:' + pt + ' ')
        .map(SDPUtils.parseRtcpFb);
      description.codecs.push(codec);
      switch (codec.name.toUpperCase()) {
        case 'RED':
        case 'ULPFEC':
          description.fecMechanisms.push(codec.name.toUpperCase());
          break;
        default:
          break;
      }
    }
  }
  SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach(function(line) {
    description.headerExtensions.push(SDPUtils.parseExtmap(line));
  });
  return description;
};
SDPUtils.writeRtpDescription = function(kind, caps) {
  var sdp = '';
  sdp += 'm=' + kind + ' ';
  sdp += caps.codecs.length > 0 ? '9' : '0';
  sdp += ' UDP/TLS/RTP/SAVPF ';
  sdp += caps.codecs.map(function(codec) {
    if (codec.preferredPayloadType !== undefined) {
      return codec.preferredPayloadType;
    }
    return codec.payloadType;
  }).join(' ') + '\r\n';
  sdp += 'c=IN IP4 0.0.0.0\r\n';
  sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';
  caps.codecs.forEach(function(codec) {
    sdp += SDPUtils.writeRtpMap(codec);
    sdp += SDPUtils.writeFmtp(codec);
    sdp += SDPUtils.writeRtcpFb(codec);
  });
  var maxptime = 0;
  caps.codecs.forEach(function(codec) {
    if (codec.maxptime > maxptime) {
      maxptime = codec.maxptime;
    }
  });
  if (maxptime > 0) {
    sdp += 'a=maxptime:' + maxptime + '\r\n';
  }
  sdp += 'a=rtcp-mux\r\n';
  if (caps.headerExtensions) {
    caps.headerExtensions.forEach(function(extension) {
      sdp += SDPUtils.writeExtmap(extension);
    });
  }
  return sdp;
};
SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
  var encodingParameters = [];
  var description = SDPUtils.parseRtpParameters(mediaSection);
  var hasRed = description.fecMechanisms.indexOf('RED') !== -1;
  var hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;
  var ssrcs = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
  .map(function(line) {
    return SDPUtils.parseSsrcMedia(line);
  })
  .filter(function(parts) {
    return parts.attribute === 'cname';
  });
  var primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
  var secondarySsrc;
  var flows = SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID')
  .map(function(line) {
    var parts = line.substr(17).split(' ');
    return parts.map(function(part) {
      return parseInt(part, 10);
    });
  });
  if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) {
    secondarySsrc = flows[0][1];
  }
  description.codecs.forEach(function(codec) {
    if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
      var encParam = {
        ssrc: primarySsrc,
        codecPayloadType: parseInt(codec.parameters.apt, 10),
      };
      if (primarySsrc && secondarySsrc) {
        encParam.rtx = {ssrc: secondarySsrc};
      }
      encodingParameters.push(encParam);
      if (hasRed) {
        encParam = JSON.parse(JSON.stringify(encParam));
        encParam.fec = {
          ssrc: secondarySsrc,
          mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
        };
        encodingParameters.push(encParam);
      }
    }
  });
  if (encodingParameters.length === 0 && primarySsrc) {
    encodingParameters.push({
      ssrc: primarySsrc
    });
  }
  var bandwidth = SDPUtils.matchPrefix(mediaSection, 'b=');
  if (bandwidth.length) {
    if (bandwidth[0].indexOf('b=TIAS:') === 0) {
      bandwidth = parseInt(bandwidth[0].substr(7), 10);
    } else if (bandwidth[0].indexOf('b=AS:') === 0) {
      bandwidth = parseInt(bandwidth[0].substr(5), 10) * 1000 * 0.95
          - (50 * 40 * 8);
    } else {
      bandwidth = undefined;
    }
    encodingParameters.forEach(function(params) {
      params.maxBitrate = bandwidth;
    });
  }
  return encodingParameters;
};
SDPUtils.parseRtcpParameters = function(mediaSection) {
  var rtcpParameters = {};
  var remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
      .map(function(line) {
        return SDPUtils.parseSsrcMedia(line);
      })
      .filter(function(obj) {
        return obj.attribute === 'cname';
      })[0];
  if (remoteSsrc) {
    rtcpParameters.cname = remoteSsrc.value;
    rtcpParameters.ssrc = remoteSsrc.ssrc;
  }
  var rsize = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
  rtcpParameters.reducedSize = rsize.length > 0;
  rtcpParameters.compound = rsize.length === 0;
  var mux = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
  rtcpParameters.mux = mux.length > 0;
  return rtcpParameters;
};
SDPUtils.parseMsid = function(mediaSection) {
  var parts;
  var spec = SDPUtils.matchPrefix(mediaSection, 'a=msid:');
  if (spec.length === 1) {
    parts = spec[0].substr(7).split(' ');
    return {stream: parts[0], track: parts[1]};
  }
  var planB = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
  .map(function(line) {
    return SDPUtils.parseSsrcMedia(line);
  })
  .filter(function(parts) {
    return parts.attribute === 'msid';
  });
  if (planB.length > 0) {
    parts = planB[0].value.split(' ');
    return {stream: parts[0], track: parts[1]};
  }
};
SDPUtils.generateSessionId = function() {
  return Math.random().toString().substr(2, 21);
};
SDPUtils.writeSessionBoilerplate = function(sessId, sessVer) {
  var sessionId;
  var version = sessVer !== undefined ? sessVer : 2;
  if (sessId) {
    sessionId = sessId;
  } else {
    sessionId = SDPUtils.generateSessionId();
  }
  return 'v=0\r\n' +
      'o=thisisadapterortc ' + sessionId + ' ' + version + ' IN IP4 127.0.0.1\r\n' +
      's=-\r\n' +
      't=0 0\r\n';
};
SDPUtils.writeMediaSection = function(transceiver, caps, type, stream) {
  var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);
  sdp += SDPUtils.writeIceParameters(
      transceiver.iceGatherer.getLocalParameters());
  sdp += SDPUtils.writeDtlsParameters(
      transceiver.dtlsTransport.getLocalParameters(),
      type === 'offer' ? 'actpass' : 'active');
  sdp += 'a=mid:' + transceiver.mid + '\r\n';
  if (transceiver.direction) {
    sdp += 'a=' + transceiver.direction + '\r\n';
  } else if (transceiver.rtpSender && transceiver.rtpReceiver) {
    sdp += 'a=sendrecv\r\n';
  } else if (transceiver.rtpSender) {
    sdp += 'a=sendonly\r\n';
  } else if (transceiver.rtpReceiver) {
    sdp += 'a=recvonly\r\n';
  } else {
    sdp += 'a=inactive\r\n';
  }
  if (transceiver.rtpSender) {
    var msid = 'msid:' + stream.id + ' ' +
        transceiver.rtpSender.track.id + '\r\n';
    sdp += 'a=' + msid;
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
        ' ' + msid;
    if (transceiver.sendEncodingParameters[0].rtx) {
      sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
          ' ' + msid;
      sdp += 'a=ssrc-group:FID ' +
          transceiver.sendEncodingParameters[0].ssrc + ' ' +
          transceiver.sendEncodingParameters[0].rtx.ssrc +
          '\r\n';
    }
  }
  sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
      ' cname:' + SDPUtils.localCName + '\r\n';
  if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) {
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
        ' cname:' + SDPUtils.localCName + '\r\n';
  }
  return sdp;
};
SDPUtils.getDirection = function(mediaSection, sessionpart) {
  var lines = SDPUtils.splitLines(mediaSection);
  for (var i = 0; i < lines.length; i++) {
    switch (lines[i]) {
      case 'a=sendrecv':
      case 'a=sendonly':
      case 'a=recvonly':
      case 'a=inactive':
        return lines[i].substr(2);
      default:
    }
  }
  if (sessionpart) {
    return SDPUtils.getDirection(sessionpart);
  }
  return 'sendrecv';
};
SDPUtils.getKind = function(mediaSection) {
  var lines = SDPUtils.splitLines(mediaSection);
  var mline = lines[0].split(' ');
  return mline[0].substr(2);
};
SDPUtils.isRejected = function(mediaSection) {
  return mediaSection.split(' ', 2)[1] === '0';
};
SDPUtils.parseMLine = function(mediaSection) {
  var lines = SDPUtils.splitLines(mediaSection);
  var parts = lines[0].substr(2).split(' ');
  return {
    kind: parts[0],
    port: parseInt(parts[1], 10),
    protocol: parts[2],
    fmt: parts.slice(3).join(' ')
  };
};
SDPUtils.parseOLine = function(mediaSection) {
  var line = SDPUtils.matchPrefix(mediaSection, 'o=')[0];
  var parts = line.substr(2).split(' ');
  return {
    username: parts[0],
    sessionId: parts[1],
    sessionVersion: parseInt(parts[2], 10),
    netType: parts[3],
    addressType: parts[4],
    address: parts[5],
  };
};
if (typeof module === 'object') {
  module.exports = SDPUtils;
}
},{}],3:[function(require,module,exports){
(function (global){
var adapterFactory = require('./adapter_factory.js');
module.exports = adapterFactory({window: global.window});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
},{"./adapter_factory.js":4}],4:[function(require,module,exports){
var utils = require('./utils');
module.exports = function(dependencies, opts) {
  var window = dependencies && dependencies.window;
  var options = {
    shimChrome: true,
    shimFirefox: true,
    shimEdge: true,
    shimSafari: true,
  };
  for (var key in opts) {
    if (hasOwnProperty.call(opts, key)) {
      options[key] = opts[key];
    }
  }
  var logging = utils.log;
  var browserDetails = utils.detectBrowser(window);
  var chromeShim = require('./chrome/chrome_shim') || null;
  var edgeShim = require('./edge/edge_shim') || null;
  var firefoxShim = require('./firefox/firefox_shim') || null;
  var safariShim = require('./safari/safari_shim') || null;
  var commonShim = require('./common_shim') || null;
  var adapter = {
    browserDetails: browserDetails,
    commonShim: commonShim,
    extractVersion: utils.extractVersion,
    disableLog: utils.disableLog,
    disableWarnings: utils.disableWarnings
  };
  switch (browserDetails.browser) {
    case 'chrome':
      if (!chromeShim || !chromeShim.shimPeerConnection ||
          !options.shimChrome) {
        logging('Chrome shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming chrome.');
      adapter.browserShim = chromeShim;
      commonShim.shimCreateObjectURL(window);
      chromeShim.shimGetUserMedia(window);
      chromeShim.shimMediaStream(window);
      chromeShim.shimSourceObject(window);
      chromeShim.shimPeerConnection(window);
      chromeShim.shimOnTrack(window);
      chromeShim.shimAddTrackRemoveTrack(window);
      chromeShim.shimGetSendersWithDtmf(window);
      chromeShim.shimSenderReceiverGetStats(window);
      chromeShim.fixNegotiationNeeded(window);
      commonShim.shimRTCIceCandidate(window);
      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      break;
    case 'firefox':
      if (!firefoxShim || !firefoxShim.shimPeerConnection ||
          !options.shimFirefox) {
        logging('Firefox shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming firefox.');
      adapter.browserShim = firefoxShim;
      commonShim.shimCreateObjectURL(window);
      firefoxShim.shimGetUserMedia(window);
      firefoxShim.shimSourceObject(window);
      firefoxShim.shimPeerConnection(window);
      firefoxShim.shimOnTrack(window);
      firefoxShim.shimRemoveStream(window);
      firefoxShim.shimSenderGetStats(window);
      firefoxShim.shimReceiverGetStats(window);
      firefoxShim.shimRTCDataChannel(window);
      commonShim.shimRTCIceCandidate(window);
      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      break;
    case 'edge':
      if (!edgeShim || !edgeShim.shimPeerConnection || !options.shimEdge) {
        logging('MS edge shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming edge.');
      adapter.browserShim = edgeShim;
      commonShim.shimCreateObjectURL(window);
      edgeShim.shimGetUserMedia(window);
      edgeShim.shimPeerConnection(window);
      edgeShim.shimReplaceTrack(window);
      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      break;
    case 'safari':
      if (!safariShim || !options.shimSafari) {
        logging('Safari shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming safari.');
      adapter.browserShim = safariShim;
      commonShim.shimCreateObjectURL(window);
      safariShim.shimRTCIceServerUrls(window);
      safariShim.shimCallbacksAPI(window);
      safariShim.shimLocalStreamsAPI(window);
      safariShim.shimRemoteStreamsAPI(window);
      safariShim.shimTrackEventTransceiver(window);
      safariShim.shimGetUserMedia(window);
      safariShim.shimCreateOfferLegacy(window);
      commonShim.shimRTCIceCandidate(window);
      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      break;
    default:
      logging('Unsupported browser!');
      break;
  }
  return adapter;
};
},{"./chrome/chrome_shim":5,"./common_shim":7,"./edge/edge_shim":1,"./firefox/firefox_shim":8,"./safari/safari_shim":10,"./utils":11}],5:[function(require,module,exports){
var utils = require('../utils.js');
var logging = utils.log;
function walkStats(stats, base, resultSet) {
  if (!base || resultSet.has(base.id)) {
    return;
  }
  resultSet.set(base.id, base);
  Object.keys(base).forEach(function(name) {
    if (name.endsWith('Id')) {
      walkStats(stats, stats.get(base[name]), resultSet);
    } else if (name.endsWith('Ids')) {
      base[name].forEach(function(id) {
        walkStats(stats, stats.get(id), resultSet);
      });
    }
  });
}
function filterStats(result, track, outbound) {
  var streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
  var filteredResult = new Map();
  if (track === null) {
    return filteredResult;
  }
  var trackStats = [];
  result.forEach(function(value) {
    if (value.type === 'track' &&
        value.trackIdentifier === track.id) {
      trackStats.push(value);
    }
  });
  trackStats.forEach(function(trackStat) {
    result.forEach(function(stats) {
      if (stats.type === streamStatsType && stats.trackId === trackStat.id) {
        walkStats(result, stats, filteredResult);
      }
    });
  });
  return filteredResult;
}
module.exports = {
  shimGetUserMedia: require('./getusermedia'),
  shimMediaStream: function(window) {
    window.MediaStream = window.MediaStream || window.webkitMediaStream;
  },
  shimOnTrack: function(window) {
    if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in
        window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
        get: function() {
          return this._ontrack;
        },
        set: function(f) {
          if (this._ontrack) {
            this.removeEventListener('track', this._ontrack);
          }
          this.addEventListener('track', this._ontrack = f);
        },
        enumerable: true,
        configurable: true
      });
      var origSetRemoteDescription =
          window.RTCPeerConnection.prototype.setRemoteDescription;
      window.RTCPeerConnection.prototype.setRemoteDescription = function() {
        var pc = this;
        if (!pc._ontrackpoly) {
          pc._ontrackpoly = function(e) {
            e.stream.addEventListener('addtrack', function(te) {
              var receiver;
              if (window.RTCPeerConnection.prototype.getReceivers) {
                receiver = pc.getReceivers().find(function(r) {
                  return r.track && r.track.id === te.track.id;
                });
              } else {
                receiver = {track: te.track};
              }
              var event = new Event('track');
              event.track = te.track;
              event.receiver = receiver;
              event.transceiver = {receiver: receiver};
              event.streams = [e.stream];
              pc.dispatchEvent(event);
            });
            e.stream.getTracks().forEach(function(track) {
              var receiver;
              if (window.RTCPeerConnection.prototype.getReceivers) {
                receiver = pc.getReceivers().find(function(r) {
                  return r.track && r.track.id === track.id;
                });
              } else {
                receiver = {track: track};
              }
              var event = new Event('track');
              event.track = track;
              event.receiver = receiver;
              event.transceiver = {receiver: receiver};
              event.streams = [e.stream];
              pc.dispatchEvent(event);
            });
          };
          pc.addEventListener('addstream', pc._ontrackpoly);
        }
        return origSetRemoteDescription.apply(pc, arguments);
      };
    } else if (!('RTCRtpTransceiver' in window)) {
      utils.wrapPeerConnectionEvent(window, 'track', function(e) {
        if (!e.transceiver) {
          e.transceiver = {receiver: e.receiver};
        }
        return e;
      });
    }
  },
  shimGetSendersWithDtmf: function(window) {
    if (typeof window === 'object' && window.RTCPeerConnection &&
        !('getSenders' in window.RTCPeerConnection.prototype) &&
        'createDTMFSender' in window.RTCPeerConnection.prototype) {
      var shimSenderWithDtmf = function(pc, track) {
        return {
          track: track,
          get dtmf() {
            if (this._dtmf === undefined) {
              if (track.kind === 'audio') {
                this._dtmf = pc.createDTMFSender(track);
              } else {
                this._dtmf = null;
              }
            }
            return this._dtmf;
          },
          _pc: pc
        };
      };
      if (!window.RTCPeerConnection.prototype.getSenders) {
        window.RTCPeerConnection.prototype.getSenders = function() {
          this._senders = this._senders || [];
          return this._senders.slice();
        };
        var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
        window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
          var pc = this;
          var sender = origAddTrack.apply(pc, arguments);
          if (!sender) {
            sender = shimSenderWithDtmf(pc, track);
            pc._senders.push(sender);
          }
          return sender;
        };
        var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
        window.RTCPeerConnection.prototype.removeTrack = function(sender) {
          var pc = this;
          origRemoveTrack.apply(pc, arguments);
          var idx = pc._senders.indexOf(sender);
          if (idx !== -1) {
            pc._senders.splice(idx, 1);
          }
        };
      }
      var origAddStream = window.RTCPeerConnection.prototype.addStream;
      window.RTCPeerConnection.prototype.addStream = function(stream) {
        var pc = this;
        pc._senders = pc._senders || [];
        origAddStream.apply(pc, [stream]);
        stream.getTracks().forEach(function(track) {
          pc._senders.push(shimSenderWithDtmf(pc, track));
        });
      };
      var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
      window.RTCPeerConnection.prototype.removeStream = function(stream) {
        var pc = this;
        pc._senders = pc._senders || [];
        origRemoveStream.apply(pc, [stream]);
        stream.getTracks().forEach(function(track) {
          var sender = pc._senders.find(function(s) {
            return s.track === track;
          });
          if (sender) {
            pc._senders.splice(pc._senders.indexOf(sender), 1);
          }
        });
      };
    } else if (typeof window === 'object' && window.RTCPeerConnection &&
               'getSenders' in window.RTCPeerConnection.prototype &&
               'createDTMFSender' in window.RTCPeerConnection.prototype &&
               window.RTCRtpSender &&
               !('dtmf' in window.RTCRtpSender.prototype)) {
      var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
      window.RTCPeerConnection.prototype.getSenders = function() {
        var pc = this;
        var senders = origGetSenders.apply(pc, []);
        senders.forEach(function(sender) {
          sender._pc = pc;
        });
        return senders;
      };
      Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
        get: function() {
          if (this._dtmf === undefined) {
            if (this.track.kind === 'audio') {
              this._dtmf = this._pc.createDTMFSender(this.track);
            } else {
              this._dtmf = null;
            }
          }
          return this._dtmf;
        }
      });
    }
  },
  shimSenderReceiverGetStats: function(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection &&
        window.RTCRtpSender && window.RTCRtpReceiver)) {
      return;
    }
    if (!('getStats' in window.RTCRtpSender.prototype)) {
      var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
      if (origGetSenders) {
        window.RTCPeerConnection.prototype.getSenders = function() {
          var pc = this;
          var senders = origGetSenders.apply(pc, []);
          senders.forEach(function(sender) {
            sender._pc = pc;
          });
          return senders;
        };
      }
      var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
      if (origAddTrack) {
        window.RTCPeerConnection.prototype.addTrack = function() {
          var sender = origAddTrack.apply(this, arguments);
          sender._pc = this;
          return sender;
        };
      }
      window.RTCRtpSender.prototype.getStats = function() {
        var sender = this;
        return this._pc.getStats().then(function(result) {
          return filterStats(result, sender.track, true);
        });
      };
    }
    if (!('getStats' in window.RTCRtpReceiver.prototype)) {
      var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
      if (origGetReceivers) {
        window.RTCPeerConnection.prototype.getReceivers = function() {
          var pc = this;
          var receivers = origGetReceivers.apply(pc, []);
          receivers.forEach(function(receiver) {
            receiver._pc = pc;
          });
          return receivers;
        };
      }
      utils.wrapPeerConnectionEvent(window, 'track', function(e) {
        e.receiver._pc = e.srcElement;
        return e;
      });
      window.RTCRtpReceiver.prototype.getStats = function() {
        var receiver = this;
        return this._pc.getStats().then(function(result) {
          return filterStats(result, receiver.track, false);
        });
      };
    }
    if (!('getStats' in window.RTCRtpSender.prototype &&
        'getStats' in window.RTCRtpReceiver.prototype)) {
      return;
    }
    var origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function() {
      var pc = this;
      if (arguments.length > 0 &&
          arguments[0] instanceof window.MediaStreamTrack) {
        var track = arguments[0];
        var sender;
        var receiver;
        var err;
        pc.getSenders().forEach(function(s) {
          if (s.track === track) {
            if (sender) {
              err = true;
            } else {
              sender = s;
            }
          }
        });
        pc.getReceivers().forEach(function(r) {
          if (r.track === track) {
            if (receiver) {
              err = true;
            } else {
              receiver = r;
            }
          }
          return r.track === track;
        });
        if (err || (sender && receiver)) {
          return Promise.reject(new DOMException(
            'There are more than one sender or receiver for the track.',
            'InvalidAccessError'));
        } else if (sender) {
          return sender.getStats();
        } else if (receiver) {
          return receiver.getStats();
        }
        return Promise.reject(new DOMException(
          'There is no sender or receiver for the track.',
          'InvalidAccessError'));
      }
      return origGetStats.apply(pc, arguments);
    };
  },
  shimSourceObject: function(window) {
    var URL = window && window.URL;
    if (typeof window === 'object') {
      if (window.HTMLMediaElement &&
        !('srcObject' in window.HTMLMediaElement.prototype)) {
        Object.defineProperty(window.HTMLMediaElement.prototype, 'srcObject', {
          get: function() {
            return this._srcObject;
          },
          set: function(stream) {
            var self = this;
            this._srcObject = stream;
            if (this.src) {
              URL.revokeObjectURL(this.src);
            }
            if (!stream) {
              this.src = '';
              return undefined;
            }
            this.src = URL.createObjectURL(stream);
            stream.addEventListener('addtrack', function() {
              if (self.src) {
                URL.revokeObjectURL(self.src);
              }
              self.src = URL.createObjectURL(stream);
            });
            stream.addEventListener('removetrack', function() {
              if (self.src) {
                URL.revokeObjectURL(self.src);
              }
              self.src = URL.createObjectURL(stream);
            });
          }
        });
      }
    }
  },
  shimAddTrackRemoveTrackWithNative: function(window) {
    window.RTCPeerConnection.prototype.getLocalStreams = function() {
      var pc = this;
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      return Object.keys(this._shimmedLocalStreams).map(function(streamId) {
        return pc._shimmedLocalStreams[streamId][0];
      });
    };
    var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
      if (!stream) {
        return origAddTrack.apply(this, arguments);
      }
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      var sender = origAddTrack.apply(this, arguments);
      if (!this._shimmedLocalStreams[stream.id]) {
        this._shimmedLocalStreams[stream.id] = [stream, sender];
      } else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) {
        this._shimmedLocalStreams[stream.id].push(sender);
      }
      return sender;
    };
    var origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function(stream) {
      var pc = this;
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      stream.getTracks().forEach(function(track) {
        var alreadyExists = pc.getSenders().find(function(s) {
          return s.track === track;
        });
        if (alreadyExists) {
          throw new DOMException('Track already exists.',
              'InvalidAccessError');
        }
      });
      var existingSenders = pc.getSenders();
      origAddStream.apply(this, arguments);
      var newSenders = pc.getSenders().filter(function(newSender) {
        return existingSenders.indexOf(newSender) === -1;
      });
      this._shimmedLocalStreams[stream.id] = [stream].concat(newSenders);
    };
    var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function(stream) {
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      delete this._shimmedLocalStreams[stream.id];
      return origRemoveStream.apply(this, arguments);
    };
    var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
    window.RTCPeerConnection.prototype.removeTrack = function(sender) {
      var pc = this;
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      if (sender) {
        Object.keys(this._shimmedLocalStreams).forEach(function(streamId) {
          var idx = pc._shimmedLocalStreams[streamId].indexOf(sender);
          if (idx !== -1) {
            pc._shimmedLocalStreams[streamId].splice(idx, 1);
          }
          if (pc._shimmedLocalStreams[streamId].length === 1) {
            delete pc._shimmedLocalStreams[streamId];
          }
        });
      }
      return origRemoveTrack.apply(this, arguments);
    };
  },
  shimAddTrackRemoveTrack: function(window) {
    var browserDetails = utils.detectBrowser(window);
    if (window.RTCPeerConnection.prototype.addTrack &&
        browserDetails.version >= 65) {
      return this.shimAddTrackRemoveTrackWithNative(window);
    }
    var origGetLocalStreams = window.RTCPeerConnection.prototype
        .getLocalStreams;
    window.RTCPeerConnection.prototype.getLocalStreams = function() {
      var pc = this;
      var nativeStreams = origGetLocalStreams.apply(this);
      pc._reverseStreams = pc._reverseStreams || {};
      return nativeStreams.map(function(stream) {
        return pc._reverseStreams[stream.id];
      });
    };
    var origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function(stream) {
      var pc = this;
      pc._streams = pc._streams || {};
      pc._reverseStreams = pc._reverseStreams || {};
      stream.getTracks().forEach(function(track) {
        var alreadyExists = pc.getSenders().find(function(s) {
          return s.track === track;
        });
        if (alreadyExists) {
          throw new DOMException('Track already exists.',
              'InvalidAccessError');
        }
      });
      if (!pc._reverseStreams[stream.id]) {
        var newStream = new window.MediaStream(stream.getTracks());
        pc._streams[stream.id] = newStream;
        pc._reverseStreams[newStream.id] = stream;
        stream = newStream;
      }
      origAddStream.apply(pc, [stream]);
    };
    var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function(stream) {
      var pc = this;
      pc._streams = pc._streams || {};
      pc._reverseStreams = pc._reverseStreams || {};
      origRemoveStream.apply(pc, [(pc._streams[stream.id] || stream)]);
      delete pc._reverseStreams[(pc._streams[stream.id] ?
          pc._streams[stream.id].id : stream.id)];
      delete pc._streams[stream.id];
    };
    window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
      var pc = this;
      if (pc.signalingState === 'closed') {
        throw new DOMException(
          'The RTCPeerConnection\'s signalingState is \'closed\'.',
          'InvalidStateError');
      }
      var streams = [].slice.call(arguments, 1);
      if (streams.length !== 1 ||
          !streams[0].getTracks().find(function(t) {
            return t === track;
          })) {
        throw new DOMException(
          'The adapter.js addTrack polyfill only supports a single ' +
          ' stream which is associated with the specified track.',
          'NotSupportedError');
      }
      var alreadyExists = pc.getSenders().find(function(s) {
        return s.track === track;
      });
      if (alreadyExists) {
        throw new DOMException('Track already exists.',
            'InvalidAccessError');
      }
      pc._streams = pc._streams || {};
      pc._reverseStreams = pc._reverseStreams || {};
      var oldStream = pc._streams[stream.id];
      if (oldStream) {
        oldStream.addTrack(track);
        Promise.resolve().then(function() {
          pc.dispatchEvent(new Event('negotiationneeded'));
        });
      } else {
        var newStream = new window.MediaStream([track]);
        pc._streams[stream.id] = newStream;
        pc._reverseStreams[newStream.id] = stream;
        pc.addStream(newStream);
      }
      return pc.getSenders().find(function(s) {
        return s.track === track;
      });
    };
    function replaceInternalStreamId(pc, description) {
      var sdp = description.sdp;
      Object.keys(pc._reverseStreams || []).forEach(function(internalId) {
        var externalStream = pc._reverseStreams[internalId];
        var internalStream = pc._streams[externalStream.id];
        sdp = sdp.replace(new RegExp(internalStream.id, 'g'),
            externalStream.id);
      });
      return new RTCSessionDescription({
        type: description.type,
        sdp: sdp
      });
    }
    function replaceExternalStreamId(pc, description) {
      var sdp = description.sdp;
      Object.keys(pc._reverseStreams || []).forEach(function(internalId) {
        var externalStream = pc._reverseStreams[internalId];
        var internalStream = pc._streams[externalStream.id];
        sdp = sdp.replace(new RegExp(externalStream.id, 'g'),
            internalStream.id);
      });
      return new RTCSessionDescription({
        type: description.type,
        sdp: sdp
      });
    }
    ['createOffer', 'createAnswer'].forEach(function(method) {
      var nativeMethod = window.RTCPeerConnection.prototype[method];
      window.RTCPeerConnection.prototype[method] = function() {
        var pc = this;
        var args = arguments;
        var isLegacyCall = arguments.length &&
            typeof arguments[0] === 'function';
        if (isLegacyCall) {
          return nativeMethod.apply(pc, [
            function(description) {
              var desc = replaceInternalStreamId(pc, description);
              args[0].apply(null, [desc]);
            },
            function(err) {
              if (args[1]) {
                args[1].apply(null, err);
              }
            }, arguments[2]
          ]);
        }
        return nativeMethod.apply(pc, arguments)
        .then(function(description) {
          return replaceInternalStreamId(pc, description);
        });
      };
    });
    var origSetLocalDescription =
        window.RTCPeerConnection.prototype.setLocalDescription;
    window.RTCPeerConnection.prototype.setLocalDescription = function() {
      var pc = this;
      if (!arguments.length || !arguments[0].type) {
        return origSetLocalDescription.apply(pc, arguments);
      }
      arguments[0] = replaceExternalStreamId(pc, arguments[0]);
      return origSetLocalDescription.apply(pc, arguments);
    };
    var origLocalDescription = Object.getOwnPropertyDescriptor(
        window.RTCPeerConnection.prototype, 'localDescription');
    Object.defineProperty(window.RTCPeerConnection.prototype,
        'localDescription', {
          get: function() {
            var pc = this;
            var description = origLocalDescription.get.apply(this);
            if (description.type === '') {
              return description;
            }
            return replaceInternalStreamId(pc, description);
          }
        });
    window.RTCPeerConnection.prototype.removeTrack = function(sender) {
      var pc = this;
      if (pc.signalingState === 'closed') {
        throw new DOMException(
          'The RTCPeerConnection\'s signalingState is \'closed\'.',
          'InvalidStateError');
      }
      if (!sender._pc) {
        throw new DOMException('Argument 1 of RTCPeerConnection.removeTrack ' +
            'does not implement interface RTCRtpSender.', 'TypeError');
      }
      var isLocal = sender._pc === pc;
      if (!isLocal) {
        throw new DOMException('Sender was not created by this connection.',
            'InvalidAccessError');
      }
      pc._streams = pc._streams || {};
      var stream;
      Object.keys(pc._streams).forEach(function(streamid) {
        var hasTrack = pc._streams[streamid].getTracks().find(function(track) {
          return sender.track === track;
        });
        if (hasTrack) {
          stream = pc._streams[streamid];
        }
      });
      if (stream) {
        if (stream.getTracks().length === 1) {
          pc.removeStream(pc._reverseStreams[stream.id]);
        } else {
          stream.removeTrack(sender.track);
        }
        pc.dispatchEvent(new Event('negotiationneeded'));
      }
    };
  },
  shimPeerConnection: function(window) {
    var browserDetails = utils.detectBrowser(window);
    if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) {
      window.RTCPeerConnection = function(pcConfig, pcConstraints) {
        logging('PeerConnection');
        if (pcConfig && pcConfig.iceTransportPolicy) {
          pcConfig.iceTransports = pcConfig.iceTransportPolicy;
        }
        return new window.webkitRTCPeerConnection(pcConfig, pcConstraints);
      };
      window.RTCPeerConnection.prototype =
          window.webkitRTCPeerConnection.prototype;
      if (window.webkitRTCPeerConnection.generateCertificate) {
        Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
          get: function() {
            return window.webkitRTCPeerConnection.generateCertificate;
          }
        });
      }
    } else {
      var OrigPeerConnection = window.RTCPeerConnection;
      window.RTCPeerConnection = function(pcConfig, pcConstraints) {
        if (pcConfig && pcConfig.iceServers) {
          var newIceServers = [];
          for (var i = 0; i < pcConfig.iceServers.length; i++) {
            var server = pcConfig.iceServers[i];
            if (!server.hasOwnProperty('urls') &&
                server.hasOwnProperty('url')) {
              utils.deprecated('RTCIceServer.url', 'RTCIceServer.urls');
              server = JSON.parse(JSON.stringify(server));
              server.urls = server.url;
              newIceServers.push(server);
            } else {
              newIceServers.push(pcConfig.iceServers[i]);
            }
          }
          pcConfig.iceServers = newIceServers;
        }
        return new OrigPeerConnection(pcConfig, pcConstraints);
      };
      window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
      Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
        get: function() {
          return OrigPeerConnection.generateCertificate;
        }
      });
    }
    var origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function(selector,
        successCallback, errorCallback) {
      var pc = this;
      var args = arguments;
      if (arguments.length > 0 && typeof selector === 'function') {
        return origGetStats.apply(this, arguments);
      }
      if (origGetStats.length === 0 && (arguments.length === 0 ||
          typeof arguments[0] !== 'function')) {
        return origGetStats.apply(this, []);
      }
      var fixChromeStats_ = function(response) {
        var standardReport = {};
        var reports = response.result();
        reports.forEach(function(report) {
          var standardStats = {
            id: report.id,
            timestamp: report.timestamp,
            type: {
              localcandidate: 'local-candidate',
              remotecandidate: 'remote-candidate'
            }[report.type] || report.type
          };
          report.names().forEach(function(name) {
            standardStats[name] = report.stat(name);
          });
          standardReport[standardStats.id] = standardStats;
        });
        return standardReport;
      };
      var makeMapStats = function(stats) {
        return new Map(Object.keys(stats).map(function(key) {
          return [key, stats[key]];
        }));
      };
      if (arguments.length >= 2) {
        var successCallbackWrapper_ = function(response) {
          args[1](makeMapStats(fixChromeStats_(response)));
        };
        return origGetStats.apply(this, [successCallbackWrapper_,
          arguments[0]]);
      }
      return new Promise(function(resolve, reject) {
        origGetStats.apply(pc, [
          function(response) {
            resolve(makeMapStats(fixChromeStats_(response)));
          }, reject]);
      }).then(successCallback, errorCallback);
    };
    if (browserDetails.version < 51) {
      ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
          .forEach(function(method) {
            var nativeMethod = window.RTCPeerConnection.prototype[method];
            window.RTCPeerConnection.prototype[method] = function() {
              var args = arguments;
              var pc = this;
              var promise = new Promise(function(resolve, reject) {
                nativeMethod.apply(pc, [args[0], resolve, reject]);
              });
              if (args.length < 2) {
                return promise;
              }
              return promise.then(function() {
                args[1].apply(null, []);
              },
              function(err) {
                if (args.length >= 3) {
                  args[2].apply(null, [err]);
                }
              });
            };
          });
    }
    if (browserDetails.version < 52) {
      ['createOffer', 'createAnswer'].forEach(function(method) {
        var nativeMethod = window.RTCPeerConnection.prototype[method];
        window.RTCPeerConnection.prototype[method] = function() {
          var pc = this;
          if (arguments.length < 1 || (arguments.length === 1 &&
              typeof arguments[0] === 'object')) {
            var opts = arguments.length === 1 ? arguments[0] : undefined;
            return new Promise(function(resolve, reject) {
              nativeMethod.apply(pc, [resolve, reject, opts]);
            });
          }
          return nativeMethod.apply(this, arguments);
        };
      });
    }
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
        .forEach(function(method) {
          var nativeMethod = window.RTCPeerConnection.prototype[method];
          window.RTCPeerConnection.prototype[method] = function() {
            arguments[0] = new ((method === 'addIceCandidate') ?
                window.RTCIceCandidate :
                window.RTCSessionDescription)(arguments[0]);
            return nativeMethod.apply(this, arguments);
          };
        });
    var nativeAddIceCandidate =
        window.RTCPeerConnection.prototype.addIceCandidate;
    window.RTCPeerConnection.prototype.addIceCandidate = function() {
      if (!arguments[0]) {
        if (arguments[1]) {
          arguments[1].apply(null);
        }
        return Promise.resolve();
      }
      return nativeAddIceCandidate.apply(this, arguments);
    };
  },
  fixNegotiationNeeded: function(window) {
    utils.wrapPeerConnectionEvent(window, 'negotiationneeded', function(e) {
      var pc = e.target;
      if (pc.signalingState !== 'stable') {
        return;
      }
      return e;
    });
  },
  shimGetDisplayMedia: function(window, getSourceId) {
    if ('getDisplayMedia' in window.navigator) {
      return;
    }
    if (typeof getSourceId !== 'function') {
      console.error('shimGetDisplayMedia: getSourceId argument is not ' +
          'a function');
      return;
    }
    navigator.getDisplayMedia = function(constraints) {
      return getSourceId(constraints)
        .then(function(sourceId) {
          constraints.video = {
            mandatory: {
              chromeMediaSource: 'desktop',
              chromeMediaSourceId: sourceId,
              maxFrameRate: constraints.video.frameRate || 3
            }
          };
          return navigator.mediaDevices.getUserMedia(constraints);
        });
    };
  }
};
},{"../utils.js":11,"./getusermedia":6}],6:[function(require,module,exports){
var utils = require('../utils.js');
var logging = utils.log;
module.exports = function(window) {
  var browserDetails = utils.detectBrowser(window);
  var navigator = window && window.navigator;
  var constraintsToChrome_ = function(c) {
    if (typeof c !== 'object' || c.mandatory || c.optional) {
      return c;
    }
    var cc = {};
    Object.keys(c).forEach(function(key) {
      if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
        return;
      }
      var r = (typeof c[key] === 'object') ? c[key] : {ideal: c[key]};
      if (r.exact !== undefined && typeof r.exact === 'number') {
        r.min = r.max = r.exact;
      }
      var oldname_ = function(prefix, name) {
        if (prefix) {
          return prefix + name.charAt(0).toUpperCase() + name.slice(1);
        }
        return (name === 'deviceId') ? 'sourceId' : name;
      };
      if (r.ideal !== undefined) {
        cc.optional = cc.optional || [];
        var oc = {};
        if (typeof r.ideal === 'number') {
          oc[oldname_('min', key)] = r.ideal;
          cc.optional.push(oc);
          oc = {};
          oc[oldname_('max', key)] = r.ideal;
          cc.optional.push(oc);
        } else {
          oc[oldname_('', key)] = r.ideal;
          cc.optional.push(oc);
        }
      }
      if (r.exact !== undefined && typeof r.exact !== 'number') {
        cc.mandatory = cc.mandatory || {};
        cc.mandatory[oldname_('', key)] = r.exact;
      } else {
        ['min', 'max'].forEach(function(mix) {
          if (r[mix] !== undefined) {
            cc.mandatory = cc.mandatory || {};
            cc.mandatory[oldname_(mix, key)] = r[mix];
          }
        });
      }
    });
    if (c.advanced) {
      cc.optional = (cc.optional || []).concat(c.advanced);
    }
    return cc;
  };
  var shimConstraints_ = function(constraints, func) {
    if (browserDetails.version >= 61) {
      return func(constraints);
    }
    constraints = JSON.parse(JSON.stringify(constraints));
    if (constraints && typeof constraints.audio === 'object') {
      var remap = function(obj, a, b) {
        if (a in obj && !(b in obj)) {
          obj[b] = obj[a];
          delete obj[a];
        }
      };
      constraints = JSON.parse(JSON.stringify(constraints));
      remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
      remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
      constraints.audio = constraintsToChrome_(constraints.audio);
    }
    if (constraints && typeof constraints.video === 'object') {
      var face = constraints.video.facingMode;
      face = face && ((typeof face === 'object') ? face : {ideal: face});
      var getSupportedFacingModeLies = browserDetails.version < 66;
      if ((face && (face.exact === 'user' || face.exact === 'environment' ||
                    face.ideal === 'user' || face.ideal === 'environment')) &&
          !(navigator.mediaDevices.getSupportedConstraints &&
            navigator.mediaDevices.getSupportedConstraints().facingMode &&
            !getSupportedFacingModeLies)) {
        delete constraints.video.facingMode;
        var matches;
        if (face.exact === 'environment' || face.ideal === 'environment') {
          matches = ['back', 'rear'];
        } else if (face.exact === 'user' || face.ideal === 'user') {
          matches = ['front'];
        }
        if (matches) {
          return navigator.mediaDevices.enumerateDevices()
          .then(function(devices) {
            devices = devices.filter(function(d) {
              return d.kind === 'videoinput';
            });
            var dev = devices.find(function(d) {
              return matches.some(function(match) {
                return d.label.toLowerCase().indexOf(match) !== -1;
              });
            });
            if (!dev && devices.length && matches.indexOf('back') !== -1) {
              dev = devices[devices.length - 1];
            }
            if (dev) {
              constraints.video.deviceId = face.exact ? {exact: dev.deviceId} :
                                                        {ideal: dev.deviceId};
            }
            constraints.video = constraintsToChrome_(constraints.video);
            logging('chrome: ' + JSON.stringify(constraints));
            return func(constraints);
          });
        }
      }
      constraints.video = constraintsToChrome_(constraints.video);
    }
    logging('chrome: ' + JSON.stringify(constraints));
    return func(constraints);
  };
  var shimError_ = function(e) {
    if (browserDetails.version >= 64) {
      return e;
    }
    return {
      name: {
        PermissionDeniedError: 'NotAllowedError',
        PermissionDismissedError: 'NotAllowedError',
        InvalidStateError: 'NotAllowedError',
        DevicesNotFoundError: 'NotFoundError',
        ConstraintNotSatisfiedError: 'OverconstrainedError',
        TrackStartError: 'NotReadableError',
        MediaDeviceFailedDueToShutdown: 'NotAllowedError',
        MediaDeviceKillSwitchOn: 'NotAllowedError',
        TabCaptureError: 'AbortError',
        ScreenCaptureError: 'AbortError',
        DeviceCaptureError: 'AbortError'
      }[e.name] || e.name,
      message: e.message,
      constraint: e.constraint || e.constraintName,
      toString: function() {
        return this.name + (this.message && ': ') + this.message;
      }
    };
  };
  var getUserMedia_ = function(constraints, onSuccess, onError) {
    shimConstraints_(constraints, function(c) {
      navigator.webkitGetUserMedia(c, onSuccess, function(e) {
        if (onError) {
          onError(shimError_(e));
        }
      });
    });
  };
  navigator.getUserMedia = getUserMedia_;
  var getUserMediaPromise_ = function(constraints) {
    return new Promise(function(resolve, reject) {
      navigator.getUserMedia(constraints, resolve, reject);
    });
  };
  if (!navigator.mediaDevices) {
    navigator.mediaDevices = {
      getUserMedia: getUserMediaPromise_,
      enumerateDevices: function() {
        return new Promise(function(resolve) {
          var kinds = {audio: 'audioinput', video: 'videoinput'};
          return window.MediaStreamTrack.getSources(function(devices) {
            resolve(devices.map(function(device) {
              return {label: device.label,
                kind: kinds[device.kind],
                deviceId: device.id,
                groupId: ''};
            }));
          });
        });
      },
      getSupportedConstraints: function() {
        return {
          deviceId: true, echoCancellation: true, facingMode: true,
          frameRate: true, height: true, width: true
        };
      }
    };
  }
  if (!navigator.mediaDevices.getUserMedia) {
    navigator.mediaDevices.getUserMedia = function(constraints) {
      return getUserMediaPromise_(constraints);
    };
  } else {
    var origGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(cs) {
      return shimConstraints_(cs, function(c) {
        return origGetUserMedia(c).then(function(stream) {
          if (c.audio && !stream.getAudioTracks().length ||
              c.video && !stream.getVideoTracks().length) {
            stream.getTracks().forEach(function(track) {
              track.stop();
            });
            throw new DOMException('', 'NotFoundError');
          }
          return stream;
        }, function(e) {
          return Promise.reject(shimError_(e));
        });
      });
    };
  }
  if (typeof navigator.mediaDevices.addEventListener === 'undefined') {
    navigator.mediaDevices.addEventListener = function() {
      logging('Dummy mediaDevices.addEventListener called.');
    };
  }
  if (typeof navigator.mediaDevices.removeEventListener === 'undefined') {
    navigator.mediaDevices.removeEventListener = function() {
      logging('Dummy mediaDevices.removeEventListener called.');
    };
  }
};
},{"../utils.js":11}],7:[function(require,module,exports){
var SDPUtils = require('sdp');
var utils = require('./utils');
module.exports = {
  shimRTCIceCandidate: function(window) {
    if (!window.RTCIceCandidate || (window.RTCIceCandidate && 'foundation' in
        window.RTCIceCandidate.prototype)) {
      return;
    }
    var NativeRTCIceCandidate = window.RTCIceCandidate;
    window.RTCIceCandidate = function(args) {
      if (typeof args === 'object' && args.candidate &&
          args.candidate.indexOf('a=') === 0) {
        args = JSON.parse(JSON.stringify(args));
        args.candidate = args.candidate.substr(2);
      }
      if (args.candidate && args.candidate.length) {
        var nativeCandidate = new NativeRTCIceCandidate(args);
        var parsedCandidate = SDPUtils.parseCandidate(args.candidate);
        var augmentedCandidate = Object.assign(nativeCandidate,
            parsedCandidate);
        augmentedCandidate.toJSON = function() {
          return {
            candidate: augmentedCandidate.candidate,
            sdpMid: augmentedCandidate.sdpMid,
            sdpMLineIndex: augmentedCandidate.sdpMLineIndex,
            usernameFragment: augmentedCandidate.usernameFragment,
          };
        };
        return augmentedCandidate;
      }
      return new NativeRTCIceCandidate(args);
    };
    window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;
    utils.wrapPeerConnectionEvent(window, 'icecandidate', function(e) {
      if (e.candidate) {
        Object.defineProperty(e, 'candidate', {
          value: new window.RTCIceCandidate(e.candidate),
          writable: 'false'
        });
      }
      return e;
    });
  },
  shimCreateObjectURL: function(window) {
    var URL = window && window.URL;
    if (!(typeof window === 'object' && window.HTMLMediaElement &&
          'srcObject' in window.HTMLMediaElement.prototype &&
        URL.createObjectURL && URL.revokeObjectURL)) {
      return undefined;
    }
    var nativeCreateObjectURL = URL.createObjectURL.bind(URL);
    var nativeRevokeObjectURL = URL.revokeObjectURL.bind(URL);
    var streams = new Map(), newId = 0;
    URL.createObjectURL = function(stream) {
      if ('getTracks' in stream) {
        var url = 'polyblob:' + (++newId);
        streams.set(url, stream);
        utils.deprecated('URL.createObjectURL(stream)',
            'elem.srcObject = stream');
        return url;
      }
      return nativeCreateObjectURL(stream);
    };
    URL.revokeObjectURL = function(url) {
      nativeRevokeObjectURL(url);
      streams.delete(url);
    };
    var dsc = Object.getOwnPropertyDescriptor(window.HTMLMediaElement.prototype,
                                              'src');
    Object.defineProperty(window.HTMLMediaElement.prototype, 'src', {
      get: function() {
        return dsc.get.apply(this);
      },
      set: function(url) {
        this.srcObject = streams.get(url) || null;
        return dsc.set.apply(this, [url]);
      }
    });
    var nativeSetAttribute = window.HTMLMediaElement.prototype.setAttribute;
    window.HTMLMediaElement.prototype.setAttribute = function() {
      if (arguments.length === 2 &&
          ('' + arguments[0]).toLowerCase() === 'src') {
        this.srcObject = streams.get(arguments[1]) || null;
      }
      return nativeSetAttribute.apply(this, arguments);
    };
  },
  shimMaxMessageSize: function(window) {
    if (window.RTCSctpTransport || !window.RTCPeerConnection) {
      return;
    }
    var browserDetails = utils.detectBrowser(window);
    if (!('sctp' in window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'sctp', {
        get: function() {
          return typeof this._sctp === 'undefined' ? null : this._sctp;
        }
      });
    }
    var sctpInDescription = function(description) {
      var sections = SDPUtils.splitSections(description.sdp);
      sections.shift();
      return sections.some(function(mediaSection) {
        var mLine = SDPUtils.parseMLine(mediaSection);
        return mLine && mLine.kind === 'application'
            && mLine.protocol.indexOf('SCTP') !== -1;
      });
    };
    var getRemoteFirefoxVersion = function(description) {
      var match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
      if (match === null || match.length < 2) {
        return -1;
      }
      var version = parseInt(match[1], 10);
      return version !== version ? -1 : version;
    };
    var getCanSendMaxMessageSize = function(remoteIsFirefox) {
      var canSendMaxMessageSize = 65536;
      if (browserDetails.browser === 'firefox') {
        if (browserDetails.version < 57) {
          if (remoteIsFirefox === -1) {
            canSendMaxMessageSize = 16384;
          } else {
            canSendMaxMessageSize = 2147483637;
          }
        } else if (browserDetails.version < 60) {
          canSendMaxMessageSize =
            browserDetails.version === 57 ? 65535 : 65536;
        } else {
          canSendMaxMessageSize = 2147483637;
        }
      }
      return canSendMaxMessageSize;
    };
    var getMaxMessageSize = function(description, remoteIsFirefox) {
      var maxMessageSize = 65536;
      if (browserDetails.browser === 'firefox'
           && browserDetails.version === 57) {
        maxMessageSize = 65535;
      }
      var match = SDPUtils.matchPrefix(description.sdp, 'a=max-message-size:');
      if (match.length > 0) {
        maxMessageSize = parseInt(match[0].substr(19), 10);
      } else if (browserDetails.browser === 'firefox' &&
                  remoteIsFirefox !== -1) {
        maxMessageSize = 2147483637;
      }
      return maxMessageSize;
    };
    var origSetRemoteDescription =
        window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function() {
      var pc = this;
      pc._sctp = null;
      if (sctpInDescription(arguments[0])) {
        var isFirefox = getRemoteFirefoxVersion(arguments[0]);
        var canSendMMS = getCanSendMaxMessageSize(isFirefox);
        var remoteMMS = getMaxMessageSize(arguments[0], isFirefox);
        var maxMessageSize;
        if (canSendMMS === 0 && remoteMMS === 0) {
          maxMessageSize = Number.POSITIVE_INFINITY;
        } else if (canSendMMS === 0 || remoteMMS === 0) {
          maxMessageSize = Math.max(canSendMMS, remoteMMS);
        } else {
          maxMessageSize = Math.min(canSendMMS, remoteMMS);
        }
        var sctp = {};
        Object.defineProperty(sctp, 'maxMessageSize', {
          get: function() {
            return maxMessageSize;
          }
        });
        pc._sctp = sctp;
      }
      return origSetRemoteDescription.apply(pc, arguments);
    };
  },
  shimSendThrowTypeError: function(window) {
    if (!(window.RTCPeerConnection &&
        'createDataChannel' in window.RTCPeerConnection.prototype)) {
      return;
    }
    function wrapDcSend(dc, pc) {
      var origDataChannelSend = dc.send;
      dc.send = function() {
        var data = arguments[0];
        var length = data.length || data.size || data.byteLength;
        if (dc.readyState === 'open' &&
            pc.sctp && length > pc.sctp.maxMessageSize) {
          throw new TypeError('Message too large (can send a maximum of ' +
            pc.sctp.maxMessageSize + ' bytes)');
        }
        return origDataChannelSend.apply(dc, arguments);
      };
    }
    var origCreateDataChannel =
      window.RTCPeerConnection.prototype.createDataChannel;
    window.RTCPeerConnection.prototype.createDataChannel = function() {
      var pc = this;
      var dataChannel = origCreateDataChannel.apply(pc, arguments);
      wrapDcSend(dataChannel, pc);
      return dataChannel;
    };
    utils.wrapPeerConnectionEvent(window, 'datachannel', function(e) {
      wrapDcSend(e.channel, e.target);
      return e;
    });
  }
};
},{"./utils":11,"sdp":2}],8:[function(require,module,exports){
var utils = require('../utils');
module.exports = {
  shimGetUserMedia: require('./getusermedia'),
  shimOnTrack: function(window) {
    if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in
        window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
        get: function() {
          return this._ontrack;
        },
        set: function(f) {
          if (this._ontrack) {
            this.removeEventListener('track', this._ontrack);
            this.removeEventListener('addstream', this._ontrackpoly);
          }
          this.addEventListener('track', this._ontrack = f);
          this.addEventListener('addstream', this._ontrackpoly = function(e) {
            e.stream.getTracks().forEach(function(track) {
              var event = new Event('track');
              event.track = track;
              event.receiver = {track: track};
              event.transceiver = {receiver: event.receiver};
              event.streams = [e.stream];
              this.dispatchEvent(event);
            }.bind(this));
          }.bind(this));
        },
        enumerable: true,
        configurable: true
      });
    }
    if (typeof window === 'object' && window.RTCTrackEvent &&
        ('receiver' in window.RTCTrackEvent.prototype) &&
        !('transceiver' in window.RTCTrackEvent.prototype)) {
      Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
        get: function() {
          return {receiver: this.receiver};
        }
      });
    }
  },
  shimSourceObject: function(window) {
    if (typeof window === 'object') {
      if (window.HTMLMediaElement &&
        !('srcObject' in window.HTMLMediaElement.prototype)) {
        Object.defineProperty(window.HTMLMediaElement.prototype, 'srcObject', {
          get: function() {
            return this.mozSrcObject;
          },
          set: function(stream) {
            this.mozSrcObject = stream;
          }
        });
      }
    }
  },
  shimPeerConnection: function(window) {
    var browserDetails = utils.detectBrowser(window);
    if (typeof window !== 'object' || !(window.RTCPeerConnection ||
        window.mozRTCPeerConnection)) {
      return;
    }
    if (!window.RTCPeerConnection) {
      window.RTCPeerConnection = function(pcConfig, pcConstraints) {
        if (browserDetails.version < 38) {
          if (pcConfig && pcConfig.iceServers) {
            var newIceServers = [];
            for (var i = 0; i < pcConfig.iceServers.length; i++) {
              var server = pcConfig.iceServers[i];
              if (server.hasOwnProperty('urls')) {
                for (var j = 0; j < server.urls.length; j++) {
                  var newServer = {
                    url: server.urls[j]
                  };
                  if (server.urls[j].indexOf('turn') === 0) {
                    newServer.username = server.username;
                    newServer.credential = server.credential;
                  }
                  newIceServers.push(newServer);
                }
              } else {
                newIceServers.push(pcConfig.iceServers[i]);
              }
            }
            pcConfig.iceServers = newIceServers;
          }
        }
        return new window.mozRTCPeerConnection(pcConfig, pcConstraints);
      };
      window.RTCPeerConnection.prototype =
          window.mozRTCPeerConnection.prototype;
      if (window.mozRTCPeerConnection.generateCertificate) {
        Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
          get: function() {
            return window.mozRTCPeerConnection.generateCertificate;
          }
        });
      }
      window.RTCSessionDescription = window.mozRTCSessionDescription;
      window.RTCIceCandidate = window.mozRTCIceCandidate;
    }
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
        .forEach(function(method) {
          var nativeMethod = window.RTCPeerConnection.prototype[method];
          window.RTCPeerConnection.prototype[method] = function() {
            arguments[0] = new ((method === 'addIceCandidate') ?
                window.RTCIceCandidate :
                window.RTCSessionDescription)(arguments[0]);
            return nativeMethod.apply(this, arguments);
          };
        });
    var nativeAddIceCandidate =
        window.RTCPeerConnection.prototype.addIceCandidate;
    window.RTCPeerConnection.prototype.addIceCandidate = function() {
      if (!arguments[0]) {
        if (arguments[1]) {
          arguments[1].apply(null);
        }
        return Promise.resolve();
      }
      return nativeAddIceCandidate.apply(this, arguments);
    };
    var makeMapStats = function(stats) {
      var map$$1 = new Map();
      Object.keys(stats).forEach(function(key) {
        map$$1.set(key, stats[key]);
        map$$1[key] = stats[key];
      });
      return map$$1;
    };
    var modernStatsTypes = {
      inboundrtp: 'inbound-rtp',
      outboundrtp: 'outbound-rtp',
      candidatepair: 'candidate-pair',
      localcandidate: 'local-candidate',
      remotecandidate: 'remote-candidate'
    };
    var nativeGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function(
      selector,
      onSucc,
      onErr
    ) {
      return nativeGetStats.apply(this, [selector || null])
        .then(function(stats) {
          if (browserDetails.version < 48) {
            stats = makeMapStats(stats);
          }
          if (browserDetails.version < 53 && !onSucc) {
            try {
              stats.forEach(function(stat) {
                stat.type = modernStatsTypes[stat.type] || stat.type;
              });
            } catch (e) {
              if (e.name !== 'TypeError') {
                throw e;
              }
              stats.forEach(function(stat, i) {
                stats.set(i, Object.assign({}, stat, {
                  type: modernStatsTypes[stat.type] || stat.type
                }));
              });
            }
          }
          return stats;
        })
        .then(onSucc, onErr);
    };
  },
  shimSenderGetStats: function(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection &&
        window.RTCRtpSender)) {
      return;
    }
    if (window.RTCRtpSender && 'getStats' in window.RTCRtpSender.prototype) {
      return;
    }
    var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) {
      window.RTCPeerConnection.prototype.getSenders = function() {
        var pc = this;
        var senders = origGetSenders.apply(pc, []);
        senders.forEach(function(sender) {
          sender._pc = pc;
        });
        return senders;
      };
    }
    var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) {
      window.RTCPeerConnection.prototype.addTrack = function() {
        var sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
      };
    }
    window.RTCRtpSender.prototype.getStats = function() {
      return this.track ? this._pc.getStats(this.track) :
          Promise.resolve(new Map());
    };
  },
  shimReceiverGetStats: function(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection &&
        window.RTCRtpSender)) {
      return;
    }
    if (window.RTCRtpSender && 'getStats' in window.RTCRtpReceiver.prototype) {
      return;
    }
    var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) {
      window.RTCPeerConnection.prototype.getReceivers = function() {
        var pc = this;
        var receivers = origGetReceivers.apply(pc, []);
        receivers.forEach(function(receiver) {
          receiver._pc = pc;
        });
        return receivers;
      };
    }
    utils.wrapPeerConnectionEvent(window, 'track', function(e) {
      e.receiver._pc = e.srcElement;
      return e;
    });
    window.RTCRtpReceiver.prototype.getStats = function() {
      return this._pc.getStats(this.track);
    };
  },
  shimRemoveStream: function(window) {
    if (!window.RTCPeerConnection ||
        'removeStream' in window.RTCPeerConnection.prototype) {
      return;
    }
    window.RTCPeerConnection.prototype.removeStream = function(stream) {
      var pc = this;
      utils.deprecated('removeStream', 'removeTrack');
      this.getSenders().forEach(function(sender) {
        if (sender.track && stream.getTracks().indexOf(sender.track) !== -1) {
          pc.removeTrack(sender);
        }
      });
    };
  },
  shimRTCDataChannel: function(window) {
    if (window.DataChannel && !window.RTCDataChannel) {
      window.RTCDataChannel = window.DataChannel;
    }
  },
  shimGetDisplayMedia: function(window, preferredMediaSource) {
    if ('getDisplayMedia' in window.navigator) {
      return;
    }
    navigator.getDisplayMedia = function(constraints) {
      if (!(constraints && constraints.video)) {
        var err = new DOMException('getDisplayMedia without video ' +
            'constraints is undefined');
        err.name = 'NotFoundError';
        err.code = 8;
        return Promise.reject(err);
      }
      if (constraints.video === true) {
        constraints.video = {mediaSource: preferredMediaSource};
      } else {
        constraints.video.mediaSource = preferredMediaSource;
      }
      return navigator.mediaDevices.getUserMedia(constraints);
    };
  }
};
},{"../utils":11,"./getusermedia":9}],9:[function(require,module,exports){
var utils = require('../utils');
var logging = utils.log;
module.exports = function(window) {
  var browserDetails = utils.detectBrowser(window);
  var navigator = window && window.navigator;
  var MediaStreamTrack = window && window.MediaStreamTrack;
  var shimError_ = function(e) {
    return {
      name: {
        InternalError: 'NotReadableError',
        NotSupportedError: 'TypeError',
        PermissionDeniedError: 'NotAllowedError',
        SecurityError: 'NotAllowedError'
      }[e.name] || e.name,
      message: {
        'The operation is insecure.': 'The request is not allowed by the ' +
        'user agent or the platform in the current context.'
      }[e.message] || e.message,
      constraint: e.constraint,
      toString: function() {
        return this.name + (this.message && ': ') + this.message;
      }
    };
  };
  var getUserMedia_ = function(constraints, onSuccess, onError) {
    var constraintsToFF37_ = function(c) {
      if (typeof c !== 'object' || c.require) {
        return c;
      }
      var require = [];
      Object.keys(c).forEach(function(key) {
        if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
          return;
        }
        var r = c[key] = (typeof c[key] === 'object') ?
            c[key] : {ideal: c[key]};
        if (r.min !== undefined ||
            r.max !== undefined || r.exact !== undefined) {
          require.push(key);
        }
        if (r.exact !== undefined) {
          if (typeof r.exact === 'number') {
            r. min = r.max = r.exact;
          } else {
            c[key] = r.exact;
          }
          delete r.exact;
        }
        if (r.ideal !== undefined) {
          c.advanced = c.advanced || [];
          var oc = {};
          if (typeof r.ideal === 'number') {
            oc[key] = {min: r.ideal, max: r.ideal};
          } else {
            oc[key] = r.ideal;
          }
          c.advanced.push(oc);
          delete r.ideal;
          if (!Object.keys(r).length) {
            delete c[key];
          }
        }
      });
      if (require.length) {
        c.require = require;
      }
      return c;
    };
    constraints = JSON.parse(JSON.stringify(constraints));
    if (browserDetails.version < 38) {
      logging('spec: ' + JSON.stringify(constraints));
      if (constraints.audio) {
        constraints.audio = constraintsToFF37_(constraints.audio);
      }
      if (constraints.video) {
        constraints.video = constraintsToFF37_(constraints.video);
      }
      logging('ff37: ' + JSON.stringify(constraints));
    }
    return navigator.mozGetUserMedia(constraints, onSuccess, function(e) {
      onError(shimError_(e));
    });
  };
  var getUserMediaPromise_ = function(constraints) {
    return new Promise(function(resolve, reject) {
      getUserMedia_(constraints, resolve, reject);
    });
  };
  if (!navigator.mediaDevices) {
    navigator.mediaDevices = {getUserMedia: getUserMediaPromise_,
      addEventListener: function() { },
      removeEventListener: function() { }
    };
  }
  navigator.mediaDevices.enumerateDevices =
      navigator.mediaDevices.enumerateDevices || function() {
        return new Promise(function(resolve) {
          var infos = [
            {kind: 'audioinput', deviceId: 'default', label: '', groupId: ''},
            {kind: 'videoinput', deviceId: 'default', label: '', groupId: ''}
          ];
          resolve(infos);
        });
      };
  if (browserDetails.version < 41) {
    var orgEnumerateDevices =
        navigator.mediaDevices.enumerateDevices.bind(navigator.mediaDevices);
    navigator.mediaDevices.enumerateDevices = function() {
      return orgEnumerateDevices().then(undefined, function(e) {
        if (e.name === 'NotFoundError') {
          return [];
        }
        throw e;
      });
    };
  }
  if (browserDetails.version < 49) {
    var origGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(c) {
      return origGetUserMedia(c).then(function(stream) {
        if (c.audio && !stream.getAudioTracks().length ||
            c.video && !stream.getVideoTracks().length) {
          stream.getTracks().forEach(function(track) {
            track.stop();
          });
          throw new DOMException('The object can not be found here.',
                                 'NotFoundError');
        }
        return stream;
      }, function(e) {
        return Promise.reject(shimError_(e));
      });
    };
  }
  if (!(browserDetails.version > 55 &&
      'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
    var remap = function(obj, a, b) {
      if (a in obj && !(b in obj)) {
        obj[b] = obj[a];
        delete obj[a];
      }
    };
    var nativeGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(c) {
      if (typeof c === 'object' && typeof c.audio === 'object') {
        c = JSON.parse(JSON.stringify(c));
        remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
        remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
      }
      return nativeGetUserMedia(c);
    };
    if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
      var nativeGetSettings = MediaStreamTrack.prototype.getSettings;
      MediaStreamTrack.prototype.getSettings = function() {
        var obj = nativeGetSettings.apply(this, arguments);
        remap(obj, 'mozAutoGainControl', 'autoGainControl');
        remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
        return obj;
      };
    }
    if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
      var nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
      MediaStreamTrack.prototype.applyConstraints = function(c) {
        if (this.kind === 'audio' && typeof c === 'object') {
          c = JSON.parse(JSON.stringify(c));
          remap(c, 'autoGainControl', 'mozAutoGainControl');
          remap(c, 'noiseSuppression', 'mozNoiseSuppression');
        }
        return nativeApplyConstraints.apply(this, [c]);
      };
    }
  }
  navigator.getUserMedia = function(constraints, onSuccess, onError) {
    if (browserDetails.version < 44) {
      return getUserMedia_(constraints, onSuccess, onError);
    }
    utils.deprecated('navigator.getUserMedia',
        'navigator.mediaDevices.getUserMedia');
    navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
  };
};
},{"../utils":11}],10:[function(require,module,exports){
var utils = require('../utils');
module.exports = {
  shimLocalStreamsAPI: function(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) {
      return;
    }
    if (!('getLocalStreams' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.getLocalStreams = function() {
        if (!this._localStreams) {
          this._localStreams = [];
        }
        return this._localStreams;
      };
    }
    if (!('getStreamById' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.getStreamById = function(id) {
        var result = null;
        if (this._localStreams) {
          this._localStreams.forEach(function(stream) {
            if (stream.id === id) {
              result = stream;
            }
          });
        }
        if (this._remoteStreams) {
          this._remoteStreams.forEach(function(stream) {
            if (stream.id === id) {
              result = stream;
            }
          });
        }
        return result;
      };
    }
    if (!('addStream' in window.RTCPeerConnection.prototype)) {
      var _addTrack = window.RTCPeerConnection.prototype.addTrack;
      window.RTCPeerConnection.prototype.addStream = function(stream) {
        if (!this._localStreams) {
          this._localStreams = [];
        }
        if (this._localStreams.indexOf(stream) === -1) {
          this._localStreams.push(stream);
        }
        var pc = this;
        stream.getTracks().forEach(function(track) {
          _addTrack.call(pc, track, stream);
        });
      };
      window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
        if (stream) {
          if (!this._localStreams) {
            this._localStreams = [stream];
          } else if (this._localStreams.indexOf(stream) === -1) {
            this._localStreams.push(stream);
          }
        }
        return _addTrack.call(this, track, stream);
      };
    }
    if (!('removeStream' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.removeStream = function(stream) {
        if (!this._localStreams) {
          this._localStreams = [];
        }
        var index = this._localStreams.indexOf(stream);
        if (index === -1) {
          return;
        }
        this._localStreams.splice(index, 1);
        var pc = this;
        var tracks = stream.getTracks();
        this.getSenders().forEach(function(sender) {
          if (tracks.indexOf(sender.track) !== -1) {
            pc.removeTrack(sender);
          }
        });
      };
    }
  },
  shimRemoteStreamsAPI: function(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) {
      return;
    }
    if (!('getRemoteStreams' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.getRemoteStreams = function() {
        return this._remoteStreams ? this._remoteStreams : [];
      };
    }
    if (!('onaddstream' in window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'onaddstream', {
        get: function() {
          return this._onaddstream;
        },
        set: function(f) {
          if (this._onaddstream) {
            this.removeEventListener('addstream', this._onaddstream);
          }
          this.addEventListener('addstream', this._onaddstream = f);
        }
      });
      var origSetRemoteDescription =
          window.RTCPeerConnection.prototype.setRemoteDescription;
      window.RTCPeerConnection.prototype.setRemoteDescription = function() {
        var pc = this;
        if (!this._onaddstreampoly) {
          this.addEventListener('track', this._onaddstreampoly = function(e) {
            e.streams.forEach(function(stream) {
              if (!pc._remoteStreams) {
                pc._remoteStreams = [];
              }
              if (pc._remoteStreams.indexOf(stream) >= 0) {
                return;
              }
              pc._remoteStreams.push(stream);
              var event = new Event('addstream');
              event.stream = stream;
              pc.dispatchEvent(event);
            });
          });
        }
        return origSetRemoteDescription.apply(pc, arguments);
      };
    }
  },
  shimCallbacksAPI: function(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) {
      return;
    }
    var prototype = window.RTCPeerConnection.prototype;
    var createOffer = prototype.createOffer;
    var createAnswer = prototype.createAnswer;
    var setLocalDescription = prototype.setLocalDescription;
    var setRemoteDescription = prototype.setRemoteDescription;
    var addIceCandidate = prototype.addIceCandidate;
    prototype.createOffer = function(successCallback, failureCallback) {
      var options = (arguments.length >= 2) ? arguments[2] : arguments[0];
      var promise = createOffer.apply(this, [options]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };
    prototype.createAnswer = function(successCallback, failureCallback) {
      var options = (arguments.length >= 2) ? arguments[2] : arguments[0];
      var promise = createAnswer.apply(this, [options]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };
    var withCallback = function(description, successCallback, failureCallback) {
      var promise = setLocalDescription.apply(this, [description]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };
    prototype.setLocalDescription = withCallback;
    withCallback = function(description, successCallback, failureCallback) {
      var promise = setRemoteDescription.apply(this, [description]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };
    prototype.setRemoteDescription = withCallback;
    withCallback = function(candidate, successCallback, failureCallback) {
      var promise = addIceCandidate.apply(this, [candidate]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };
    prototype.addIceCandidate = withCallback;
  },
  shimGetUserMedia: function(window) {
    var navigator = window && window.navigator;
    if (!navigator.getUserMedia) {
      if (navigator.webkitGetUserMedia) {
        navigator.getUserMedia = navigator.webkitGetUserMedia.bind(navigator);
      } else if (navigator.mediaDevices &&
          navigator.mediaDevices.getUserMedia) {
        navigator.getUserMedia = function(constraints, cb, errcb) {
          navigator.mediaDevices.getUserMedia(constraints)
          .then(cb, errcb);
        }.bind(navigator);
      }
    }
  },
  shimRTCIceServerUrls: function(window) {
    var OrigPeerConnection = window.RTCPeerConnection;
    window.RTCPeerConnection = function(pcConfig, pcConstraints) {
      if (pcConfig && pcConfig.iceServers) {
        var newIceServers = [];
        for (var i = 0; i < pcConfig.iceServers.length; i++) {
          var server = pcConfig.iceServers[i];
          if (!server.hasOwnProperty('urls') &&
              server.hasOwnProperty('url')) {
            utils.deprecated('RTCIceServer.url', 'RTCIceServer.urls');
            server = JSON.parse(JSON.stringify(server));
            server.urls = server.url;
            delete server.url;
            newIceServers.push(server);
          } else {
            newIceServers.push(pcConfig.iceServers[i]);
          }
        }
        pcConfig.iceServers = newIceServers;
      }
      return new OrigPeerConnection(pcConfig, pcConstraints);
    };
    window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
    if ('generateCertificate' in window.RTCPeerConnection) {
      Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
        get: function() {
          return OrigPeerConnection.generateCertificate;
        }
      });
    }
  },
  shimTrackEventTransceiver: function(window) {
    if (typeof window === 'object' && window.RTCPeerConnection &&
        ('receiver' in window.RTCTrackEvent.prototype) &&
        !window.RTCTransceiver) {
      Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
        get: function() {
          return {receiver: this.receiver};
        }
      });
    }
  },
  shimCreateOfferLegacy: function(window) {
    var origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function(offerOptions) {
      var pc = this;
      if (offerOptions) {
        if (typeof offerOptions.offerToReceiveAudio !== 'undefined') {
          offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
        }
        var audioTransceiver = pc.getTransceivers().find(function(transceiver) {
          return transceiver.sender.track &&
              transceiver.sender.track.kind === 'audio';
        });
        if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
          if (audioTransceiver.direction === 'sendrecv') {
            if (audioTransceiver.setDirection) {
              audioTransceiver.setDirection('sendonly');
            } else {
              audioTransceiver.direction = 'sendonly';
            }
          } else if (audioTransceiver.direction === 'recvonly') {
            if (audioTransceiver.setDirection) {
              audioTransceiver.setDirection('inactive');
            } else {
              audioTransceiver.direction = 'inactive';
            }
          }
        } else if (offerOptions.offerToReceiveAudio === true &&
            !audioTransceiver) {
          pc.addTransceiver('audio');
        }
        if (typeof offerOptions.offerToReceiveVideo !== 'undefined') {
          offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
        }
        var videoTransceiver = pc.getTransceivers().find(function(transceiver) {
          return transceiver.sender.track &&
              transceiver.sender.track.kind === 'video';
        });
        if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
          if (videoTransceiver.direction === 'sendrecv') {
            videoTransceiver.setDirection('sendonly');
          } else if (videoTransceiver.direction === 'recvonly') {
            videoTransceiver.setDirection('inactive');
          }
        } else if (offerOptions.offerToReceiveVideo === true &&
            !videoTransceiver) {
          pc.addTransceiver('video');
        }
      }
      return origCreateOffer.apply(pc, arguments);
    };
  }
};
},{"../utils":11}],11:[function(require,module,exports){
var logDisabled_ = true;
var deprecationWarnings_ = true;
function extractVersion(uastring, expr, pos) {
  var match = uastring.match(expr);
  return match && match.length >= pos && parseInt(match[pos], 10);
}
function wrapPeerConnectionEvent(window, eventNameToWrap, wrapper) {
  if (!window.RTCPeerConnection) {
    return;
  }
  var proto = window.RTCPeerConnection.prototype;
  var nativeAddEventListener = proto.addEventListener;
  proto.addEventListener = function(nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap) {
      return nativeAddEventListener.apply(this, arguments);
    }
    var wrappedCallback = function(e) {
      var modifiedEvent = wrapper(e);
      if (modifiedEvent) {
        cb(modifiedEvent);
      }
    };
    this._eventMap = this._eventMap || {};
    this._eventMap[cb] = wrappedCallback;
    return nativeAddEventListener.apply(this, [nativeEventName,
      wrappedCallback]);
  };
  var nativeRemoveEventListener = proto.removeEventListener;
  proto.removeEventListener = function(nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap || !this._eventMap
        || !this._eventMap[cb]) {
      return nativeRemoveEventListener.apply(this, arguments);
    }
    var unwrappedCb = this._eventMap[cb];
    delete this._eventMap[cb];
    return nativeRemoveEventListener.apply(this, [nativeEventName,
      unwrappedCb]);
  };
  Object.defineProperty(proto, 'on' + eventNameToWrap, {
    get: function() {
      return this['_on' + eventNameToWrap];
    },
    set: function(cb) {
      if (this['_on' + eventNameToWrap]) {
        this.removeEventListener(eventNameToWrap,
            this['_on' + eventNameToWrap]);
        delete this['_on' + eventNameToWrap];
      }
      if (cb) {
        this.addEventListener(eventNameToWrap,
            this['_on' + eventNameToWrap] = cb);
      }
    },
    enumerable: true,
    configurable: true
  });
}
module.exports = {
  extractVersion: extractVersion,
  wrapPeerConnectionEvent: wrapPeerConnectionEvent,
  disableLog: function(bool) {
    if (typeof bool !== 'boolean') {
      return new Error('Argument type: ' + typeof bool +
          '. Please use a boolean.');
    }
    logDisabled_ = bool;
    return (bool) ? 'adapter.js logging disabled' :
        'adapter.js logging enabled';
  },
  disableWarnings: function(bool) {
    if (typeof bool !== 'boolean') {
      return new Error('Argument type: ' + typeof bool +
          '. Please use a boolean.');
    }
    deprecationWarnings_ = !bool;
    return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
  },
  log: function() {
    if (typeof window === 'object') {
      if (logDisabled_) {
        return;
      }
      if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.log.apply(console, arguments);
      }
    }
  },
  deprecated: function(oldMethod, newMethod) {
    if (!deprecationWarnings_) {
      return;
    }
    console.warn(oldMethod + ' is deprecated, please use ' + newMethod +
        ' instead.');
  },
  detectBrowser: function(window) {
    var navigator = window && window.navigator;
    var result = {};
    result.browser = null;
    result.version = null;
    if (typeof window === 'undefined' || !window.navigator) {
      result.browser = 'Not a browser.';
      return result;
    }
    if (navigator.mozGetUserMedia) {
      result.browser = 'firefox';
      result.version = extractVersion(navigator.userAgent,
          /Firefox\/(\d+)\./, 1);
    } else if (navigator.webkitGetUserMedia) {
      result.browser = 'chrome';
      result.version = extractVersion(navigator.userAgent,
          /Chrom(e|ium)\/(\d+)\./, 2);
    } else if (navigator.mediaDevices &&
        navigator.userAgent.match(/Edge\/(\d+).(\d+)$/)) {
      result.browser = 'edge';
      result.version = extractVersion(navigator.userAgent,
          /Edge\/(\d+).(\d+)$/, 2);
    } else if (window.RTCPeerConnection &&
        navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
      result.browser = 'safari';
      result.version = extractVersion(navigator.userAgent,
          /AppleWebKit\/(\d+)\./, 1);
    } else {
      result.browser = 'Not a supported browser.';
      return result;
    }
    return result;
  }
};
},{}]},{},[3]);

var env = {};

env.RTCPeerConnection = window.RTCPeerConnection;
env.RTCIceCandidate = window.RTCIceCandidate;
env.WebSocket = window.WebSocket;
env.TextEncoder = window.TextEncoder;
env.TextDecoder = window.TextDecoder;
env.crypto = window.crypto;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var netfluxCSS = 'background-color: #FFCA28; padding: 0 3px';
var debugCSS = 'background-color: #b3ba2e; padding: 0 3px';
var webrtcCSS = 'background-color: #CE93D8; padding: 0 3px';
var channelCSS = 'background-color: #90CAF9; padding: 0 3px';
var topologyCSS = 'background-color: #26A69A; padding: 0 3px';
var signalingCSS = 'background-color: #66BB6A; padding: 0 3px';
var channelBuilderCSS = 'background-color: #F57C00; padding: 0 3px';
var signalingStateCSS = 'background-color: #9FA8DA; padding: 0 2px';
var webGroupStateCSS = 'background-color: #EF9A9A; padding: 0 2px';
var warningeCSS = 'background-color: #FF5252; padding: 0 2px';
var log = {
    webgroup: function () { },
    signalingState: function () { },
    webGroupState: function () { },
    webrtc: function () { },
    channel: function () { },
    topology: function () { },
    signaling: function () { },
    channelBuilder: function () { },
    debug: function () { },
    warn: function () { },
};
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["WEB_GROUP"] = 1] = "WEB_GROUP";
    LogLevel[LogLevel["WEBRTC"] = 2] = "WEBRTC";
    LogLevel[LogLevel["CHANNEL"] = 3] = "CHANNEL";
    LogLevel[LogLevel["TOPOLOGY"] = 4] = "TOPOLOGY";
    LogLevel[LogLevel["SIGNALING"] = 5] = "SIGNALING";
    LogLevel[LogLevel["CHANNEL_BUILDER"] = 6] = "CHANNEL_BUILDER";
})(LogLevel || (LogLevel = {}));
var logLevels = [];
function setLogLevel() {
    var levels = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        levels[_i] = arguments[_i];
    }
    logLevels = levels;
    if (logLevels.includes(LogLevel.WEB_GROUP)) {
        log.webgroup = function (msg) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            if (rest.length === 0) {
                console.info("%cNETFLUX WebGroup%c: " + msg, netfluxCSS, '');
            }
            else {
                console.info.apply(console, __spread(["%cNETFLUX WebGroup%c: " + msg, netfluxCSS, ''], rest));
            }
        };
        log.signalingState = function (msg, id) {
            console.info("%cNETFLUX " + id + " WebGroup%c: Signaling: %c" + msg + "%c", netfluxCSS, '', signalingStateCSS, '');
        };
        log.webGroupState = function (msg, id) {
            console.info("%cNETFLUX " + id + " WebGroup%c: WebGroup: %c" + msg + "%c", netfluxCSS, '', webGroupStateCSS, '');
        };
    }
    else {
        log.webgroup = function () { };
        log.signalingState = function () { };
        log.webGroupState = function () { };
    }
    if (logLevels.includes(LogLevel.WEBRTC)) {
        log.webrtc = function (msg) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            if (rest.length === 0) {
                console.info("%cNETFLUX WebRTC%c: " + msg, webrtcCSS, '');
            }
            else {
                console.info.apply(console, __spread(["%cNETFLUX WebRTC%c: " + msg, webrtcCSS, ''], rest));
            }
        };
    }
    else {
        log.webrtc = function () { };
    }
    if (logLevels.includes(LogLevel.CHANNEL)) {
        log.channel = function (msg) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            if (rest.length === 0) {
                console.info("%cNETFLUX Channel%c: " + msg, channelCSS, '');
            }
            else {
                console.info.apply(console, __spread(["%cNETFLUX Channel%c: " + msg, channelCSS, ''], rest));
            }
        };
    }
    else {
        log.channel = function () { };
    }
    if (logLevels.includes(LogLevel.TOPOLOGY)) {
        log.topology = function (msg) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            if (rest.length === 0) {
                console.info("%cNETFLUX Topology%c: " + msg, topologyCSS, '');
            }
            else {
                console.info.apply(console, __spread(["%cNETFLUX Topology%c: " + msg, topologyCSS, ''], rest));
            }
        };
    }
    else {
        log.topology = function () { };
    }
    if (logLevels.includes(LogLevel.SIGNALING)) {
        log.signaling = function (msg) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            if (rest.length === 0) {
                console.info("%cNETFLUX Signaling%c: " + msg, signalingCSS, '');
            }
            else {
                console.info.apply(console, __spread(["%cNETFLUX Signaling%c: " + msg, signalingCSS, ''], rest));
            }
        };
    }
    else {
        log.signaling = function () { };
    }
    if (logLevels.includes(LogLevel.CHANNEL_BUILDER)) {
        log.channelBuilder = function (msg) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            if (rest.length === 0) {
                console.info("%cNETFLUX ChannelBuilder%c: " + msg, channelBuilderCSS, '');
            }
            else {
                console.info.apply(console, __spread(["%cNETFLUX ChannelBuilder%c: " + msg, channelBuilderCSS, ''], rest));
            }
        };
    }
    else {
        log.channelBuilder = function () { };
    }
    if (logLevels.includes(LogLevel.DEBUG)) {
        log.debug = function (msg) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            if (rest.length === 0) {
                console.info("%cNETFLUX Debug%c: " + msg, debugCSS, '');
            }
            else {
                console.info.apply(console, __spread(["%cNETFLUX Debug%c: " + msg, debugCSS, ''], rest));
            }
        };
    }
    else {
        log.debug = function () { };
    }
    log.warn = function (msg) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        if (rest.length === 0) {
            console.info("%cNETFLUX WARNING%c: " + msg, warningeCSS, '');
        }
        else {
            console.info.apply(console, __spread(["%cNETFLUX WARNING%c: " + msg, warningeCSS, ''], rest));
        }
    };
}

var MIN_ID = 2147483648;
var isBrowser = typeof window === 'undefined' ? false : true;
function isOnline() {
    return isBrowser ? navigator.onLine : true;
}
function isVisible() {
    return isBrowser ? document.visibilityState === 'visible' : true;
}
function validateWebSocketURL(url) {
    var regex = /^(wss|ws):\/\/((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])|(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9]))(:[0-9]{1,5})?(\/.*)?$/;
    if (!new RegExp(regex, 'i').test(url)) {
        throw new Error("Invalid URL: " + url);
    }
}
function generateKey() {
    var mask = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var length = 42;
    var values = randNumbers(length);
    var result = '';
    for (var i = 0; i < length; i++) {
        result += mask[values[i] % mask.length];
    }
    return result;
}
function generateId(exclude) {
    if (exclude === void 0) { exclude = []; }
    var id = randNumbers()[0];
    if (id < MIN_ID) {
        id += MIN_ID;
    }
    if (exclude.includes(id)) {
        return generateId(exclude);
    }
    return id;
}
var MAX_KEY_LENGTH = 512;
function validateKey(key) {
    if (typeof key !== 'string') {
        throw new Error("The key type \"" + typeof key + "\" is not a \"string\"");
    }
    else if (key === '') {
        throw new Error('The key is an empty string');
    }
    else if (key.length > MAX_KEY_LENGTH) {
        throw new Error("The key length of " + key.length + " exceeds the maximum of " + MAX_KEY_LENGTH + " characters");
    }
    return true;
}
function extractHostnameAndPort(url) {
    return url.split('/')[2];
}
function randNumbers(length) {
    if (length === void 0) { length = 1; }
    var res;
    if (isBrowser) {
        res = new Uint32Array(length);
        env.crypto.getRandomValues(res);
    }
    else {
        res = [];
        var bytes = env.cryptoNode.randomBytes(4 * length);
        for (var i = 0; i < bytes.length; i += 4) {
            res[res.length] = bytes.readUInt32BE(i, true);
        }
    }
    return res;
}
function isWebSocketSupported() {
    return !!env.WebSocket;
}
function isWebRTCSupported() {
    return !!env.RTCPeerConnection && 'createDataChannel' in env.RTCPeerConnection.prototype;
}

var Service = (function () {
    function Service(serviceId, proto) {
        this.serviceId = serviceId;
        this.proto = proto;
    }
    Service.prototype.useWebChannelStream = function (wc) {
        var _this = this;
        return {
            id: wc.STREAM_ID,
            message: wc.messageFromStream.pipe(filter(function (_a) {
                var serviceId = _a.serviceId;
                return serviceId === _this.serviceId;
            }), map(function (_a) {
                var channel = _a.channel, senderId = _a.senderId, recipientId = _a.recipientId, content = _a.content;
                return ({
                    channel: channel,
                    senderId: senderId,
                    recipientId: recipientId,
                    msg: _this.decode(content),
                });
            }), filter(function (_a) {
                var msg = _a.msg;
                return msg && msg.type;
            })),
            send: function (content, recipientId) {
                wc.sendOverStream({
                    senderId: wc.myId,
                    recipientId: recipientId,
                    serviceId: _this.serviceId,
                    content: content instanceof Uint8Array ? content : _this.encode(content),
                });
            },
        };
    };
    Service.prototype.useSignalingStream = function (sig) {
        var _this = this;
        return {
            id: sig.STREAM_ID,
            message: sig.messageFromStream.pipe(filter(function (_a) {
                var serviceId = _a.serviceId;
                return serviceId === _this.serviceId;
            }), map(function (_a) {
                var senderId = _a.senderId, recipientId = _a.recipientId, content = _a.content;
                return ({
                    senderId: senderId,
                    recipientId: recipientId,
                    msg: _this.decode(content),
                });
            }), filter(function (_a) {
                var msg = _a.msg;
                return msg && msg.type;
            })),
            send: function (content, recipientId, senderId) {
                sig.sendOverStream({
                    senderId: senderId,
                    recipientId: recipientId,
                    serviceId: _this.serviceId,
                    content: content instanceof Uint8Array ? content : _this.encode(content),
                });
            },
        };
    };
    Service.prototype.useAllStreams = function (wc, sig) {
        var wcStream = this.useWebChannelStream(wc);
        var sigStream = this.useSignalingStream(sig);
        return {
            message: merge(wcStream.message.pipe(map(function (_a) {
                var senderId = _a.senderId, recipientId = _a.recipientId, msg = _a.msg;
                return ({
                    streamId: wcStream.id,
                    senderId: senderId,
                    recipientId: recipientId,
                    msg: msg,
                });
            })), sigStream.message.pipe(map(function (_a) {
                var senderId = _a.senderId, recipientId = _a.recipientId, msg = _a.msg;
                return ({
                    streamId: sigStream.id,
                    senderId: senderId,
                    recipientId: recipientId,
                    msg: msg,
                });
            }))),
            sendOver: function (streamId, msg, recipientId, senderId) {
                if (streamId === wcStream.id) {
                    wcStream.send(msg, recipientId);
                }
                else {
                    sigStream.send(msg, recipientId, senderId);
                }
            },
        };
    };
    Service.prototype.encode = function (msg) {
        return this.proto.encode(this.proto.create(msg)).finish();
    };
    Service.prototype.decode = function (bytes) {
        try {
            return this.proto.decode(bytes);
        }
        catch (err) {
            log.warn('Decode service message error: ', err);
        }
        return { type: undefined };
    };
    return Service;
}());

var TopologyEnum;
(function (TopologyEnum) {
    TopologyEnum[TopologyEnum["FULL_MESH"] = 0] = "FULL_MESH";
})(TopologyEnum || (TopologyEnum = {}));
var TopologyState;
(function (TopologyState) {
    TopologyState[TopologyState["CONSTRUCTING"] = 0] = "CONSTRUCTING";
    TopologyState[TopologyState["CONSTRUCTED"] = 1] = "CONSTRUCTED";
    TopologyState[TopologyState["IDLE"] = 2] = "IDLE";
})(TopologyState || (TopologyState = {}));
var Topology = (function (_super) {
    __extends(Topology, _super);
    function Topology(wc, serviceId, proto) {
        var _this = _super.call(this, serviceId, proto) || this;
        _this.wc = wc;
        _this.wcStream = _super.prototype.useWebChannelStream.call(_this, wc);
        _this.stateSubject = new Subject();
        _this._state = TopologyState.IDLE;
        return _this;
    }
    Object.defineProperty(Topology.prototype, "onState", {
        get: function () {
            return this.stateSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Topology.prototype, "state", {
        get: function () {
            return this._state;
        },
        enumerable: true,
        configurable: true
    });
    Topology.prototype.setJoinedState = function () {
        this.setState(TopologyState.CONSTRUCTED);
    };
    Topology.prototype.setState = function (state) {
        if (this.state !== state) {
            log.topology("Topology state = " + TopologyState[state]);
            this._state = state;
            this.stateSubject.next(state);
        }
    };
    return Topology;
}(Service));

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}
var aspromise = asPromise;
function asPromise(fn, ctx              ) {
    var params  = new Array(arguments.length - 1),
        offset  = 0,
        index   = 2,
        pending = true;
    while (index < arguments.length)
        params[offset++] = arguments[index++];
    return new Promise(function executor(resolve, reject) {
        params[offset] = function callback(err              ) {
            if (pending) {
                pending = false;
                if (err)
                    reject(err);
                else {
                    var params = new Array(arguments.length - 1),
                        offset = 0;
                    while (offset < params.length)
                        params[offset++] = arguments[offset];
                    resolve.apply(null, params);
                }
            }
        };
        try {
            fn.apply(ctx || null, params);
        } catch (err) {
            if (pending) {
                pending = false;
                reject(err);
            }
        }
    });
}
var base64_1 = createCommonjsModule(function (module, exports) {
var base64 = exports;
base64.length = function length(string) {
    var p = string.length;
    if (!p)
        return 0;
    var n = 0;
    while (--p % 4 > 1 && string.charAt(p) === "=")
        ++n;
    return Math.ceil(string.length * 3) / 4 - n;
};
var b64 = new Array(64);
var s64 = new Array(123);
for (var i = 0; i < 64;)
    s64[b64[i] = i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i - 59 | 43] = i++;
base64.encode = function encode(buffer, start, end) {
    var parts = null,
        chunk = [];
    var i = 0,
        j = 0,
        t;
    while (start < end) {
        var b = buffer[start++];
        switch (j) {
            case 0:
                chunk[i++] = b64[b >> 2];
                t = (b & 3) << 4;
                j = 1;
                break;
            case 1:
                chunk[i++] = b64[t | b >> 4];
                t = (b & 15) << 2;
                j = 2;
                break;
            case 2:
                chunk[i++] = b64[t | b >> 6];
                chunk[i++] = b64[b & 63];
                j = 0;
                break;
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (j) {
        chunk[i++] = b64[t];
        chunk[i++] = 61;
        if (j === 1)
            chunk[i++] = 61;
    }
    if (parts) {
        if (i)
            parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
var invalidEncoding = "invalid encoding";
base64.decode = function decode(string, buffer, offset) {
    var start = offset;
    var j = 0,
        t;
    for (var i = 0; i < string.length;) {
        var c = string.charCodeAt(i++);
        if (c === 61 && j > 1)
            break;
        if ((c = s64[c]) === undefined)
            throw Error(invalidEncoding);
        switch (j) {
            case 0:
                t = c;
                j = 1;
                break;
            case 1:
                buffer[offset++] = t << 2 | (c & 48) >> 4;
                t = c;
                j = 2;
                break;
            case 2:
                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
                t = c;
                j = 3;
                break;
            case 3:
                buffer[offset++] = (t & 3) << 6 | c;
                j = 0;
                break;
        }
    }
    if (j === 1)
        throw Error(invalidEncoding);
    return offset - start;
};
base64.test = function test(string) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
};
});
var eventemitter = EventEmitter;
function EventEmitter() {
    this._listeners = {};
}
EventEmitter.prototype.on = function on(evt, fn, ctx) {
    (this._listeners[evt] || (this._listeners[evt] = [])).push({
        fn  : fn,
        ctx : ctx || this
    });
    return this;
};
EventEmitter.prototype.off = function off(evt, fn) {
    if (evt === undefined)
        this._listeners = {};
    else {
        if (fn === undefined)
            this._listeners[evt] = [];
        else {
            var listeners = this._listeners[evt];
            for (var i = 0; i < listeners.length;)
                if (listeners[i].fn === fn)
                    listeners.splice(i, 1);
                else
                    ++i;
        }
    }
    return this;
};
EventEmitter.prototype.emit = function emit(evt) {
    var listeners = this._listeners[evt];
    if (listeners) {
        var args = [],
            i = 1;
        for (; i < arguments.length;)
            args.push(arguments[i++]);
        for (i = 0; i < listeners.length;)
            listeners[i].fn.apply(listeners[i++].ctx, args);
    }
    return this;
};
var float_1 = factory(factory);
function factory(exports) {
    if (typeof Float32Array !== "undefined") (function() {
        var f32 = new Float32Array([ -0 ]),
            f8b = new Uint8Array(f32.buffer),
            le  = f8b[3] === 128;
        function writeFloat_f32_cpy(val, buf, pos) {
            f32[0] = val;
            buf[pos    ] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
        }
        function writeFloat_f32_rev(val, buf, pos) {
            f32[0] = val;
            buf[pos    ] = f8b[3];
            buf[pos + 1] = f8b[2];
            buf[pos + 2] = f8b[1];
            buf[pos + 3] = f8b[0];
        }
        exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
        exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
        function readFloat_f32_cpy(buf, pos) {
            f8b[0] = buf[pos    ];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            return f32[0];
        }
        function readFloat_f32_rev(buf, pos) {
            f8b[3] = buf[pos    ];
            f8b[2] = buf[pos + 1];
            f8b[1] = buf[pos + 2];
            f8b[0] = buf[pos + 3];
            return f32[0];
        }
        exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
        exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
    })(); else (function() {
        function writeFloat_ieee754(writeUint, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign)
                val = -val;
            if (val === 0)
                writeUint(1 / val > 0 ?                0 :                  2147483648, buf, pos);
            else if (isNaN(val))
                writeUint(2143289344, buf, pos);
            else if (val > 3.4028234663852886e+38)
                writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
            else if (val < 1.1754943508222875e-38)
                writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
            else {
                var exponent = Math.floor(Math.log(val) / Math.LN2),
                    mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
            }
        }
        exports.writeFloatLE = writeFloat_ieee754.bind(null, writeUintLE);
        exports.writeFloatBE = writeFloat_ieee754.bind(null, writeUintBE);
        function readFloat_ieee754(readUint, buf, pos) {
            var uint = readUint(buf, pos),
                sign = (uint >> 31) * 2 + 1,
                exponent = uint >>> 23 & 255,
                mantissa = uint & 8388607;
            return exponent === 255
                ? mantissa
                ? NaN
                : sign * Infinity
                : exponent === 0
                ? sign * 1.401298464324817e-45 * mantissa
                : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
        }
        exports.readFloatLE = readFloat_ieee754.bind(null, readUintLE);
        exports.readFloatBE = readFloat_ieee754.bind(null, readUintBE);
    })();
    if (typeof Float64Array !== "undefined") (function() {
        var f64 = new Float64Array([-0]),
            f8b = new Uint8Array(f64.buffer),
            le  = f8b[7] === 128;
        function writeDouble_f64_cpy(val, buf, pos) {
            f64[0] = val;
            buf[pos    ] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
            buf[pos + 4] = f8b[4];
            buf[pos + 5] = f8b[5];
            buf[pos + 6] = f8b[6];
            buf[pos + 7] = f8b[7];
        }
        function writeDouble_f64_rev(val, buf, pos) {
            f64[0] = val;
            buf[pos    ] = f8b[7];
            buf[pos + 1] = f8b[6];
            buf[pos + 2] = f8b[5];
            buf[pos + 3] = f8b[4];
            buf[pos + 4] = f8b[3];
            buf[pos + 5] = f8b[2];
            buf[pos + 6] = f8b[1];
            buf[pos + 7] = f8b[0];
        }
        exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
        exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
        function readDouble_f64_cpy(buf, pos) {
            f8b[0] = buf[pos    ];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            f8b[4] = buf[pos + 4];
            f8b[5] = buf[pos + 5];
            f8b[6] = buf[pos + 6];
            f8b[7] = buf[pos + 7];
            return f64[0];
        }
        function readDouble_f64_rev(buf, pos) {
            f8b[7] = buf[pos    ];
            f8b[6] = buf[pos + 1];
            f8b[5] = buf[pos + 2];
            f8b[4] = buf[pos + 3];
            f8b[3] = buf[pos + 4];
            f8b[2] = buf[pos + 5];
            f8b[1] = buf[pos + 6];
            f8b[0] = buf[pos + 7];
            return f64[0];
        }
        exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
        exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
    })(); else (function() {
        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign)
                val = -val;
            if (val === 0) {
                writeUint(0, buf, pos + off0);
                writeUint(1 / val > 0 ?                0 :                  2147483648, buf, pos + off1);
            } else if (isNaN(val)) {
                writeUint(0, buf, pos + off0);
                writeUint(2146959360, buf, pos + off1);
            } else if (val > 1.7976931348623157e+308) {
                writeUint(0, buf, pos + off0);
                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
            } else {
                var mantissa;
                if (val < 2.2250738585072014e-308) {
                    mantissa = val / 5e-324;
                    writeUint(mantissa >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
                } else {
                    var exponent = Math.floor(Math.log(val) / Math.LN2);
                    if (exponent === 1024)
                        exponent = 1023;
                    mantissa = val * Math.pow(2, -exponent);
                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
                }
            }
        }
        exports.writeDoubleLE = writeDouble_ieee754.bind(null, writeUintLE, 0, 4);
        exports.writeDoubleBE = writeDouble_ieee754.bind(null, writeUintBE, 4, 0);
        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
            var lo = readUint(buf, pos + off0),
                hi = readUint(buf, pos + off1);
            var sign = (hi >> 31) * 2 + 1,
                exponent = hi >>> 20 & 2047,
                mantissa = 4294967296 * (hi & 1048575) + lo;
            return exponent === 2047
                ? mantissa
                ? NaN
                : sign * Infinity
                : exponent === 0
                ? sign * 5e-324 * mantissa
                : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
        }
        exports.readDoubleLE = readDouble_ieee754.bind(null, readUintLE, 0, 4);
        exports.readDoubleBE = readDouble_ieee754.bind(null, readUintBE, 4, 0);
    })();
    return exports;
}
function writeUintLE(val, buf, pos) {
    buf[pos    ] =  val        & 255;
    buf[pos + 1] =  val >>> 8  & 255;
    buf[pos + 2] =  val >>> 16 & 255;
    buf[pos + 3] =  val >>> 24;
}
function writeUintBE(val, buf, pos) {
    buf[pos    ] =  val >>> 24;
    buf[pos + 1] =  val >>> 16 & 255;
    buf[pos + 2] =  val >>> 8  & 255;
    buf[pos + 3] =  val        & 255;
}
function readUintLE(buf, pos) {
    return (buf[pos    ]
          | buf[pos + 1] << 8
          | buf[pos + 2] << 16
          | buf[pos + 3] << 24) >>> 0;
}
function readUintBE(buf, pos) {
    return (buf[pos    ] << 24
          | buf[pos + 1] << 16
          | buf[pos + 2] << 8
          | buf[pos + 3]) >>> 0;
}
var inquire_1 = inquire;
function inquire(moduleName) {
    return null;
}
var utf8_1 = createCommonjsModule(function (module, exports) {
var utf8 = exports;
utf8.length = function utf8_length(string) {
    var len = 0,
        c = 0;
    for (var i = 0; i < string.length; ++i) {
        c = string.charCodeAt(i);
        if (c < 128)
            len += 1;
        else if (c < 2048)
            len += 2;
        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
            ++i;
            len += 4;
        } else
            len += 3;
    }
    return len;
};
utf8.read = function utf8_read(buffer, start, end) {
    var len = end - start;
    if (len < 1)
        return "";
    var parts = null,
        chunk = [],
        i = 0,
        t;
    while (start < end) {
        t = buffer[start++];
        if (t < 128)
            chunk[i++] = t;
        else if (t > 191 && t < 224)
            chunk[i++] = (t & 31) << 6 | buffer[start++] & 63;
        else if (t > 239 && t < 365) {
            t = ((t & 7) << 18 | (buffer[start++] & 63) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63) - 0x10000;
            chunk[i++] = 0xD800 + (t >> 10);
            chunk[i++] = 0xDC00 + (t & 1023);
        } else
            chunk[i++] = (t & 15) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63;
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (parts) {
        if (i)
            parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
utf8.write = function utf8_write(string, buffer, offset) {
    var start = offset,
        c1,
        c2;
    for (var i = 0; i < string.length; ++i) {
        c1 = string.charCodeAt(i);
        if (c1 < 128) {
            buffer[offset++] = c1;
        } else if (c1 < 2048) {
            buffer[offset++] = c1 >> 6       | 192;
            buffer[offset++] = c1       & 63 | 128;
        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
            ++i;
            buffer[offset++] = c1 >> 18      | 240;
            buffer[offset++] = c1 >> 12 & 63 | 128;
            buffer[offset++] = c1 >> 6  & 63 | 128;
            buffer[offset++] = c1       & 63 | 128;
        } else {
            buffer[offset++] = c1 >> 12      | 224;
            buffer[offset++] = c1 >> 6  & 63 | 128;
            buffer[offset++] = c1       & 63 | 128;
        }
    }
    return offset - start;
};
});
var pool_1 = pool;
function pool(alloc, slice, size) {
    var SIZE   = size || 8192;
    var MAX    = SIZE >>> 1;
    var slab   = null;
    var offset = SIZE;
    return function pool_alloc(size) {
        if (size < 1 || size > MAX)
            return alloc(size);
        if (offset + size > SIZE) {
            slab = alloc(SIZE);
            offset = 0;
        }
        var buf = slice.call(slab, offset, offset += size);
        if (offset & 7)
            offset = (offset | 7) + 1;
        return buf;
    };
}
var longbits = LongBits;
function LongBits(lo, hi) {
    this.lo = lo >>> 0;
    this.hi = hi >>> 0;
}
var zero = LongBits.zero = new LongBits(0, 0);
zero.toNumber = function() { return 0; };
zero.zzEncode = zero.zzDecode = function() { return this; };
zero.length = function() { return 1; };
var zeroHash = LongBits.zeroHash = "\0\0\0\0\0\0\0\0";
LongBits.fromNumber = function fromNumber(value) {
    if (value === 0)
        return zero;
    var sign = value < 0;
    if (sign)
        value = -value;
    var lo = value >>> 0,
        hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
        hi = ~hi >>> 0;
        lo = ~lo >>> 0;
        if (++lo > 4294967295) {
            lo = 0;
            if (++hi > 4294967295)
                hi = 0;
        }
    }
    return new LongBits(lo, hi);
};
LongBits.from = function from(value) {
    if (typeof value === "number")
        return LongBits.fromNumber(value);
    if (minimal.isString(value)) {
        if (minimal.Long)
            value = minimal.Long.fromString(value);
        else
            return LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new LongBits(value.low >>> 0, value.high >>> 0) : zero;
};
LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
        var lo = ~this.lo + 1 >>> 0,
            hi = ~this.hi     >>> 0;
        if (!lo)
            hi = hi + 1 >>> 0;
        return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
};
LongBits.prototype.toLong = function toLong(unsigned) {
    return minimal.Long
        ? new minimal.Long(this.lo | 0, this.hi | 0, Boolean(unsigned))
        : { low: this.lo | 0, high: this.hi | 0, unsigned: Boolean(unsigned) };
};
var charCodeAt = String.prototype.charCodeAt;
LongBits.fromHash = function fromHash(hash) {
    if (hash === zeroHash)
        return zero;
    return new LongBits(
        ( charCodeAt.call(hash, 0)
        | charCodeAt.call(hash, 1) << 8
        | charCodeAt.call(hash, 2) << 16
        | charCodeAt.call(hash, 3) << 24) >>> 0
    ,
        ( charCodeAt.call(hash, 4)
        | charCodeAt.call(hash, 5) << 8
        | charCodeAt.call(hash, 6) << 16
        | charCodeAt.call(hash, 7) << 24) >>> 0
    );
};
LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(
        this.lo        & 255,
        this.lo >>> 8  & 255,
        this.lo >>> 16 & 255,
        this.lo >>> 24      ,
        this.hi        & 255,
        this.hi >>> 8  & 255,
        this.hi >>> 16 & 255,
        this.hi >>> 24
    );
};
LongBits.prototype.zzEncode = function zzEncode() {
    var mask =   this.hi >> 31;
    this.hi  = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo  = ( this.lo << 1                   ^ mask) >>> 0;
    return this;
};
LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo  = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi  = ( this.hi >>> 1                  ^ mask) >>> 0;
    return this;
};
LongBits.prototype.length = function length() {
    var part0 =  this.lo,
        part1 = (this.lo >>> 28 | this.hi << 4) >>> 0,
        part2 =  this.hi >>> 24;
    return part2 === 0
         ? part1 === 0
           ? part0 < 16384
             ? part0 < 128 ? 1 : 2
             : part0 < 2097152 ? 3 : 4
           : part1 < 16384
             ? part1 < 128 ? 5 : 6
             : part1 < 2097152 ? 7 : 8
         : part2 < 128 ? 9 : 10;
};
var minimal = createCommonjsModule(function (module, exports) {
var util = exports;
util.asPromise = aspromise;
util.base64 = base64_1;
util.EventEmitter = eventemitter;
util.float = float_1;
util.inquire = inquire_1;
util.utf8 = utf8_1;
util.pool = pool_1;
util.LongBits = longbits;
util.global = typeof window !== "undefined" && window
           || typeof commonjsGlobal !== "undefined" && commonjsGlobal
           || typeof self   !== "undefined" && self
           || commonjsGlobal;
util.emptyArray = Object.freeze ? Object.freeze([]) :                            [];
util.emptyObject = Object.freeze ? Object.freeze({}) :                            {};
util.isNode = Boolean(util.global.process && util.global.process.versions && util.global.process.versions.node);
util.isInteger = Number.isInteger ||                            function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
};
util.isObject = function isObject(value) {
    return value && typeof value === "object";
};
util.isset =
util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && obj.hasOwnProperty(prop))
        return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
};
util.Buffer = (function() {
    try {
        var Buffer = util.inquire("buffer").Buffer;
        return Buffer.prototype.utf8Write ? Buffer :                            null;
    } catch (e) {
        return null;
    }
})();
util._Buffer_from = null;
util._Buffer_allocUnsafe = null;
util.newBuffer = function newBuffer(sizeOrArray) {
    return typeof sizeOrArray === "number"
        ? util.Buffer
            ? util._Buffer_allocUnsafe(sizeOrArray)
            : new util.Array(sizeOrArray)
        : util.Buffer
            ? util._Buffer_from(sizeOrArray)
            : typeof Uint8Array === "undefined"
                ? sizeOrArray
                : new Uint8Array(sizeOrArray);
};
util.Array = typeof Uint8Array !== "undefined" ? Uint8Array                            : Array;
util.Long =                            util.global.dcodeIO &&                            util.global.dcodeIO.Long
         ||                            util.global.Long
         || util.inquire("long");
util.key2Re = /^true|false|0|1$/;
util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
util.longToHash = function longToHash(value) {
    return value
        ? util.LongBits.from(value).toHash()
        : util.LongBits.zeroHash;
};
util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = util.LongBits.fromHash(hash);
    if (util.Long)
        return util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
};
function merge$$1(dst, src, ifNotSet) {
    for (var keys = Object.keys(src), i = 0; i < keys.length; ++i)
        if (dst[keys[i]] === undefined || !ifNotSet)
            dst[keys[i]] = src[keys[i]];
    return dst;
}
util.merge = merge$$1;
util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};
function newError(name) {
    function CustomError(message, properties) {
        if (!(this instanceof CustomError))
            return new CustomError(message, properties);
        Object.defineProperty(this, "message", { get: function() { return message; } });
        if (Error.captureStackTrace)
            Error.captureStackTrace(this, CustomError);
        else
            Object.defineProperty(this, "stack", { value: (new Error()).stack || "" });
        if (properties)
            merge$$1(this, properties);
    }
    (CustomError.prototype = Object.create(Error.prototype)).constructor = CustomError;
    Object.defineProperty(CustomError.prototype, "name", { get: function() { return name; } });
    CustomError.prototype.toString = function toString() {
        return this.name + ": " + this.message;
    };
    return CustomError;
}
util.newError = newError;
util.ProtocolError = newError("ProtocolError");
util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for (var i = 0; i < fieldNames.length; ++i)
        fieldMap[fieldNames[i]] = 1;
    return function() {
        for (var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)
            if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null)
                return keys[i];
    };
};
util.oneOfSetter = function setOneOf(fieldNames) {
    return function(name) {
        for (var i = 0; i < fieldNames.length; ++i)
            if (fieldNames[i] !== name)
                delete this[fieldNames[i]];
    };
};
util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
};
util._configure = function() {
    var Buffer = util.Buffer;
    if (!Buffer) {
        util._Buffer_from = util._Buffer_allocUnsafe = null;
        return;
    }
    util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from ||
        function Buffer_from(value, encoding) {
            return new Buffer(value, encoding);
        };
    util._Buffer_allocUnsafe = Buffer.allocUnsafe ||
        function Buffer_allocUnsafe(size) {
            return new Buffer(size);
        };
};
});
var writer = Writer;
var BufferWriter;
var LongBits$1  = minimal.LongBits,
    base64    = minimal.base64,
    utf8      = minimal.utf8;
function Op(fn, len, val) {
    this.fn = fn;
    this.len = len;
    this.next = undefined;
    this.val = val;
}
function noop() {}
function State(writer) {
    this.head = writer.head;
    this.tail = writer.tail;
    this.len = writer.len;
    this.next = writer.states;
}
function Writer() {
    this.len = 0;
    this.head = new Op(noop, 0, 0);
    this.tail = this.head;
    this.states = null;
}
Writer.create = minimal.Buffer
    ? function create_buffer_setup() {
        return (Writer.create = function create_buffer() {
            return new BufferWriter();
        })();
    }
    : function create_array() {
        return new Writer();
    };
Writer.alloc = function alloc(size) {
    return new minimal.Array(size);
};
if (minimal.Array !== Array)
    Writer.alloc = minimal.pool(Writer.alloc, minimal.Array.prototype.subarray);
Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new Op(fn, len, val);
    this.len += len;
    return this;
};
function writeByte(val, buf, pos) {
    buf[pos] = val & 255;
}
function writeVarint32(val, buf, pos) {
    while (val > 127) {
        buf[pos++] = val & 127 | 128;
        val >>>= 7;
    }
    buf[pos] = val;
}
function VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
}
VarintOp.prototype = Object.create(Op.prototype);
VarintOp.prototype.fn = writeVarint32;
Writer.prototype.uint32 = function write_uint32(value) {
    this.len += (this.tail = this.tail.next = new VarintOp(
        (value = value >>> 0)
                < 128       ? 1
        : value < 16384     ? 2
        : value < 2097152   ? 3
        : value < 268435456 ? 4
        :                     5,
    value)).len;
    return this;
};
Writer.prototype.int32 = function write_int32(value) {
    return value < 0
        ? this._push(writeVarint64, 10, LongBits$1.fromNumber(value))
        : this.uint32(value);
};
Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
};
function writeVarint64(val, buf, pos) {
    while (val.hi) {
        buf[pos++] = val.lo & 127 | 128;
        val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
        val.hi >>>= 7;
    }
    while (val.lo > 127) {
        buf[pos++] = val.lo & 127 | 128;
        val.lo = val.lo >>> 7;
    }
    buf[pos++] = val.lo;
}
Writer.prototype.uint64 = function write_uint64(value) {
    var bits = LongBits$1.from(value);
    return this._push(writeVarint64, bits.length(), bits);
};
Writer.prototype.int64 = Writer.prototype.uint64;
Writer.prototype.sint64 = function write_sint64(value) {
    var bits = LongBits$1.from(value).zzEncode();
    return this._push(writeVarint64, bits.length(), bits);
};
Writer.prototype.bool = function write_bool(value) {
    return this._push(writeByte, 1, value ? 1 : 0);
};
function writeFixed32(val, buf, pos) {
    buf[pos    ] =  val         & 255;
    buf[pos + 1] =  val >>> 8   & 255;
    buf[pos + 2] =  val >>> 16  & 255;
    buf[pos + 3] =  val >>> 24;
}
Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push(writeFixed32, 4, value >>> 0);
};
Writer.prototype.sfixed32 = Writer.prototype.fixed32;
Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = LongBits$1.from(value);
    return this._push(writeFixed32, 4, bits.lo)._push(writeFixed32, 4, bits.hi);
};
Writer.prototype.sfixed64 = Writer.prototype.fixed64;
Writer.prototype.float = function write_float(value) {
    return this._push(minimal.float.writeFloatLE, 4, value);
};
Writer.prototype.double = function write_double(value) {
    return this._push(minimal.float.writeDoubleLE, 8, value);
};
var writeBytes = minimal.Array.prototype.set
    ? function writeBytes_set(val, buf, pos) {
        buf.set(val, pos);
    }
    : function writeBytes_for(val, buf, pos) {
        for (var i = 0; i < val.length; ++i)
            buf[pos + i] = val[i];
    };
Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len)
        return this._push(writeByte, 1, 0);
    if (minimal.isString(value)) {
        var buf = Writer.alloc(len = base64.length(value));
        base64.decode(value, buf, 0);
        value = buf;
    }
    return this.uint32(len)._push(writeBytes, len, value);
};
Writer.prototype.string = function write_string(value) {
    var len = utf8.length(value);
    return len
        ? this.uint32(len)._push(utf8.write, len, value)
        : this._push(writeByte, 1, 0);
};
Writer.prototype.fork = function fork() {
    this.states = new State(this);
    this.head = this.tail = new Op(noop, 0, 0);
    this.len = 0;
    return this;
};
Writer.prototype.reset = function reset() {
    if (this.states) {
        this.head   = this.states.head;
        this.tail   = this.states.tail;
        this.len    = this.states.len;
        this.states = this.states.next;
    } else {
        this.head = this.tail = new Op(noop, 0, 0);
        this.len  = 0;
    }
    return this;
};
Writer.prototype.ldelim = function ldelim() {
    var head = this.head,
        tail = this.tail,
        len  = this.len;
    this.reset().uint32(len);
    if (len) {
        this.tail.next = head.next;
        this.tail = tail;
        this.len += len;
    }
    return this;
};
Writer.prototype.finish = function finish() {
    var head = this.head.next,
        buf  = this.constructor.alloc(this.len),
        pos  = 0;
    while (head) {
        head.fn(head.val, buf, pos);
        pos += head.len;
        head = head.next;
    }
    return buf;
};
Writer._configure = function(BufferWriter_) {
    BufferWriter = BufferWriter_;
};
var writer_buffer = BufferWriter$1;
(BufferWriter$1.prototype = Object.create(writer.prototype)).constructor = BufferWriter$1;
var Buffer = minimal.Buffer;
function BufferWriter$1() {
    writer.call(this);
}
BufferWriter$1.alloc = function alloc_buffer(size) {
    return (BufferWriter$1.alloc = minimal._Buffer_allocUnsafe)(size);
};
var writeBytesBuffer = Buffer && Buffer.prototype instanceof Uint8Array && Buffer.prototype.set.name === "set"
    ? function writeBytesBuffer_set(val, buf, pos) {
        buf.set(val, pos);
    }
    : function writeBytesBuffer_copy(val, buf, pos) {
        if (val.copy)
            val.copy(buf, pos, 0, val.length);
        else for (var i = 0; i < val.length;)
            buf[pos++] = val[i++];
    };
BufferWriter$1.prototype.bytes = function write_bytes_buffer(value) {
    if (minimal.isString(value))
        value = minimal._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len)
        this._push(writeBytesBuffer, len, value);
    return this;
};
function writeStringBuffer(val, buf, pos) {
    if (val.length < 40)
        minimal.utf8.write(val, buf, pos);
    else
        buf.utf8Write(val, pos);
}
BufferWriter$1.prototype.string = function write_string_buffer(value) {
    var len = Buffer.byteLength(value);
    this.uint32(len);
    if (len)
        this._push(writeStringBuffer, len, value);
    return this;
};
var reader = Reader;
var BufferReader;
var LongBits$2  = minimal.LongBits,
    utf8$1      = minimal.utf8;
function indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
}
function Reader(buffer) {
    this.buf = buffer;
    this.pos = 0;
    this.len = buffer.length;
}
var create_array = typeof Uint8Array !== "undefined"
    ? function create_typed_array(buffer) {
        if (buffer instanceof Uint8Array || Array.isArray(buffer))
            return new Reader(buffer);
        throw Error("illegal buffer");
    }
    : function create_array(buffer) {
        if (Array.isArray(buffer))
            return new Reader(buffer);
        throw Error("illegal buffer");
    };
Reader.create = minimal.Buffer
    ? function create_buffer_setup(buffer) {
        return (Reader.create = function create_buffer(buffer) {
            return minimal.Buffer.isBuffer(buffer)
                ? new BufferReader(buffer)
                : create_array(buffer);
        })(buffer);
    }
    : create_array;
Reader.prototype._slice = minimal.Array.prototype.subarray ||                            minimal.Array.prototype.slice;
Reader.prototype.uint32 = (function read_uint32_setup() {
    var value = 4294967295;
    return function read_uint32() {
        value = (         this.buf[this.pos] & 127       ) >>> 0; if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) <<  7) >>> 0; if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0; if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0; if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] &  15) << 28) >>> 0; if (this.buf[this.pos++] < 128) return value;
        if ((this.pos += 5) > this.len) {
            this.pos = this.len;
            throw indexOutOfRange(this, 10);
        }
        return value;
    };
})();
Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
};
Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
};
function readLongVarint() {
    var bits = new LongBits$2(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
        for (; i < 4; ++i) {
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128)
                return bits;
        }
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >>  4) >>> 0;
        if (this.buf[this.pos++] < 128)
            return bits;
        i = 0;
    } else {
        for (; i < 3; ++i) {
            if (this.pos >= this.len)
                throw indexOutOfRange(this);
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128)
                return bits;
        }
        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
        return bits;
    }
    if (this.len - this.pos > 4) {
        for (; i < 5; ++i) {
            bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
            if (this.buf[this.pos++] < 128)
                return bits;
        }
    } else {
        for (; i < 5; ++i) {
            if (this.pos >= this.len)
                throw indexOutOfRange(this);
            bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
            if (this.buf[this.pos++] < 128)
                return bits;
        }
    }
    throw Error("invalid varint encoding");
}
Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
};
function readFixed32_end(buf, end) {
    return (buf[end - 4]
          | buf[end - 3] << 8
          | buf[end - 2] << 16
          | buf[end - 1] << 24) >>> 0;
}
Reader.prototype.fixed32 = function read_fixed32() {
    if (this.pos + 4 > this.len)
        throw indexOutOfRange(this, 4);
    return readFixed32_end(this.buf, this.pos += 4);
};
Reader.prototype.sfixed32 = function read_sfixed32() {
    if (this.pos + 4 > this.len)
        throw indexOutOfRange(this, 4);
    return readFixed32_end(this.buf, this.pos += 4) | 0;
};
function readFixed64(                  ) {
    if (this.pos + 8 > this.len)
        throw indexOutOfRange(this, 8);
    return new LongBits$2(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
}
Reader.prototype.float = function read_float() {
    if (this.pos + 4 > this.len)
        throw indexOutOfRange(this, 4);
    var value = minimal.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
};
Reader.prototype.double = function read_double() {
    if (this.pos + 8 > this.len)
        throw indexOutOfRange(this, 4);
    var value = minimal.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
};
Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(),
        start  = this.pos,
        end    = this.pos + length;
    if (end > this.len)
        throw indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf))
        return this.buf.slice(start, end);
    return start === end
        ? new this.buf.constructor(0)
        : this._slice.call(this.buf, start, end);
};
Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return utf8$1.read(bytes, 0, bytes.length);
};
Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
        if (this.pos + length > this.len)
            throw indexOutOfRange(this, length);
        this.pos += length;
    } else {
        do {
            if (this.pos >= this.len)
                throw indexOutOfRange(this);
        } while (this.buf[this.pos++] & 128);
    }
    return this;
};
Reader.prototype.skipType = function(wireType) {
    switch (wireType) {
        case 0:
            this.skip();
            break;
        case 1:
            this.skip(8);
            break;
        case 2:
            this.skip(this.uint32());
            break;
        case 3:
            while ((wireType = this.uint32() & 7) !== 4) {
                this.skipType(wireType);
            }
            break;
        case 5:
            this.skip(4);
            break;
        default:
            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
};
Reader._configure = function(BufferReader_) {
    BufferReader = BufferReader_;
    var fn = minimal.Long ? "toLong" :                            "toNumber";
    minimal.merge(Reader.prototype, {
        int64: function read_int64() {
            return readLongVarint.call(this)[fn](false);
        },
        uint64: function read_uint64() {
            return readLongVarint.call(this)[fn](true);
        },
        sint64: function read_sint64() {
            return readLongVarint.call(this).zzDecode()[fn](false);
        },
        fixed64: function read_fixed64() {
            return readFixed64.call(this)[fn](true);
        },
        sfixed64: function read_sfixed64() {
            return readFixed64.call(this)[fn](false);
        }
    });
};
var reader_buffer = BufferReader$1;
(BufferReader$1.prototype = Object.create(reader.prototype)).constructor = BufferReader$1;
function BufferReader$1(buffer) {
    reader.call(this, buffer);
}
if (minimal.Buffer)
    BufferReader$1.prototype._slice = minimal.Buffer.prototype.slice;
BufferReader$1.prototype.string = function read_string_buffer() {
    var len = this.uint32();
    return this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len));
};
var service = Service$1;
(Service$1.prototype = Object.create(minimal.EventEmitter.prototype)).constructor = Service$1;
function Service$1(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function")
        throw TypeError("rpcImpl must be a function");
    minimal.EventEmitter.call(this);
    this.rpcImpl = rpcImpl;
    this.requestDelimited = Boolean(requestDelimited);
    this.responseDelimited = Boolean(responseDelimited);
}
Service$1.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request)
        throw TypeError("request must be specified");
    var self = this;
    if (!callback)
        return minimal.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
    if (!self.rpcImpl) {
        setTimeout(function() { callback(Error("already ended")); }, 0);
        return undefined;
    }
    try {
        return self.rpcImpl(
            method,
            requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(),
            function rpcCallback(err, response) {
                if (err) {
                    self.emit("error", err, method);
                    return callback(err);
                }
                if (response === null) {
                    self.end(                 true);
                    return undefined;
                }
                if (!(response instanceof responseCtor)) {
                    try {
                        response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
                    } catch (err) {
                        self.emit("error", err, method);
                        return callback(err);
                    }
                }
                self.emit("data", response, method);
                return callback(null, response);
            }
        );
    } catch (err) {
        self.emit("error", err, method);
        setTimeout(function() { callback(err); }, 0);
        return undefined;
    }
};
Service$1.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
        if (!endedByRPC)
            this.rpcImpl(null, null, null);
        this.rpcImpl = null;
        this.emit("end").off();
    }
    return this;
};
var rpc_1 = createCommonjsModule(function (module, exports) {
var rpc = exports;
rpc.Service = service;
});
var roots = {};
var indexMinimal = createCommonjsModule(function (module, exports) {
var protobuf = exports;
protobuf.build = "minimal";
protobuf.Writer       = writer;
protobuf.BufferWriter = writer_buffer;
protobuf.Reader       = reader;
protobuf.BufferReader = reader_buffer;
protobuf.util         = minimal;
protobuf.rpc          = rpc_1;
protobuf.roots        = roots;
protobuf.configure    = configure;
function configure() {
    protobuf.Reader._configure(protobuf.BufferReader);
    protobuf.util._configure();
}
protobuf.Writer._configure(protobuf.BufferWriter);
configure();
});
var minimal$1 = indexMinimal;
var minimal_1 = minimal$1.Reader;
var minimal_2 = minimal$1.Writer;
var minimal_3 = minimal$1.util;
var minimal_4 = minimal$1.roots;
var $Reader = minimal_1, $Writer = minimal_2, $util = minimal_3;
var $root = minimal_4["default"] || (minimal_4["default"] = {});
var Message = $root.Message = (function () {
    function Message(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    Message.prototype.senderId = 0;
    Message.prototype.recipientId = 0;
    Message.prototype.serviceId = 0;
    Message.prototype.content = $util.newBuffer([]);
    Message.create = function create(properties) {
        return new Message(properties);
    };
    Message.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.senderId != null && message.hasOwnProperty("senderId"))
            writer.uint32(8).uint32(message.senderId);
        if (message.recipientId != null && message.hasOwnProperty("recipientId"))
            writer.uint32(16).uint32(message.recipientId);
        if (message.serviceId != null && message.hasOwnProperty("serviceId"))
            writer.uint32(24).uint32(message.serviceId);
        if (message.content != null && message.hasOwnProperty("content"))
            writer.uint32(34).bytes(message.content);
        return writer;
    };
    Message.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Message();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.senderId = reader.uint32();
                    break;
                case 2:
                    message.recipientId = reader.uint32();
                    break;
                case 3:
                    message.serviceId = reader.uint32();
                    break;
                case 4:
                    message.content = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    return Message;
})();
var userMessage = $root.userMessage = (function () {
    var userMessage = {};
    userMessage.Message = (function () {
        function Message(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }
        Message.prototype.length = 0;
        Message.prototype.type = 0;
        Message.prototype.full = $util.newBuffer([]);
        Message.prototype.chunk = null;
        var $oneOfFields;
        Object.defineProperty(Message.prototype, "contentType", {
            get: $util.oneOfGetter($oneOfFields = ["full", "chunk"]),
            set: $util.oneOfSetter($oneOfFields)
        });
        Message.create = function create(properties) {
            return new Message(properties);
        };
        Message.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.length != null && message.hasOwnProperty("length"))
                writer.uint32(8).uint32(message.length);
            if (message.type != null && message.hasOwnProperty("type"))
                writer.uint32(16).int32(message.type);
            if (message.full != null && message.hasOwnProperty("full"))
                writer.uint32(26).bytes(message.full);
            if (message.chunk != null && message.hasOwnProperty("chunk"))
                $root.userMessage.Message.Chunk.encode(message.chunk, writer.uint32(34).fork()).ldelim();
            return writer;
        };
        Message.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.userMessage.Message();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.length = reader.uint32();
                        break;
                    case 2:
                        message.type = reader.int32();
                        break;
                    case 3:
                        message.full = reader.bytes();
                        break;
                    case 4:
                        message.chunk = $root.userMessage.Message.Chunk.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        Message.Chunk = (function () {
            function Chunk(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }
            Chunk.prototype.id = 0;
            Chunk.prototype.nb = 0;
            Chunk.prototype.content = $util.newBuffer([]);
            Chunk.create = function create(properties) {
                return new Chunk(properties);
            };
            Chunk.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && message.hasOwnProperty("id"))
                    writer.uint32(8).uint32(message.id);
                if (message.nb != null && message.hasOwnProperty("nb"))
                    writer.uint32(16).uint32(message.nb);
                if (message.content != null && message.hasOwnProperty("content"))
                    writer.uint32(34).bytes(message.content);
                return writer;
            };
            Chunk.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.userMessage.Message.Chunk();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                        case 1:
                            message.id = reader.uint32();
                            break;
                        case 2:
                            message.nb = reader.uint32();
                            break;
                        case 4:
                            message.content = reader.bytes();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                    }
                }
                return message;
            };
            return Chunk;
        })();
        Message.Type = (function () {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "STRING"] = 0;
            values[valuesById[1] = "U_INT_8_ARRAY"] = 1;
            return values;
        })();
        return Message;
    })();
    return userMessage;
})();
var channelBuilder = $root.channelBuilder = (function () {
    var channelBuilder = {};
    channelBuilder.Message = (function () {
        function Message(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }
        Message.prototype.negotiation = null;
        Message.prototype.connectionRequest = $util.newBuffer([]);
        Message.prototype.connectionResponse = false;
        var $oneOfFields;
        Object.defineProperty(Message.prototype, "type", {
            get: $util.oneOfGetter($oneOfFields = ["negotiation", "connectionRequest", "connectionResponse"]),
            set: $util.oneOfSetter($oneOfFields)
        });
        Message.create = function create(properties) {
            return new Message(properties);
        };
        Message.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.negotiation != null && message.hasOwnProperty("negotiation"))
                $root.channelBuilder.Negotiation.encode(message.negotiation, writer.uint32(10).fork()).ldelim();
            if (message.connectionRequest != null && message.hasOwnProperty("connectionRequest"))
                writer.uint32(18).bytes(message.connectionRequest);
            if (message.connectionResponse != null && message.hasOwnProperty("connectionResponse"))
                writer.uint32(24).bool(message.connectionResponse);
            return writer;
        };
        Message.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.channelBuilder.Message();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.negotiation = $root.channelBuilder.Negotiation.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.connectionRequest = reader.bytes();
                        break;
                    case 3:
                        message.connectionResponse = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        return Message;
    })();
    channelBuilder.Negotiation = (function () {
        function Negotiation(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }
        Negotiation.prototype.initiator = null;
        Negotiation.prototype.passive = null;
        Negotiation.create = function create(properties) {
            return new Negotiation(properties);
        };
        Negotiation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.initiator != null && message.hasOwnProperty("initiator"))
                $root.channelBuilder.Info.encode(message.initiator, writer.uint32(10).fork()).ldelim();
            if (message.passive != null && message.hasOwnProperty("passive"))
                $root.channelBuilder.Info.encode(message.passive, writer.uint32(18).fork()).ldelim();
            return writer;
        };
        Negotiation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.channelBuilder.Negotiation();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.initiator = $root.channelBuilder.Info.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.passive = $root.channelBuilder.Info.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        return Negotiation;
    })();
    channelBuilder.Info = (function () {
        function Info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }
        Info.prototype.id = 0;
        Info.prototype.wss = "";
        Info.prototype.wcId = 0;
        Info.prototype.wsSupported = false;
        Info.prototype.wsTried = false;
        Info.prototype.dcSupported = false;
        Info.prototype.dcTried = false;
        Info.create = function create(properties) {
            return new Info(properties);
        };
        Info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && message.hasOwnProperty("id"))
                writer.uint32(8).uint32(message.id);
            if (message.wss != null && message.hasOwnProperty("wss"))
                writer.uint32(18).string(message.wss);
            if (message.wcId != null && message.hasOwnProperty("wcId"))
                writer.uint32(24).uint32(message.wcId);
            if (message.wsSupported != null && message.hasOwnProperty("wsSupported"))
                writer.uint32(32).bool(message.wsSupported);
            if (message.wsTried != null && message.hasOwnProperty("wsTried"))
                writer.uint32(40).bool(message.wsTried);
            if (message.dcSupported != null && message.hasOwnProperty("dcSupported"))
                writer.uint32(48).bool(message.dcSupported);
            if (message.dcTried != null && message.hasOwnProperty("dcTried"))
                writer.uint32(56).bool(message.dcTried);
            return writer;
        };
        Info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.channelBuilder.Info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.id = reader.uint32();
                        break;
                    case 2:
                        message.wss = reader.string();
                        break;
                    case 3:
                        message.wcId = reader.uint32();
                        break;
                    case 4:
                        message.wsSupported = reader.bool();
                        break;
                    case 5:
                        message.wsTried = reader.bool();
                        break;
                    case 6:
                        message.dcSupported = reader.bool();
                        break;
                    case 7:
                        message.dcTried = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        return Info;
    })();
    return channelBuilder;
})();
var fullMesh = $root.fullMesh = (function () {
    var fullMesh = {};
    fullMesh.Message = (function () {
        function Message(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }
        Message.prototype.members = null;
        Message.prototype.adjacentMembers = null;
        Message.prototype.heartbeat = false;
        var $oneOfFields;
        Object.defineProperty(Message.prototype, "type", {
            get: $util.oneOfGetter($oneOfFields = ["members", "adjacentMembers", "heartbeat"]),
            set: $util.oneOfSetter($oneOfFields)
        });
        Message.create = function create(properties) {
            return new Message(properties);
        };
        Message.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.members != null && message.hasOwnProperty("members"))
                $root.fullMesh.Peers.encode(message.members, writer.uint32(10).fork()).ldelim();
            if (message.adjacentMembers != null && message.hasOwnProperty("adjacentMembers"))
                $root.fullMesh.Peers.encode(message.adjacentMembers, writer.uint32(26).fork()).ldelim();
            if (message.heartbeat != null && message.hasOwnProperty("heartbeat"))
                writer.uint32(32).bool(message.heartbeat);
            return writer;
        };
        Message.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.fullMesh.Message();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.members = $root.fullMesh.Peers.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.adjacentMembers = $root.fullMesh.Peers.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.heartbeat = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        return Message;
    })();
    fullMesh.Peers = (function () {
        function Peers(properties) {
            this.ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }
        Peers.prototype.ids = $util.emptyArray;
        Peers.create = function create(properties) {
            return new Peers(properties);
        };
        Peers.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ids != null && message.ids.length) {
                writer.uint32(10).fork();
                for (var i = 0; i < message.ids.length; ++i)
                    writer.uint32(message.ids[i]);
                writer.ldelim();
            }
            return writer;
        };
        Peers.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.fullMesh.Peers();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        if (!(message.ids && message.ids.length))
                            message.ids = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.ids.push(reader.uint32());
                        }
                        else
                            message.ids.push(reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        return Peers;
    })();
    fullMesh.ConnectionRequest = (function () {
        function ConnectionRequest(properties) {
            this.adjacentIds = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }
        ConnectionRequest.prototype.id = 0;
        ConnectionRequest.prototype.adjacentIds = $util.emptyArray;
        ConnectionRequest.create = function create(properties) {
            return new ConnectionRequest(properties);
        };
        ConnectionRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && message.hasOwnProperty("id"))
                writer.uint32(8).uint32(message.id);
            if (message.adjacentIds != null && message.adjacentIds.length) {
                writer.uint32(18).fork();
                for (var i = 0; i < message.adjacentIds.length; ++i)
                    writer.uint32(message.adjacentIds[i]);
                writer.ldelim();
            }
            return writer;
        };
        ConnectionRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.fullMesh.ConnectionRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.id = reader.uint32();
                        break;
                    case 2:
                        if (!(message.adjacentIds && message.adjacentIds.length))
                            message.adjacentIds = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.adjacentIds.push(reader.uint32());
                        }
                        else
                            message.adjacentIds.push(reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        return ConnectionRequest;
    })();
    return fullMesh;
})();
var dataChannelBuilder = $root.dataChannelBuilder = (function () {
    var dataChannelBuilder = {};
    dataChannelBuilder.Message = (function () {
        function Message(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }
        Message.prototype.offer = "";
        Message.prototype.answer = "";
        Message.prototype.candidate = null;
        var $oneOfFields;
        Object.defineProperty(Message.prototype, "type", {
            get: $util.oneOfGetter($oneOfFields = ["offer", "answer", "candidate"]),
            set: $util.oneOfSetter($oneOfFields)
        });
        Message.create = function create(properties) {
            return new Message(properties);
        };
        Message.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.offer != null && message.hasOwnProperty("offer"))
                writer.uint32(10).string(message.offer);
            if (message.answer != null && message.hasOwnProperty("answer"))
                writer.uint32(18).string(message.answer);
            if (message.candidate != null && message.hasOwnProperty("candidate"))
                $root.dataChannelBuilder.IceCandidate.encode(message.candidate, writer.uint32(26).fork()).ldelim();
            return writer;
        };
        Message.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dataChannelBuilder.Message();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.offer = reader.string();
                        break;
                    case 2:
                        message.answer = reader.string();
                        break;
                    case 3:
                        message.candidate = $root.dataChannelBuilder.IceCandidate.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        return Message;
    })();
    dataChannelBuilder.IceCandidate = (function () {
        function IceCandidate(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }
        IceCandidate.prototype.candidate = "";
        IceCandidate.prototype.sdpMid = "";
        IceCandidate.prototype.sdpMLineIndex = 0;
        IceCandidate.create = function create(properties) {
            return new IceCandidate(properties);
        };
        IceCandidate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.candidate != null && message.hasOwnProperty("candidate"))
                writer.uint32(10).string(message.candidate);
            if (message.sdpMid != null && message.hasOwnProperty("sdpMid"))
                writer.uint32(18).string(message.sdpMid);
            if (message.sdpMLineIndex != null && message.hasOwnProperty("sdpMLineIndex"))
                writer.uint32(24).uint32(message.sdpMLineIndex);
            return writer;
        };
        IceCandidate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dataChannelBuilder.IceCandidate();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.candidate = reader.string();
                        break;
                    case 2:
                        message.sdpMid = reader.string();
                        break;
                    case 3:
                        message.sdpMLineIndex = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        return IceCandidate;
    })();
    return dataChannelBuilder;
})();
var channel = $root.channel = (function () {
    var channel = {};
    channel.Message = (function () {
        function Message(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }
        Message.prototype.initPing = null;
        Message.prototype.initPong = 0;
        var $oneOfFields;
        Object.defineProperty(Message.prototype, "type", {
            get: $util.oneOfGetter($oneOfFields = ["initPing", "initPong"]),
            set: $util.oneOfSetter($oneOfFields)
        });
        Message.create = function create(properties) {
            return new Message(properties);
        };
        Message.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.initPing != null && message.hasOwnProperty("initPing"))
                $root.channel.Data.encode(message.initPing, writer.uint32(10).fork()).ldelim();
            if (message.initPong != null && message.hasOwnProperty("initPong"))
                writer.uint32(16).uint32(message.initPong);
            return writer;
        };
        Message.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.channel.Message();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.initPing = $root.channel.Data.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.initPong = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        return Message;
    })();
    channel.Data = (function () {
        function Data(properties) {
            this.members = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }
        Data.prototype.topology = 0;
        Data.prototype.wcId = 0;
        Data.prototype.senderId = 0;
        Data.prototype.members = $util.emptyArray;
        Data.prototype.key = "";
        Data.create = function create(properties) {
            return new Data(properties);
        };
        Data.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.topology != null && message.hasOwnProperty("topology"))
                writer.uint32(8).uint32(message.topology);
            if (message.wcId != null && message.hasOwnProperty("wcId"))
                writer.uint32(16).uint32(message.wcId);
            if (message.senderId != null && message.hasOwnProperty("senderId"))
                writer.uint32(24).uint32(message.senderId);
            if (message.members != null && message.members.length) {
                writer.uint32(34).fork();
                for (var i = 0; i < message.members.length; ++i)
                    writer.uint32(message.members[i]);
                writer.ldelim();
            }
            if (message.key != null && message.hasOwnProperty("key"))
                writer.uint32(42).string(message.key);
            return writer;
        };
        Data.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.channel.Data();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.topology = reader.uint32();
                        break;
                    case 2:
                        message.wcId = reader.uint32();
                        break;
                    case 3:
                        message.senderId = reader.uint32();
                        break;
                    case 4:
                        if (!(message.members && message.members.length))
                            message.members = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.members.push(reader.uint32());
                        }
                        else
                            message.members.push(reader.uint32());
                        break;
                    case 5:
                        message.key = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        return Data;
    })();
    return channel;
})();
var signaling = $root.signaling = (function () {
    var signaling = {};
    signaling.Message = (function () {
        function Message(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }
        Message.prototype.heartbeat = false;
        Message.prototype.content = null;
        Message.prototype.connect = null;
        Message.prototype.connected = false;
        var $oneOfFields;
        Object.defineProperty(Message.prototype, "type", {
            get: $util.oneOfGetter($oneOfFields = ["heartbeat", "content", "connect", "connected"]),
            set: $util.oneOfSetter($oneOfFields)
        });
        Message.create = function create(properties) {
            return new Message(properties);
        };
        Message.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.heartbeat != null && message.hasOwnProperty("heartbeat"))
                writer.uint32(8).bool(message.heartbeat);
            if (message.content != null && message.hasOwnProperty("content"))
                $root.signaling.Content.encode(message.content, writer.uint32(18).fork()).ldelim();
            if (message.connect != null && message.hasOwnProperty("connect"))
                $root.signaling.GroupData.encode(message.connect, writer.uint32(26).fork()).ldelim();
            if (message.connected != null && message.hasOwnProperty("connected"))
                writer.uint32(32).bool(message.connected);
            return writer;
        };
        Message.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.signaling.Message();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.heartbeat = reader.bool();
                        break;
                    case 2:
                        message.content = $root.signaling.Content.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.connect = $root.signaling.GroupData.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.connected = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        return Message;
    })();
    signaling.Content = (function () {
        function Content(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }
        Content.prototype.senderId = 0;
        Content.prototype.recipientId = 0;
        Content.prototype.lastData = false;
        Content.prototype.data = $util.newBuffer([]);
        Content.create = function create(properties) {
            return new Content(properties);
        };
        Content.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.senderId != null && message.hasOwnProperty("senderId"))
                writer.uint32(8).uint32(message.senderId);
            if (message.recipientId != null && message.hasOwnProperty("recipientId"))
                writer.uint32(16).uint32(message.recipientId);
            if (message.lastData != null && message.hasOwnProperty("lastData"))
                writer.uint32(24).bool(message.lastData);
            if (message.data != null && message.hasOwnProperty("data"))
                writer.uint32(34).bytes(message.data);
            return writer;
        };
        Content.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.signaling.Content();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.senderId = reader.uint32();
                        break;
                    case 2:
                        message.recipientId = reader.uint32();
                        break;
                    case 3:
                        message.lastData = reader.bool();
                        break;
                    case 4:
                        message.data = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        return Content;
    })();
    signaling.GroupData = (function () {
        function GroupData(properties) {
            this.members = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }
        GroupData.prototype.id = 0;
        GroupData.prototype.members = $util.emptyArray;
        GroupData.create = function create(properties) {
            return new GroupData(properties);
        };
        GroupData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && message.hasOwnProperty("id"))
                writer.uint32(8).uint32(message.id);
            if (message.members != null && message.members.length) {
                writer.uint32(18).fork();
                for (var i = 0; i < message.members.length; ++i)
                    writer.uint32(message.members[i]);
                writer.ldelim();
            }
            return writer;
        };
        GroupData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.signaling.GroupData();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.id = reader.uint32();
                        break;
                    case 2:
                        if (!(message.members && message.members.length))
                            message.members = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.members.push(reader.uint32());
                        }
                        else
                            message.members.push(reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        return GroupData;
    })();
    return signaling;
})();

var MAXIMUM_MISSED_HEARTBEAT = 3;
var HEARTBEAT_INTERVAL = 5000;
var heartbeatMsg = signaling.Message.encode(signaling.Message.create({ heartbeat: true })).finish();
var SignalingState;
(function (SignalingState) {
    SignalingState[SignalingState["CONNECTING"] = 0] = "CONNECTING";
    SignalingState[SignalingState["OPEN"] = 1] = "OPEN";
    SignalingState[SignalingState["CHECKING"] = 2] = "CHECKING";
    SignalingState[SignalingState["CHECKED"] = 4] = "CHECKED";
    SignalingState[SignalingState["CLOSED"] = 3] = "CLOSED";
})(SignalingState || (SignalingState = {}));
var Signaling = (function () {
    function Signaling(wc, url) {
        this.STREAM_ID = 1;
        this.wc = wc;
        this.url = url;
        this.state = SignalingState.CLOSED;
        this.connected = false;
        this.missedHeartbeat = 0;
        this.streamSubject = new Subject();
        this.stateSubject = new Subject();
    }
    Object.defineProperty(Signaling.prototype, "messageFromStream", {
        get: function () {
            return this.streamSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Signaling.prototype.sendOverStream = function (msg) {
        log.signaling(this.wc.myId + ' Forward message', msg);
        this.send({
            content: {
                recipientId: msg.recipientId,
                senderId: msg.senderId,
                lastData: msg.content === undefined,
                data: Message.encode(Message.create(msg)).finish(),
            },
        });
    };
    Object.defineProperty(Signaling.prototype, "onState", {
        get: function () {
            return this.stateSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Signaling.prototype.check = function () {
        var _this = this;
        if (this.state === SignalingState.CHECKED || this.state === SignalingState.OPEN) {
            this.setState(SignalingState.CHECKING);
            this.send({
                connect: { id: this.wc.myId, members: this.wc.members.filter(function (id) { return id !== _this.wc.myId; }) },
            });
        }
    };
    Signaling.prototype.connect = function (key) {
        var _this = this;
        if (isWebSocketSupported()) {
            this.setState(SignalingState.CONNECTING);
            this.ws = new env.WebSocket(this.fullUrl(key));
            this.ws.binaryType = 'arraybuffer';
            this.connectionTimeout = setTimeout(function () {
                if (_this.ws && _this.ws.readyState !== _this.ws.OPEN) {
                    log.signaling("Failed to connect to Signaling server " + _this.url + ": connection timeout");
                    _this.close();
                }
            }, 10000);
            this.ws.onopen = function () {
                _this.setState(SignalingState.OPEN);
                if (_this.connectionTimeout) {
                    clearTimeout(_this.connectionTimeout);
                }
                _this.startHeartbeat();
            };
            this.ws.onerror = function (err) { return log.signaling("WebSocket ERROR", err); };
            this.ws.onclose = function (closeEvt) {
                _this.clean();
                _this.setState(SignalingState.CLOSED);
            };
            this.ws.onmessage = function (_a) {
                var data = _a.data;
                return _this.handleMessage(data);
            };
        }
        else {
            throw new Error('Failed to join over Signaling: WebSocket is not supported by your environment');
        }
    };
    Signaling.prototype.close = function () {
        if (this.state !== SignalingState.CLOSED) {
            if (this.ws) {
                this.ws.onmessage = function () { };
                this.ws.onclose = function () { };
                this.ws.onerror = function () { };
                this.ws.close(1000);
            }
            this.clean();
            this.setState(SignalingState.CLOSED);
        }
    };
    Signaling.prototype.clean = function () {
        if (this.connectionTimeout) {
            clearTimeout(this.connectionTimeout);
        }
        if (this.heartbeatInterval) {
            clearInterval(this.heartbeatInterval);
        }
        this.ws = undefined;
    };
    Signaling.prototype.handleMessage = function (bytes) {
        var _this = this;
        try {
            var msg = signaling.Message.decode(new Uint8Array(bytes));
            switch (msg.type) {
                case 'heartbeat':
                    this.missedHeartbeat = 0;
                    break;
                case 'connected':
                    this.connected = msg.connected;
                    this.setState(SignalingState.CHECKED);
                    if (!msg.connected) {
                        this.wc.channelBuilder.connectOverSignaling().catch(function () { return _this.check(); });
                    }
                    break;
                case 'content': {
                    var _a = msg.content, data = _a.data, senderId = _a.senderId, recipientId = _a.recipientId;
                    var streamMessage = Message.decode(data);
                    streamMessage.senderId = senderId;
                    streamMessage.recipientId = recipientId;
                    log.signaling('StreamMessage RECEIVED: ', streamMessage);
                    this.streamSubject.next(streamMessage);
                    break;
                }
            }
        }
        catch (err) {
            log.warn('Decode Signaling message error: ', err);
        }
    };
    Signaling.prototype.setState = function (state) {
        if (this.state !== state) {
            this.state = state;
            this.stateSubject.next(state);
        }
    };
    Signaling.prototype.startHeartbeat = function () {
        var _this = this;
        this.missedHeartbeat = 0;
        this.heartbeatInterval = setInterval(function () {
            try {
                _this.missedHeartbeat++;
                if (_this.missedHeartbeat >= MAXIMUM_MISSED_HEARTBEAT) {
                    throw new Error('Too many missed heartbeats');
                }
                _this.heartbeat();
            }
            catch (err) {
                _this.close();
            }
        }, HEARTBEAT_INTERVAL);
    };
    Signaling.prototype.send = function (msg) {
        if (this.ws && this.ws.readyState === env.WebSocket.OPEN) {
            try {
                this.ws.send(signaling.Message.encode(signaling.Message.create(msg)).finish());
            }
            catch (err) {
                log.signaling('Failed send to Signaling', err);
            }
        }
    };
    Signaling.prototype.heartbeat = function () {
        if (this.ws && this.ws.readyState === env.WebSocket.OPEN) {
            try {
                this.ws.send(heartbeatMsg);
            }
            catch (err) {
                log.signaling('Failed send to Signaling: ' + err.message);
            }
        }
    };
    Signaling.prototype.fullUrl = function (key) {
        var urlWithKey = this.url.endsWith('/') ? this.url + key : this.url + '/' + key;
        if (isBrowser) {
            return urlWithKey;
        }
        else {
            return urlWithKey + '?favored';
        }
    };
    return Signaling;
}());

var WebChannelState;
(function (WebChannelState) {
    WebChannelState[WebChannelState["JOINING"] = 0] = "JOINING";
    WebChannelState[WebChannelState["JOINED"] = 1] = "JOINED";
    WebChannelState[WebChannelState["LEFT"] = 2] = "LEFT";
})(WebChannelState || (WebChannelState = {}));

var MAX_USER_MSG_SIZE = 15000;
var MAX_MSG_ID_SIZE = 65535;
var textEncoder = new env.TextEncoder();
var textDecoder = new env.TextDecoder();
var UserMessage = (function (_super) {
    __extends(UserMessage, _super);
    function UserMessage() {
        var _this = _super.call(this, UserMessage.SERVICE_ID, userMessage.Message) || this;
        _this.buffers = new Map();
        return _this;
    }
    UserMessage.prototype.clean = function () {
        this.buffers.clear();
    };
    UserMessage.prototype.encodeUserMessage = function (data) {
        var _a = this.userDataToType(data), type = _a.type, bytes = _a.bytes;
        var msg = { length: bytes.length, type: type };
        if (bytes.length <= MAX_USER_MSG_SIZE) {
            msg.full = bytes;
            return [_super.prototype.encode.call(this, msg)];
        }
        else {
            msg.chunk = { id: Math.ceil(Math.random() * MAX_MSG_ID_SIZE) };
            var numberOfChunks = Math.ceil(bytes.length / MAX_USER_MSG_SIZE);
            var res = new Array(numberOfChunks);
            for (var i = 0; i < numberOfChunks; i++) {
                var length_1 = Math.min(MAX_USER_MSG_SIZE, bytes.length - MAX_USER_MSG_SIZE * i);
                var begin = MAX_USER_MSG_SIZE * i;
                var end = begin + length_1;
                msg.chunk.nb = i;
                msg.chunk.content = new Uint8Array(bytes.slice(begin, end));
                res[i] = _super.prototype.encode.call(this, msg);
            }
            return res;
        }
    };
    UserMessage.prototype.decodeUserMessage = function (bytes, senderId) {
        try {
            var _a = _super.prototype.decode.call(this, bytes), length_2 = _a.length, type = _a.type, contentType = _a.contentType, full = _a.full, chunk = _a.chunk;
            var result = void 0;
            switch (contentType) {
                case 'full': {
                    result = full;
                    break;
                }
                case 'chunk': {
                    var buffer = this.getBuffer(senderId, chunk.id);
                    if (buffer === undefined) {
                        buffer = new Buffer$1(length_2, chunk.content, chunk.nb);
                        this.setBuffer(senderId, chunk.id, buffer);
                        result = undefined;
                    }
                    else {
                        result = buffer.append(chunk.content, chunk.nb);
                    }
                    break;
                }
                default: {
                    throw new Error('Unknown message integrity');
                }
            }
            if (result !== undefined) {
                switch (type) {
                    case userMessage.Message.Type.U_INT_8_ARRAY:
                        return result;
                    case userMessage.Message.Type.STRING:
                        return textDecoder.decode(result);
                    default:
                        throw new Error('Unknown message type');
                }
            }
            return result;
        }
        catch (err) {
            log.warn('Decode user message error: ', err);
            return undefined;
        }
    };
    UserMessage.prototype.userDataToType = function (data) {
        if (data instanceof Uint8Array) {
            return { type: userMessage.Message.Type.U_INT_8_ARRAY, bytes: data };
        }
        else if (typeof data === 'string') {
            return { type: userMessage.Message.Type.STRING, bytes: textEncoder.encode(data) };
        }
        else if (data instanceof String) {
            return { type: userMessage.Message.Type.STRING, bytes: textEncoder.encode('' + data) };
        }
        else {
            throw new Error('Message neigther a string type or a Uint8Array type');
        }
    };
    UserMessage.prototype.getBuffer = function (peerId, msgId) {
        var buffers = this.buffers.get(peerId);
        if (buffers !== undefined) {
            return buffers.get(msgId);
        }
        return undefined;
    };
    UserMessage.prototype.setBuffer = function (peerId, msgId, buffer) {
        var buffers = this.buffers.get(peerId);
        if (buffers === undefined) {
            buffers = new Map();
        }
        buffers.set(msgId, buffer);
        this.buffers.set(peerId, buffers);
    };
    UserMessage.SERVICE_ID = 743;
    return UserMessage;
}(Service));
var Buffer$1 = (function () {
    function Buffer(totalLength, data, chunkNb) {
        this.fullData = new Uint8Array(totalLength);
        this.currentLength = 0;
        this.append(data, chunkNb);
    }
    Buffer.prototype.append = function (data, chunkNb) {
        var e_1, _a;
        var i = chunkNb * MAX_USER_MSG_SIZE;
        this.currentLength += data.length;
        try {
            for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
                var d = data_1_1.value;
                this.fullData[i++] = d;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return this.currentLength === this.fullData.length ? this.fullData : undefined;
    };
    return Buffer;
}());

var MAXIMUM_MISSED_HEARTBEAT$1 = 3;
var Channel = (function () {
    function Channel(wc, wsOrDc, type, id, pc) {
        var _this = this;
        log.channel("New Channel " + type + ": Me: " + wc.myId + " with " + id);
        this.wc = wc;
        this.wsOrDc = wsOrDc;
        this.type = type;
        this.pc = pc;
        this.missedHeartbeat = 0;
        this.heartbeatMsg = new Uint8Array(0);
        this.resolveInit = function () { };
        if (isBrowser) {
            wsOrDc.binaryType = 'arraybuffer';
            this.send = this.sendInBrowser;
        }
        else if (!this.pc) {
            this.send = this.sendInNodeOverWebSocket;
        }
        else {
            wsOrDc.binaryType = 'arraybuffer';
            this.send = this.sendInNodeOverDataChannel;
        }
        if (type === Channel.WITH_INTERNAL) {
            this.id = id;
            this.heartbeatMsg = this.createHeartbeatMsg();
            this.init = Promise.resolve();
            this.initHandlers();
        }
        else {
            this.id = MIN_ID;
            if (type === Channel.WITH_JOINING) {
                this.sendInitPing();
            }
            this.init = new Promise(function (resolve, reject) {
                return (_this.resolveInit = function () {
                    _this.heartbeatMsg = _this.createHeartbeatMsg();
                    resolve();
                });
            });
            this.wsOrDc.onmessage = function (_a) {
                var data = _a.data;
                try {
                    var msg = channel.Message.decode(new Uint8Array(data));
                    _this.handleInitMessage(msg);
                }
                catch (err) {
                    log.warn('Decode inner Channel message error: ', err);
                }
            };
        }
    }
    Channel.remoteType = function (type) {
        return type === Channel.WITH_INTERNAL
            ? Channel.WITH_INTERNAL
            : type === Channel.WITH_JOINING
                ? Channel.WITH_MEMBER
                : Channel.WITH_JOINING;
    };
    Object.defineProperty(Channel.prototype, "url", {
        get: function () {
            if (!this.pc) {
                return this.wsOrDc.url;
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Channel.prototype.encodeAndSend = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.senderId, senderId = _c === void 0 ? this.wc.myId : _c, _d = _b.recipientId, recipientId = _d === void 0 ? 0 : _d, serviceId = _b.serviceId, content = _b.content;
        this.send(Message.encode(Message.create({ senderId: senderId, recipientId: recipientId, serviceId: serviceId, content: content })).finish());
    };
    Channel.prototype.close = function () {
        this.wsOrDc.onmessage = undefined;
        this.wsOrDc.onclose = undefined;
        this.wsOrDc.onerror = undefined;
        if (this.pc) {
            this.pc.oniceconnectionstatechange = function () { };
            this.pc.close();
        }
        else {
            this.wsOrDc.close(1000);
        }
    };
    Channel.prototype.sendHeartbeat = function () {
        this.missedHeartbeat++;
        if (this.missedHeartbeat >= MAXIMUM_MISSED_HEARTBEAT$1) {
            log.channel(this.id + " channel closed: too many missed heartbeats");
            this.wc.topology.onChannelClose(this);
            this.close();
        }
        else {
            this.send(this.heartbeatMsg);
        }
    };
    Channel.prototype.sendInBrowser = function (data) {
        try {
            this.wsOrDc.send(data);
        }
        catch (err) {
            log.channel('Channel sendInBrowser ERROR', err);
        }
    };
    Channel.prototype.sendInNodeOverWebSocket = function (data) {
        try {
            this.wsOrDc.send(data, { binary: true });
        }
        catch (err) {
            log.channel('Channel sendInNodeOverWebSocket ERROR', err);
        }
    };
    Channel.prototype.sendInNodeOverDataChannel = function (data) {
        this.sendInBrowser(data.slice(0));
    };
    Channel.prototype.handleInitMessage = function (msg) {
        switch (msg.type) {
            case 'initPing': {
                log.channel(this.wc.myId + " received InitPing");
                var _a = msg.initPing, topology = _a.topology, wcId = _a.wcId, senderId = _a.senderId, members = _a.members, key = _a.key;
                if (this.wc.topologyEnum !== topology) {
                    log.channel('Different topology. This message should never be shown: something is wrong');
                }
                else if (members.includes(this.id) && wcId !== this.wc.id) ;
                this.wc.id = wcId;
                this.wc.key = key;
                this.id = senderId;
                log.channel(this.wc.myId + " send InitPong");
                this.send(channel.Message.encode(channel.Message.create({ initPong: this.wc.myId })).finish());
                this.initData = { members: members };
                this.initHandlers();
                this.resolveInit();
                break;
            }
            case 'initPong':
                log.channel(this.wc.myId + " received InitPong");
                this.id = msg.initPong;
                this.initHandlers();
                this.resolveInit();
                break;
            default:
                log.channel("Unknown message type: \"" + msg.type + "\". This message should never be shown: something went wrong");
        }
    };
    Channel.prototype.initHandlers = function () {
        var _this = this;
        this.wsOrDc.onmessage = function (_a) {
            var data = _a.data;
            try {
                var msg = Message.decode(new Uint8Array(data));
                if (msg.recipientId === 0 || msg.recipientId === _this.wc.myId) {
                    if (msg.serviceId === UserMessage.SERVICE_ID) {
                        var userData = _this.wc.userMsg.decodeUserMessage(msg.content, msg.senderId);
                        if (userData) {
                            _this.wc.onMessage(msg.senderId, userData);
                        }
                    }
                    else if (msg.serviceId === 0) {
                        _this.missedHeartbeat = 0;
                    }
                    else {
                        _this.wc.streamSubject.next(Object.assign({ channel: _this }, msg));
                    }
                }
                if (msg.recipientId !== _this.wc.myId) {
                    _this.wc.topology.forward(msg);
                }
            }
            catch (err) {
                log.warn('Decode general Channel message error: ', err);
            }
        };
        this.wsOrDc.onclose = function (evt) {
            log.channel("Connection with " + _this.id + " has closed", evt);
            if (_this.pc) {
                _this.pc.oniceconnectionstatechange = function () { };
            }
            _this.wc.topology.onChannelClose(_this);
        };
        if (this.pc) {
            this.pc.oniceconnectionstatechange = function () {
                if (_this.pc && _this.pc.iceConnectionState === 'failed') {
                    _this.close();
                    _this.wc.topology.onChannelClose(_this);
                }
            };
        }
        this.wsOrDc.onerror = function (evt) { return log.channel('Channel error: ', evt); };
    };
    Channel.prototype.createHeartbeatMsg = function () {
        return Message.encode(Message.create({ serviceId: 0, senderId: this.wc.myId, recipientId: this.id })).finish();
    };
    Channel.prototype.sendInitPing = function () {
        log.channel('initialize...');
        this.send(channel.Message.encode(channel.Message.create({
            initPing: {
                topology: this.wc.topologyEnum,
                wcId: this.wc.id,
                senderId: this.wc.myId,
                members: this.wc.members,
                key: this.wc.key,
            },
        })).finish());
    };
    Channel.WITH_INTERNAL = 0;
    Channel.WITH_JOINING = 1;
    Channel.WITH_MEMBER = 2;
    return Channel;
}());

var CONNECT_TIMEOUT = 4000;
var WebSocketBuilder = (function () {
    function WebSocketBuilder(wc) {
        this.wc = wc;
        this.channelsSubject = new Subject();
    }
    Object.defineProperty(WebSocketBuilder.prototype, "channels", {
        get: function () {
            return this.channelsSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    WebSocketBuilder.prototype.newWebSocket = function (ws, id, type) {
        this.channelsSubject.next({ id: id, channel: new Channel(this.wc, ws, type, id) });
    };
    WebSocketBuilder.prototype.connect = function (url, type, targetId, myId, wcId) {
        return __awaiter(this, void 0, void 0, function () {
            var fullUrl, ws, channel;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        validateWebSocketURL(url);
                        fullUrl = this.composeUrl(url, Channel.remoteType(type), wcId, myId);
                        ws = new env.WebSocket(fullUrl);
                        return [4, new Promise(function (resolve, reject) {
                                var timeout = setTimeout(function () {
                                    if (ws.readyState !== ws.OPEN) {
                                        ws.close();
                                        reject(new Error("WebSocket " + CONNECT_TIMEOUT + "ms connection timeout with '" + url + "'"));
                                    }
                                }, CONNECT_TIMEOUT);
                                ws.onopen = function () {
                                    clearTimeout(timeout);
                                    resolve(new Channel(_this.wc, ws, type, targetId));
                                };
                                ws.onerror = function (err) { return reject(err); };
                                ws.onclose = function (closeEvt) {
                                    reject(new Error("WebSocket with '" + url + "' closed " + closeEvt.code + ": " + closeEvt.reason));
                                };
                            })];
                    case 1:
                        channel = (_a.sent());
                        this.channelsSubject.next({ id: targetId, channel: channel });
                        return [2];
                }
            });
        });
    };
    WebSocketBuilder.prototype.composeUrl = function (url, type, wcId, senderId) {
        var result = url + "/?type=" + type + "&wcId=" + wcId + "&senderId=" + senderId;
        if (type !== Channel.WITH_INTERNAL) {
            result += "&key=" + this.wc.key;
        }
        return result;
    };
    WebSocketBuilder.listenUrl = new BehaviorSubject('');
    return WebSocketBuilder;
}());

var Remote = (function () {
    function Remote(id, pc, send, remotes, timeout) {
        var _this = this;
        this.finalMessageReceived = false;
        this.finalMessageSent = false;
        this.id = id;
        this.pc = pc;
        this.send = send;
        this._onError = function () { };
        this.candidates = new ReplaySubject();
        this.remotes = remotes;
        this.isSDPSent = false;
        this.remotes.set(id, this);
        this.timer = setTimeout(function () {
            if (_this.pc.iceConnectionState !== 'connected' &&
                _this.pc.iceConnectionState !== 'completed') {
                _this._onError(new Error(timeout + "ms connection timeout"));
            }
        }, timeout);
        pc.oniceconnectionstatechange = function () {
            log.webrtc('LOCAL ICE CONNECTION STATE', pc.iceConnectionState);
            if (pc.iceConnectionState === 'failed') {
                _this._onError(new Error('Ice Connection State is FAILED'));
            }
        };
        pc.onicecandidate = function (evt) {
            if (evt.candidate !== null) {
                log.webrtc('LOCAL ICE CANDIDATE', evt.candidate.candidate);
                _this.send({
                    candidate: {
                        candidate: evt.candidate.candidate,
                        sdpMid: evt.candidate.sdpMid,
                        sdpMLineIndex: evt.candidate.sdpMLineIndex,
                    },
                });
            }
            else {
                _this.pc.onicecandidate = function () { };
                if (_this.isSDPSent) {
                    _this.sendFinalMessage();
                }
            }
        };
    }
    Object.defineProperty(Remote.prototype, "onError", {
        get: function () {
            return this._onError;
        },
        set: function (handler) {
            var _this = this;
            this._onError = function (err) {
                log.webrtc('ERROR: ', err.message);
                _this.clean(err.message !== 'clean');
                handler(err);
            };
        },
        enumerable: true,
        configurable: true
    });
    Remote.prototype.sdpIsSent = function () {
        this.isSDPSent = true;
        if (this.pc.iceGatheringState === 'complete') {
            this.sendFinalMessage();
        }
    };
    Remote.prototype.clean = function (sendFinalMessage) {
        if (sendFinalMessage === void 0) { sendFinalMessage = true; }
        log.webrtc('CLEAN REMOTE');
        this.pc.oniceconnectionstatechange = function () { };
        this.pc.onicecandidate = function () { };
        this.pc.ondatachannel = function () { };
        this._onError = function () { };
        this.candidates.complete();
        this.remotes.delete(this.id);
        clearTimeout(this.timer);
        this.pc.close();
        if (sendFinalMessage) {
            this.sendFinalMessage();
        }
    };
    Remote.prototype.dataChannelOpen = function (dc) {
        log.webrtc("DATA CHANNEL with " + this.id + " OPEN");
        if (this.finalMessageReceived && this.finalMessageSent) {
            this.remotes.delete(this.id);
        }
        this.pc.oniceconnectionstatechange = function () { };
        dc.onopen = function () { };
        this.pc.ondatachannel = function () { };
        this._onError = function () { };
    };
    Remote.prototype.handleMessage = function (msg) {
        var _this = this;
        if (msg.type) {
            switch (msg.type) {
                case 'offer':
                    log.webrtc('REMOTE OFFER', { offer: msg.offer });
                    this.pc
                        .setRemoteDescription({ type: 'offer', sdp: msg.offer })
                        .then(function () {
                        return _this.candidates.subscribe(function (ic) {
                            return _this.pc
                                .addIceCandidate(ic)
                                .catch(function (err) { return log.webrtc('Failed to addIceCandidate', err); });
                        });
                    })
                        .then(function () { return _this.pc.createAnswer(); })
                        .then(function (answer) { return _this.pc.setLocalDescription(answer); })
                        .then(function () {
                        var sdp = _this.pc.localDescription.sdp;
                        log.webrtc('Send LOCAL ANSWER', { answer: sdp });
                        _this.send({ answer: sdp });
                        _this.sdpIsSent();
                    })
                        .catch(function (err) { return _this._onError(err); });
                    break;
                case 'answer':
                    log.webrtc('REMOTE ANSWER is received', { answer: msg.answer });
                    this.pc
                        .setRemoteDescription({ type: 'answer', sdp: msg.answer })
                        .then(function () {
                        _this.candidates.subscribe(function (ic) {
                            return _this.pc
                                .addIceCandidate(ic)
                                .catch(function (err) { return log.webrtc(_this.id + ": Failed to add REMOTE Ice Candidate", err); });
                        });
                    })
                        .catch(function (err) { return _this._onError(err); });
                    break;
                case 'candidate':
                    log.webrtc('REMOTE ICE CANDIDATE is received', msg.candidate);
                    this.candidates.next(new env.RTCIceCandidate(msg.candidate));
                    break;
                default:
                    this._onError(new Error('Buffer Protocol unknown message from the remote peer'));
            }
        }
        else {
            log.webrtc('REMOTE FINAL MESSAGE received');
            this.finalMessageReceived = true;
            this.candidates.complete();
            if (this.finalMessageSent) {
                this.remotes.delete(this.id);
            }
        }
    };
    Remote.prototype.sendFinalMessage = function () {
        if (!this.finalMessageSent) {
            this.finalMessageSent = true;
            this.send({});
            if (this.finalMessageReceived) {
                this.remotes.delete(this.id);
            }
        }
    };
    return Remote;
}());

var CONNECT_TIMEOUT$1 = 9000;
var DataChannelBuilder = (function (_super) {
    __extends(DataChannelBuilder, _super);
    function DataChannelBuilder(wc, rtcConfiguration) {
        var _this = _super.call(this, DataChannelBuilder.SERVICE_ID, dataChannelBuilder.Message) || this;
        _this.wc = wc;
        _this.allStreams = _super.prototype.useAllStreams.call(_this, wc, wc.signaling);
        _this.rtcConfiguration = rtcConfiguration;
        _this.channelsSubject = new Subject();
        _this.remotes = new Map();
        _this.allStreams.message.subscribe(function (_a) {
            var streamId = _a.streamId, senderId = _a.senderId, recipientId = _a.recipientId, msg = _a.msg;
            var remote = _this.remotes.get(senderId);
            if (remote && remote.finalMessageReceived) {
                remote.clean(false);
                remote = undefined;
            }
            if (!remote) {
                if (msg.type && (msg.type === 'offer' || msg.type === 'candidate')) {
                    try {
                        remote = _this.createRemote(streamId, senderId, recipientId, true);
                    }
                    catch (err) {
                        return;
                    }
                }
                else {
                    return;
                }
            }
            remote.handleMessage(msg);
        });
        return _this;
    }
    Object.defineProperty(DataChannelBuilder.prototype, "channels", {
        get: function () {
            return this.channelsSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    DataChannelBuilder.prototype.connect = function (targetId, myId, type) {
        return __awaiter(this, void 0, void 0, function () {
            var streamId, remote, remoteType, dc, offerInit, offer, channel$$1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        log.webrtc('connectWith call', { targetId: targetId, myId: myId, type: type });
                        streamId = type === Channel.WITH_INTERNAL ? this.wc.STREAM_ID : this.wc.signaling.STREAM_ID;
                        remote = this.remotes.get(targetId);
                        if (remote) {
                            remote.clean();
                        }
                        else {
                            remote = this.createRemote(streamId, targetId, myId);
                        }
                        remoteType = Channel.remoteType(type);
                        dc = remote.pc.createDataChannel("{\"id\":" + this.wc.myId + ",\"type\":" + remoteType + "}");
                        return [4, remote.pc.createOffer()];
                    case 1:
                        offerInit = _a.sent();
                        return [4, remote.pc.setLocalDescription(offerInit)];
                    case 2:
                        _a.sent();
                        offer = remote.pc.localDescription.sdp;
                        this.allStreams.sendOver(streamId, { offer: offer }, targetId, myId);
                        remote.sdpIsSent();
                        return [4, new Promise(function (resolve, reject) {
                                remote.onError = function (err) { return reject(err); };
                                dc.onopen = function () {
                                    remote.dataChannelOpen(dc);
                                    resolve(new Channel(_this.wc, dc, type, targetId, remote.pc));
                                };
                            })];
                    case 3:
                        channel$$1 = (_a.sent());
                        this.channelsSubject.next({ id: targetId, channel: channel$$1 });
                        return [2];
                }
            });
        });
    };
    DataChannelBuilder.prototype.clean = function (id) {
        if (id) {
            var remote = this.remotes.get(id);
            if (remote) {
                remote.clean(false);
            }
        }
        else {
            this.remotes.forEach(function (remote) { return remote.onError(new Error('clean')); });
        }
    };
    DataChannelBuilder.prototype.createRemote = function (streamId, recipientId, senderId, passive) {
        var _this = this;
        if (passive === void 0) { passive = false; }
        var remote = new Remote(recipientId, new env.RTCPeerConnection(this.rtcConfiguration), function (msg) { return _this.allStreams.sendOver(streamId, msg, recipientId, senderId); }, this.remotes, CONNECT_TIMEOUT$1);
        if (passive) {
            log.webrtc("create a new remote object with " + recipientId + " - PASSIVE");
            var pc = remote.pc;
            pc.ondatachannel = function (_a) {
                var dc = _a.channel;
                var _b = JSON.parse(dc.label), id = _b.id, type = _b.type;
                dc.onopen = function () {
                    remote.dataChannelOpen(dc);
                    var channel$$1 = new Channel(_this.wc, dc, type, id, remote.pc);
                    _this.channelsSubject.next({ id: recipientId, channel: channel$$1 });
                };
            };
        }
        else {
            log.webrtc("create a new remote object with " + recipientId + " - INITIATOR");
        }
        return remote;
    };
    DataChannelBuilder.SERVICE_ID = 7431;
    return DataChannelBuilder;
}(Service));

var ConnectionError;
(function (ConnectionError) {
    ConnectionError["RESPONSE_TIMEOUT"] = "Response timeout: remote peer is not responding";
    ConnectionError["CONNECTION_TIMEOUT"] = "Connection timeout: unable to establish a channel within a specified time";
    ConnectionError["DENIED"] = "Connection denied: remote peer refused the connection request";
    ConnectionError["CLEAN"] = "Clean: all connections in progress must be stopped";
    ConnectionError["IN_PROGRESS"] = "Connection setup is already in progress";
    ConnectionError["NEGOTIATION_ERROR"] = "All connection possibilities have been tried and none of them worked";
})(ConnectionError || (ConnectionError = {}));

var ConnectionsInProgress = (function () {
    function ConnectionsInProgress() {
        this.connections = new Map();
    }
    ConnectionsInProgress.prototype.create = function (id, connectionTimeout, responseTimeout, onConnectionTimeoutCallback) {
        var _this = this;
        var connection = {};
        connection.promise = new Promise(function (resolveResponse, rejectResponse) {
            var responseTimer = setTimeout(function () { return connection.reject(new Error(ConnectionError.RESPONSE_TIMEOUT)); }, responseTimeout);
            connection.resolve = function () {
                clearTimeout(responseTimer);
                resolveResponse();
                connection.promise = new Promise(function (resolveConnection, rejectConnection) {
                    var connectionTimer = setTimeout(function () {
                        log.channelBuilder('on Connection timeout callback');
                        onConnectionTimeoutCallback();
                        connection.reject(new Error(ConnectionError.CONNECTION_TIMEOUT));
                    }, connectionTimeout);
                    connection.resolve = function () {
                        clearTimeout(connectionTimer);
                        _this.connections.delete(id);
                        resolveConnection();
                    };
                    connection.reject = function (err) {
                        connection.promise.catch(function () { });
                        clearTimeout(connectionTimer);
                        _this.connections.delete(id);
                        rejectConnection(err);
                    };
                });
            };
            connection.reject = function (err) {
                connection.promise.catch(function () { });
                clearTimeout(responseTimer);
                _this.connections.delete(id);
                rejectResponse(err);
            };
            _this.connections.set(id, connection);
        });
        return connection;
    };
    ConnectionsInProgress.prototype.get = function (id) {
        return this.connections.get(id);
    };
    ConnectionsInProgress.prototype.has = function (streamId, id) {
        return this.connections.has(id);
    };
    ConnectionsInProgress.prototype.clean = function () {
        this.connections.forEach(function (c) { return c.reject(new Error(ConnectionError.CLEAN)); });
        this.connections.clear();
    };
    return ConnectionsInProgress;
}());

var CONNECT_TIMEOUT$2 = Math.max(CONNECT_TIMEOUT$1, CONNECT_TIMEOUT) + 5000;
var RESPONSE_TIMEOUT = 2000;
var ChannelBuilder = (function (_super) {
    __extends(ChannelBuilder, _super);
    function ChannelBuilder(wc) {
        var _this = _super.call(this, ChannelBuilder.SERVICE_ID, channelBuilder.Message) || this;
        _this.wc = wc;
        _this.allStreams = _super.prototype.useAllStreams.call(_this, wc, wc.signaling);
        _this.connectsInProgress = new ConnectionsInProgress();
        _this.channelsSubject = new Subject();
        _this.onConnectionRequest = function () { return true; };
        _this.dataChannelBuilder = new DataChannelBuilder(_this.wc, _this.wc.rtcConfiguration);
        _this.myInfo = {
            wsTried: false,
            wsSupported: isWebSocketSupported(),
            dcTried: false,
            dcSupported: isWebRTCSupported(),
        };
        _this.negotiationEncoded = _super.prototype.encode.call(_this, { negotiation: { initiator: _this.myInfo } });
        if (!ChannelBuilder.connectResTrueEncoded && !ChannelBuilder.connectResFalseEncoded) {
            ChannelBuilder.connectResTrueEncoded = _super.prototype.encode.call(_this, { connectionResponse: true });
            ChannelBuilder.connectResFalseEncoded = _super.prototype.encode.call(_this, { connectionResponse: false });
        }
        _this.allStreams.message.subscribe(function (_a) {
            var streamId = _a.streamId, senderId = _a.senderId, recipientId = _a.recipientId, msg = _a.msg;
            _this.handleMessage(streamId, senderId, recipientId, msg);
        });
        _this.subscribeToChannels();
        _this.subscribeToURLandIDChange();
        return _this;
    }
    ChannelBuilder.prototype.clean = function () {
        log.channelBuilder('CLEAN call');
        this.dataChannelBuilder.clean();
        this.connectsInProgress.clean();
    };
    Object.defineProperty(ChannelBuilder.prototype, "onChannel", {
        get: function () {
            return this.channelsSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ChannelBuilder.prototype.connectOverWebChannel = function (id, cb, data) {
        if (cb === void 0) { cb = function () { }; }
        if (data === void 0) { data = new Uint8Array(); }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.connectOver(this.wc.STREAM_ID, id, cb, data)];
            });
        });
    };
    ChannelBuilder.prototype.connectOverSignaling = function (cb, data) {
        if (cb === void 0) { cb = function () { }; }
        if (data === void 0) { data = new Uint8Array(); }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.connectOver(this.wc.signaling.STREAM_ID, 0, cb, data)];
            });
        });
    };
    ChannelBuilder.prototype.connectOver = function (streamId, id, cb, data) {
        return __awaiter(this, void 0, void 0, function () {
            var connection;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        connection = this.connectsInProgress.get(id);
                        if (!!connection) return [3, 2];
                        this.allStreams.sendOver(streamId, { connectionRequest: data }, id, this.wc.myId);
                        connection = this.connectsInProgress.create(id, CONNECT_TIMEOUT$2, RESPONSE_TIMEOUT, function () {
                            return _this.dataChannelBuilder.clean(id);
                        });
                        return [4, connection.promise];
                    case 1:
                        _a.sent();
                        cb();
                        return [2, connection.promise];
                    case 2: throw new Error(ConnectionError.IN_PROGRESS);
                }
            });
        });
    };
    ChannelBuilder.prototype.handleMessage = function (streamId, senderId, recipientId, msg) {
        var _this = this;
        switch (msg.type) {
            case 'connectionRequest': {
                log.channelBuilder('connection Request from ', senderId);
                var connection = this.connectsInProgress.get(senderId);
                if (connection) {
                    if (senderId < this.wc.myId) {
                        connection.reject(new Error(ConnectionError.IN_PROGRESS));
                    }
                    else {
                        return;
                    }
                }
                if (this.onConnectionRequest(streamId, msg.connectionRequest)) {
                    connection = this.connectsInProgress.create(senderId, CONNECT_TIMEOUT$2, RESPONSE_TIMEOUT, function () { return _this.dataChannelBuilder.clean(senderId); });
                    connection.resolve();
                    log.channelBuilder('connection Response POSITIVE to ', senderId);
                    this.allStreams.sendOver(streamId, ChannelBuilder.connectResTrueEncoded, senderId, recipientId);
                }
                else {
                    log.channelBuilder('connection Response NEGATIVE to ', senderId);
                    this.allStreams.sendOver(streamId, ChannelBuilder.connectResFalseEncoded, senderId, recipientId);
                }
                break;
            }
            case 'connectionResponse': {
                log.channelBuilder('connection Response from ', senderId);
                var connection = this.connectsInProgress.get(senderId);
                if (connection) {
                    if (msg.connectionResponse) {
                        connection.resolve();
                        log.channelBuilder('Send first negotiation message to ', senderId);
                        this.allStreams.sendOver(streamId, this.negotiationEncoded, senderId, recipientId);
                    }
                    else {
                        connection.reject(new Error(ConnectionError.DENIED));
                    }
                }
                break;
            }
            case 'negotiation': {
                if (this.connectsInProgress.has(streamId, senderId)) {
                    var neg = msg.negotiation;
                    var initiator_1 = neg.initiator;
                    var passive_1 = neg.passive;
                    if (!passive_1) {
                        initiator_1.id = senderId;
                        passive_1 = Object.assign({}, this.myInfo);
                        passive_1.id = recipientId;
                    }
                    log.channelBuilder("NEGOTIATION message to proceed from " + senderId + ": ", JSON.stringify({
                        isIamInitiatore: passive_1.id === senderId,
                        passive: passive_1,
                        initiator: initiator_1,
                        senderId: senderId,
                        recipientId: recipientId,
                    }));
                    if (this.isNagotiable(initiator_1, passive_1)) {
                        this.proceedNegotiation(streamId, initiator_1, passive_1, passive_1.id === senderId).catch(function (err) {
                            _this.rejectConnection(streamId, senderId, err);
                            log.channelBuilder("NEGOTIATION with " + senderId + " FIALED: ", { passive: passive_1, initiator: initiator_1 });
                            _this.allStreams.sendOver(streamId, { negotiation: { initiator: initiator_1, passive: passive_1 } }, senderId, recipientId);
                        });
                    }
                    else {
                        this.rejectConnection(streamId, senderId, new Error(ConnectionError.NEGOTIATION_ERROR));
                    }
                }
                break;
            }
        }
    };
    ChannelBuilder.prototype.proceedNegotiation = function (streamId, initiator, passive, amIInitiator) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, me, theOther, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = __read(amIInitiator ? [initiator, passive] : [passive, initiator], 2), me = _a[0], theOther = _a[1];
                        _b = theOther.wss && !me.wsTried;
                        if (!_b) return [3, 2];
                        return [4, this.tryWs(streamId, me, theOther, amIInitiator)];
                    case 1:
                        _b = (_d.sent());
                        _d.label = 2;
                    case 2:
                        if (_b) {
                            return [2];
                        }
                        if (me.wss && !theOther.wsTried) {
                            log.channelBuilder("Prompt the other to connect over WebSocket");
                            this.allStreams.sendOver(streamId, { negotiation: { initiator: initiator, passive: passive } }, theOther.id, me.id);
                            return [2];
                        }
                        if (!(me.dcSupported && theOther.dcSupported)) return [3, 5];
                        _c = !me.dcTried;
                        if (!_c) return [3, 4];
                        return [4, this.tryDc(streamId, me, theOther, amIInitiator)];
                    case 3:
                        _c = (_d.sent());
                        _d.label = 4;
                    case 4:
                        if (_c) {
                            return [2];
                        }
                        if (!theOther.dcTried) {
                            log.channelBuilder("Prompt the other to connect over RTCDataChannel");
                            this.allStreams.sendOver(streamId, { negotiation: { initiator: initiator, passive: passive } }, theOther.id, me.id);
                            return [2];
                        }
                        _d.label = 5;
                    case 5: throw new Error(ConnectionError.NEGOTIATION_ERROR);
                }
            });
        });
    };
    ChannelBuilder.prototype.tryWs = function (streamId, me, theOther, amIInitiator) {
        return __awaiter(this, void 0, void 0, function () {
            var type, wcId, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        type = this.getType(streamId, amIInitiator);
                        wcId = type === Channel.WITH_MEMBER ? theOther.wcId : this.wc.myId;
                        return [4, this.wc.webSocketBuilder.connect(theOther.wss, type, theOther.id, me.id, wcId)];
                    case 1:
                        _a.sent();
                        log.channelBuilder("New WebSocket connection with " + theOther.id);
                        return [2, true];
                    case 2:
                        err_1 = _a.sent();
                        if (err_1.message !== 'clean') {
                            log.channelBuilder("WebSocket failed with " + theOther.id, err_1);
                            me.wsTried = true;
                            return [2, false];
                        }
                        else {
                            return [2, true];
                        }
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    ChannelBuilder.prototype.tryDc = function (streamId, me, theOther, amIInitiator) {
        return __awaiter(this, void 0, void 0, function () {
            var type, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        type = this.getType(streamId, amIInitiator);
                        return [4, this.dataChannelBuilder.connect(theOther.id, me.id, type)];
                    case 1:
                        _a.sent();
                        log.channelBuilder("New RTCDataChannel with " + theOther.id);
                        return [2, true];
                    case 2:
                        err_2 = _a.sent();
                        if (err_2.message !== 'clean') {
                            log.channelBuilder("RTCDataChannel failed with " + theOther.id, err_2);
                            me.dcTried = true;
                            return [2, false];
                        }
                        else {
                            return [2, true];
                        }
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    ChannelBuilder.prototype.getType = function (streamId, amIInitiator) {
        if (streamId === this.wc.STREAM_ID) {
            return Channel.WITH_INTERNAL;
        }
        return amIInitiator ? Channel.WITH_MEMBER : Channel.WITH_JOINING;
    };
    ChannelBuilder.prototype.isNagotiable = function (peerInfo1, peerInfo2) {
        return ((peerInfo1.wss && !peerInfo2.wsTried) ||
            (peerInfo2.wss && !peerInfo1.wsTried) ||
            (peerInfo1.dcSupported && peerInfo2.dcSupported && (!peerInfo1.dcTried || !peerInfo2.dcTried)));
    };
    ChannelBuilder.prototype.subscribeToChannels = function () {
        var _this = this;
        merge(this.dataChannelBuilder.channels, this.wc.webSocketBuilder.channels).subscribe(function (_a) {
            var id = _a.id, channel$$1 = _a.channel;
            channel$$1.init.then(function () {
                log.channelBuilder('NEW Channel from ', JSON.stringify({ type: channel$$1.type, id: id }));
                var connection = _this.connectsInProgress.get(id);
                if (connection) {
                    log.channelBuilder('RESOLVE this NEW Channel');
                    connection.resolve();
                }
                else {
                    log.channelBuilder('this NEW Channel NOT FOUND');
                }
                _this.channelsSubject.next(channel$$1);
            });
        });
    };
    ChannelBuilder.prototype.subscribeToURLandIDChange = function () {
        var _this = this;
        WebSocketBuilder.listenUrl.subscribe(function (url) {
            if (url) {
                _this.myInfo.wss = url;
                _this.negotiationEncoded = _super.prototype.encode.call(_this, { negotiation: { initiator: _this.myInfo } });
            }
        });
        this.wc.onIdChange.subscribe(function (id) {
            _this.myInfo.wcId = _this.wc.id;
            _this.negotiationEncoded = _super.prototype.encode.call(_this, { negotiation: { initiator: _this.myInfo } });
        });
    };
    ChannelBuilder.prototype.rejectConnection = function (streamId, senderId, err) {
        var connection = this.connectsInProgress.get(senderId);
        if (connection) {
            connection.reject(err);
        }
    };
    ChannelBuilder.SERVICE_ID = 74;
    return ChannelBuilder;
}(Service));

var REQUEST_MEMBERS_INTERVAL = 20000;
var MAX_ROUTE_DISTANCE = 3;
var HEARTBEAT_INTERVAL$1 = 3000;
var DELAYED_TIMEOUT = 300000;
var FullMesh = (function (_super) {
    __extends(FullMesh, _super);
    function FullMesh(wc) {
        var _this = _super.call(this, wc, FullMesh.SERVICE_ID, fullMesh.Message) || this;
        _this.adjacentMembers = new Map();
        _this.distantMembers = new Map();
        _this.antecedentId = 0;
        _this.delayedMembers = new Set();
        _this.delayedMembersTimers = new Set();
        _this.adjacentBots = new Set();
        _this.heartbeatMsg = _super.prototype.encode.call(_this, { heartbeat: true });
        _this.wcStream.message.subscribe(function (_a) {
            var channel$$1 = _a.channel, senderId = _a.senderId, msg = _a.msg;
            return _this.handleServiceMessage(channel$$1, senderId, msg);
        });
        _this.wc.channelBuilder.onConnectionRequest = function (streamId, data) {
            try {
                var _a = fullMesh.ConnectionRequest.decode(data), id = _a.id, adjacentIds = _a.adjacentIds;
                if (streamId === _this.wc.STREAM_ID) {
                    log.topology("CONNECTION REQUEST from " + id + ", where adjacent members are: ", adjacentIds);
                    return _this.createOrUpdateDistantMember(id, adjacentIds);
                }
                else {
                    return true;
                }
            }
            catch (err) {
                log.warn('Decode Fullmesh onConnectionRequest message error: ', err);
                return false;
            }
        };
        _this.wc.channelBuilder.onChannel.subscribe(function (ch) {
            log.topology("New adjacent member: " + ch.id);
            _this.distantMembers.delete(ch.id);
            _this.delayedMembers.delete(ch.id);
            var am = _this.adjacentMembers.get(ch.id);
            if (am) {
                log.topology('Replacing the same channel');
                am.close();
            }
            _this.adjacentMembers.set(ch.id, ch);
            if (ch.url) {
                _this.adjacentBots.add(ch);
            }
            _this.notifyDistantMembers();
            if (!_this.heartbeatInterval) {
                _this.startHeartbeatInterval();
            }
            if (ch.type === Channel.WITH_MEMBER) {
                _super.prototype.setState.call(_this, TopologyState.CONSTRUCTING);
                var members = ch.initData.members;
                _this.connectToMembers(members, ch.id).then(function () {
                    _super.prototype.setState.call(_this, TopologyState.CONSTRUCTED);
                    _this.startMembersCheckIntervals();
                });
            }
            else {
                _this.startMembersCheckIntervals();
            }
            _this.wc.onMemberJoinProxy(ch.id);
            _this.updateAntecedentId();
        });
        if (isBrowser) {
            window.fullmesh = function () {
                log.topology('Fullmesh info:', {
                    myId: _this.wc.myId,
                    antecedentId: _this.antecedentId,
                    signalingState: _this.wc.signaling.state,
                    webGroupState: _this.wc.state,
                    topologyState: TopologyState[_this.state],
                    adjacentBots: Array.from(_this.adjacentBots).map(function (ch) { return ch.id; }),
                    adjacentMembers: Array.from(_this.adjacentMembers.keys()).toString(),
                    distantMembers: Array.from(_this.distantMembers.keys()).toString(),
                    distantMembersDETAILS: Array.from(_this.distantMembers.keys()).map(function (id) {
                        var adjacentMembers = _this.distantMembers.get(id);
                        return { id: id, adjacentMembers: adjacentMembers ? adjacentMembers.adjacentIds : [] };
                    }),
                });
            };
        }
        return _this;
    }
    FullMesh.prototype.send = function (msg) {
        var _this = this;
        this.adjacentMembers.forEach(function (ch) { return ch.encodeAndSend(msg); });
        this.distantMembers.forEach(function (distantMember, id) {
            _this.sendToDistantPeer(distantMember, Object.assign(msg, { recipientId: id }));
        });
    };
    FullMesh.prototype.sendTo = function (msg) {
        var ch = this.adjacentMembers.get(msg.recipientId);
        if (ch) {
            ch.encodeAndSend(msg);
        }
        else {
            this.sendToDistantPeer(this.distantMembers.get(msg.recipientId), msg);
        }
    };
    FullMesh.prototype.forward = function (msg) {
        this.sendTo(msg);
    };
    FullMesh.prototype.leave = function () {
        if (this.state !== TopologyState.IDLE) {
            log.topology('LEAVE');
            this.clean();
            this.adjacentMembers.forEach(function (ch) { return ch.close(); });
            this.wc.onAdjacentMembersLeaveProxy(Array.from(this.adjacentMembers.keys()));
            this.adjacentMembers.clear();
            _super.prototype.setState.call(this, TopologyState.IDLE);
        }
    };
    FullMesh.prototype.onChannelClose = function (channel$$1) {
        if (this.adjacentMembers.delete(channel$$1.id)) {
            this.adjacentBots.delete(channel$$1);
            this.delayedMembers.delete(channel$$1.id);
            this.wc.onAdjacentMembersLeaveProxy([channel$$1.id]);
            if (this.adjacentMembers.size === 0) {
                this.clean();
            }
            else {
                this.notifyDistantMembers();
                this.updateAntecedentId();
            }
            log.topology("Channel closed with " + channel$$1.id);
        }
    };
    Object.defineProperty(FullMesh.prototype, "neighbors", {
        get: function () {
            return Array.from(this.adjacentMembers.values());
        },
        enumerable: true,
        configurable: true
    });
    FullMesh.prototype.clean = function () {
        log.topology('CLEAN');
        this.wc.onDistantMembersLeaveProxy(Array.from(this.distantMembers.keys()));
        this.distantMembers.clear();
        this.antecedentId = 0;
        clearInterval(this.heartbeatInterval);
        this.heartbeatInterval = undefined;
        clearInterval(this.membersCheckInterval);
        this.membersCheckInterval = undefined;
        this.delayedMembers.clear();
        this.delayedMembersTimers.forEach(function (t) { return clearTimeout(t); });
        this.delayedMembersTimers.clear();
        this.adjacentBots.clear();
    };
    FullMesh.prototype.handleServiceMessage = function (channel$$1, senderId, msg) {
        switch (msg.type) {
            case 'members': {
                this.connectToMembers(msg.members.ids, senderId);
                break;
            }
            case 'adjacentMembers': {
                log.topology("adjacent members received from " + senderId, msg.adjacentMembers.ids);
                var ids = msg.adjacentMembers.ids;
                this.createOrUpdateDistantMember(senderId, ids);
                break;
            }
            case 'heartbeat': {
                var distantMember = this.distantMembers.get(senderId);
                if (distantMember) {
                    distantMember.missedHeartbeat = 0;
                }
                break;
            }
        }
    };
    FullMesh.prototype.connectToMembers = function (ids, adjacentId) {
        var _this = this;
        var e_1, _a;
        var missingIds = ids.filter(function (id) { return !_this.adjacentMembers.has(id) && id !== _this.wc.myId; });
        if (missingIds.length !== 0) {
            log.topology("TRY TO CONNECT to members", missingIds);
            var attempts = [];
            var msg = fullMesh.ConnectionRequest.encode(fullMesh.ConnectionRequest.create({
                id: this.wc.myId,
                adjacentIds: Array.from(this.adjacentMembers.keys()),
            })).finish();
            var _loop_1 = function (id) {
                if (!this_1.distantMembers.has(id)) {
                    this_1.distantMembers.set(id, {
                        adjacentIds: [adjacentId],
                        missedHeartbeat: 0,
                    });
                    log.topology("NEW distant member = " + id + "; BIS", adjacentId);
                    this_1.updateAntecedentId();
                }
                if (!this_1.delayedMembers.has(id)) {
                    attempts[attempts.length] = this_1.wc.channelBuilder
                        .connectOverWebChannel(id, function () {
                        _this.wc.onMemberJoinProxy(id);
                        _this.updateAntecedentId();
                    }, msg)
                        .catch(function (err) {
                        log.topology("FAILED to connect to " + id + ", because: " + err.message);
                        if (err.message === ConnectionError.CONNECTION_TIMEOUT ||
                            err.message === ConnectionError.NEGOTIATION_ERROR ||
                            err.message === ConnectionError.IN_PROGRESS) {
                            _this.delayedMembers.add(id);
                            var timer_1 = setTimeout(function () {
                                _this.delayedMembers.delete(id);
                                _this.delayedMembersTimers.delete(timer_1);
                            }, DELAYED_TIMEOUT);
                            _this.delayedMembersTimers.add(timer_1);
                        }
                    });
                }
            };
            var this_1 = this;
            try {
                for (var missingIds_1 = __values(missingIds), missingIds_1_1 = missingIds_1.next(); !missingIds_1_1.done; missingIds_1_1 = missingIds_1.next()) {
                    var id = missingIds_1_1.value;
                    _loop_1(id);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (missingIds_1_1 && !missingIds_1_1.done && (_a = missingIds_1.return)) _a.call(missingIds_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return Promise.all(attempts);
        }
        return Promise.resolve();
    };
    FullMesh.prototype.notifyDistantMembers = function () {
        var _this = this;
        if (this.distantMembers.size !== 0) {
            var msg_1 = _super.prototype.encode.call(this, {
                adjacentMembers: { ids: Array.from(this.adjacentMembers.keys()) },
            });
            this.distantMembers.forEach(function (dm, id) { return _this.wcStream.send(msg_1, id); });
        }
    };
    FullMesh.prototype.startMembersCheckIntervals = function () {
        var _this = this;
        if (!this.membersCheckInterval) {
            this.membersCheckInterval = setInterval(function () {
                if (_this.antecedentId) {
                    _this.wcStream.send({ members: { ids: _this.wc.members } }, _this.antecedentId);
                }
            }, REQUEST_MEMBERS_INTERVAL);
        }
    };
    FullMesh.prototype.startHeartbeatInterval = function () {
        var _this = this;
        this.heartbeatInterval = setInterval(function () {
            _this.adjacentMembers.forEach(function (ch) { return ch.sendHeartbeat(); });
            _this.distantMembers.forEach(function (peer, id) {
                peer.missedHeartbeat++;
                if (peer.missedHeartbeat >= MAXIMUM_MISSED_HEARTBEAT$1 + 1) {
                    log.topology("Distant peer " + id + " stopped to responding: too many missed heartbeats");
                    if (_this.distantMembers.delete(id)) {
                        _this.delayedMembers.delete(id);
                        _this.wc.onDistantMembersLeaveProxy([id]);
                        _this.updateAntecedentId();
                    }
                }
                _this.wcStream.send(_this.heartbeatMsg, id);
            });
        }, HEARTBEAT_INTERVAL$1);
    };
    FullMesh.prototype.sendToDistantPeer = function (distantMember, msg) {
        for (var d = 1; d <= MAX_ROUTE_DISTANCE; d++) {
            var ch = this.findRoutedChannel(distantMember, d);
            if (ch) {
                ch.encodeAndSend(msg);
                return;
            }
        }
    };
    FullMesh.prototype.findRoutedChannel = function (distantMember, distance) {
        var e_2, _a, e_3, _b, e_4, _c;
        if (distantMember) {
            try {
                for (var _d = __values(this.adjacentBots), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var ch = _e.value;
                    if (distantMember.adjacentIds.includes(ch.id)) {
                        return ch;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_2) throw e_2.error; }
            }
            try {
                for (var _f = __values(this.adjacentMembers), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var _h = __read(_g.value, 2), neighbourId = _h[0], ch = _h[1];
                    if (distantMember.adjacentIds.includes(neighbourId)) {
                        return ch;
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_3) throw e_3.error; }
            }
            if (distance !== 0) {
                try {
                    for (var _j = __values(distantMember.adjacentIds), _k = _j.next(); !_k.done; _k = _j.next()) {
                        var id = _k.value;
                        var ch = this.findRoutedChannel(this.distantMembers.get(id), distance - 1);
                        if (ch) {
                            return ch;
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        }
        return undefined;
    };
    FullMesh.prototype.createOrUpdateDistantMember = function (id, ids) {
        if (!this.adjacentMembers.has(id)) {
            var distantMember = this.distantMembers.get(id);
            if (distantMember) {
                distantMember.adjacentIds = ids;
                log.topology("UPDATE distant member = " + id, distantMember.adjacentIds);
            }
            else {
                this.distantMembers.set(id, {
                    adjacentIds: ids,
                    missedHeartbeat: 0,
                });
                this.wc.onMemberJoinProxy(id);
                log.topology("NEW distant member = " + id, ids);
                this.updateAntecedentId();
            }
            return true;
        }
        log.topology("ABNORMAL update or create a distant member " + id + ", but he is also an adjacent member");
        return false;
    };
    FullMesh.prototype.updateAntecedentId = function () {
        var e_5, _a;
        if (this.adjacentMembers.size > 0) {
            var maxId = -1;
            var desiredId = -1;
            try {
                for (var _b = __values(this.wc.members), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var id = _c.value;
                    if (id !== this.wc.myId) {
                        if (id < this.wc.myId && id > desiredId) {
                            desiredId = id;
                        }
                        if (maxId < id) {
                            maxId = id;
                        }
                    }
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
            this.antecedentId = desiredId !== -1 ? desiredId : maxId;
        }
        else {
            this.antecedentId = 0;
        }
        log.topology("UPDATE, antecedentId = " + this.antecedentId + ", members = ", JSON.stringify(this.wc.members));
    };
    FullMesh.SERVICE_ID = 74315;
    return FullMesh;
}(Topology));

var webChannelDefaultOptions = {
    topology: TopologyEnum.FULL_MESH,
    signalingServer: 'wss://signaling.netflux.coedit.re',
    rtcConfiguration: {
        iceServers: [{ urls: 'stun:stun3.l.google.com:19302' }],
    },
    autoRejoin: true,
};
var REJOIN_TIMEOUT = 3000;
var WebChannel = (function () {
    function WebChannel(options) {
        this.STREAM_ID = 2;
        var fullOptions = Object.assign({}, webChannelDefaultOptions, options);
        this.streamSubject = new Subject();
        this.idSubject = new Subject();
        this.topologyEnum = fullOptions.topology;
        this.autoRejoin = fullOptions.autoRejoin;
        this.rtcConfiguration = fullOptions.rtcConfiguration;
        this.members = [];
        this._id = 0;
        this.key = '';
        this.myId = 0;
        this.state = WebChannelState.LEFT;
        this.rejoinEnabled = false;
        this.rejoinTimer = undefined;
        this.topology = {};
        this._onAlone = function () { };
        this.onMemberJoin = function none() { };
        this.onMemberLeave = function none() { };
        this.onMessage = function none() { };
        this.onMyId = function none() { };
        this.onStateChange = function none() { };
        this.onSignalingStateChange = function none() { };
        this.userMsg = new UserMessage();
        this.signaling = new Signaling(this, fullOptions.signalingServer);
        this.subscribeToSignalingState();
        this.webSocketBuilder = new WebSocketBuilder(this);
        this.channelBuilder = new ChannelBuilder(this);
        this.setTopology(fullOptions.topology);
        if (isBrowser) {
            this.subscribeToBrowserEvents();
        }
    }
    Object.defineProperty(WebChannel.prototype, "onIdChange", {
        get: function () {
            return this.idSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WebChannel.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
            this.idSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WebChannel.prototype, "messageFromStream", {
        get: function () {
            return this.streamSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WebChannel.prototype, "onAlone", {
        set: function (handler) {
            this._onAlone = handler;
        },
        enumerable: true,
        configurable: true
    });
    WebChannel.prototype.sendOverStream = function (msg) {
        this.topology.sendTo(msg);
    };
    WebChannel.prototype.join = function (key) {
        if (key === void 0) { key = generateKey(); }
        validateKey(key);
        if (this.state === WebChannelState.LEFT) {
            this.startJoin(key);
        }
    };
    WebChannel.prototype.invite = function (url) {
        var e_1, _a;
        validateWebSocketURL(url);
        var hostnamePort = extractHostnameAndPort(url);
        try {
            for (var _b = __values(this.topology.neighbors), _c = _b.next(); !_c.done; _c = _b.next()) {
                var ch = _c.value;
                if (hostnamePort === extractHostnameAndPort(ch.url)) {
                    return;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.webSocketBuilder
            .connect(url, Channel.WITH_JOINING, -1, -1, this.id)
            .catch(function (err) { return log.webgroup("Failed to invite the bot " + url + ": " + err.message); });
    };
    WebChannel.prototype.leave = function () {
        if (this.state !== WebChannelState.LEFT) {
            this.key = '';
            this.internalLeave();
        }
    };
    WebChannel.prototype.send = function (data) {
        var e_2, _a;
        if (this.members.length !== 1) {
            try {
                for (var _b = __values(this.userMsg.encodeUserMessage(data)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var chunk = _c.value;
                    this.topology.send({
                        senderId: this.myId,
                        recipientId: 0,
                        serviceId: UserMessage.SERVICE_ID,
                        content: chunk,
                    });
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    };
    WebChannel.prototype.sendTo = function (id, data) {
        var e_3, _a;
        if (this.members.length !== 1) {
            try {
                for (var _b = __values(this.userMsg.encodeUserMessage(data)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var chunk = _c.value;
                    this.topology.sendTo({
                        senderId: this.myId,
                        recipientId: id,
                        serviceId: UserMessage.SERVICE_ID,
                        content: chunk,
                    });
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    };
    WebChannel.prototype.onMemberJoinProxy = function (id) {
        if (!this.members.includes(id)) {
            this.members[this.members.length] = id;
            this.onMemberJoin(id);
        }
    };
    WebChannel.prototype.onAdjacentMembersLeaveProxy = function (ids) {
        if (this.onMemberLeaveProxy(ids)) {
            if (this.members.length === 1) {
                this._onAlone();
                this.topology.leave();
            }
            else if (this.signaling.state === SignalingState.CHECKED &&
                this.topology.state === TopologyState.CONSTRUCTED) {
                this.signaling.check();
            }
        }
    };
    WebChannel.prototype.onDistantMembersLeaveProxy = function (ids) {
        this.onMemberLeaveProxy(ids);
    };
    WebChannel.prototype.init = function (key, id) {
        if (id === void 0) { id = generateId(); }
        log.webgroup('INIT');
        this.id = id;
        this.myId = generateId();
        this.members = [this.myId];
        this.key = key;
        this.rejoinEnabled = this.autoRejoin;
        this.onMyId(this.myId);
        if (this.rejoinTimer) {
            clearTimeout(this.rejoinTimer);
            this.rejoinTimer = undefined;
        }
        this.setState(WebChannelState.JOINING);
    };
    WebChannel.prototype.clean = function () {
        log.webgroup('CLEAN');
        if (this.rejoinTimer) {
            clearTimeout(this.rejoinTimer);
            this.rejoinTimer = undefined;
        }
        this.members = [];
        this.id = 0;
        this.myId = 0;
    };
    WebChannel.prototype.setState = function (state) {
        if (this.state !== state) {
            log.webGroupState(WebChannelState[state], this.myId);
            this.state = state;
            this.onStateChange(state);
        }
    };
    WebChannel.prototype.setTopology = function (topologyEnum) {
        var _this = this;
        this.topologyEnum = topologyEnum;
        this.topology = new FullMesh(this);
        this.topology.onState.subscribe(function (state) {
            log.webgroup('Topology state: ', TopologyState[state]);
            switch (state) {
                case TopologyState.CONSTRUCTING:
                    _this.setState(WebChannelState.JOINING);
                    break;
                case TopologyState.CONSTRUCTED:
                    if (_this.signaling.state === SignalingState.OPEN) {
                        _this.signaling.check();
                    }
                    else if (_this.signaling.state === SignalingState.CHECKED) {
                        _this.setState(WebChannelState.JOINED);
                        _this.signaling.check();
                    }
                    else if (_this.signaling.state === SignalingState.CLOSED) {
                        _this.signaling.connect(_this.key);
                    }
                    break;
                case TopologyState.IDLE:
                    _this.channelBuilder.clean();
                    _this.userMsg.clean();
                    switch (_this.signaling.state) {
                        case SignalingState.CLOSED:
                            if (_this.rejoinEnabled) {
                                _this.rejoin();
                            }
                            else {
                                _this.internalLeave();
                            }
                            break;
                        case SignalingState.CONNECTING:
                            _this.setState(WebChannelState.JOINING);
                            break;
                        case SignalingState.OPEN:
                            _this.setState(WebChannelState.JOINING);
                            _this.signaling.check();
                            break;
                        case SignalingState.CHECKING:
                            _this.setState(WebChannelState.JOINING);
                            break;
                        case SignalingState.CHECKED:
                            _this.signaling.check();
                            break;
                    }
                    break;
            }
        });
    };
    WebChannel.prototype.subscribeToSignalingState = function () {
        var _this = this;
        this.signaling.onState.subscribe(function (state) {
            log.signalingState(SignalingState[state], _this.myId);
            _this.onSignalingStateChange(state);
            switch (state) {
                case SignalingState.CLOSED:
                    if (_this.topology.state === TopologyState.IDLE) {
                        if (_this.rejoinEnabled) {
                            _this.rejoin();
                        }
                        else {
                            _this.internalLeave();
                        }
                    }
                    else if (_this.topology.state === TopologyState.CONSTRUCTED) {
                        if (_this.members.length === 1) {
                            _this.topology.leave();
                        }
                        else if (_this.rejoinEnabled && !_this.rejoinTimer) {
                            _this.reconnectToSignaling();
                        }
                    }
                    break;
                case SignalingState.OPEN:
                    if (_this.topology.state !== TopologyState.CONSTRUCTING) {
                        _this.signaling.check();
                    }
                    break;
                case SignalingState.CHECKED:
                    if (_this.topology.state === TopologyState.IDLE) {
                        if (_this.signaling.connected) {
                            _this.topology.setJoinedState();
                        }
                    }
                    else if (_this.topology.state === TopologyState.CONSTRUCTED) {
                        _this.setState(WebChannelState.JOINED);
                    }
                    break;
            }
        });
    };
    WebChannel.prototype.subscribeToBrowserEvents = function () {
        var _this = this;
        window.addEventListener('online', function () { return _this.onBrowserBack(); });
        window.addEventListener('visibilitychange', function () { return _this.onBrowserBack(); });
        window.addEventListener('beforeunload', function () { return _this.leave(); });
    };
    WebChannel.prototype.startJoin = function (key) {
        if (key === void 0) { key = this.key; }
        log.webgroup('start join...');
        this.init(key);
        this.signaling.connect(key);
    };
    WebChannel.prototype.rejoin = function () {
        var _this = this;
        this.setState(WebChannelState.JOINING);
        if (!isVisible() || !isOnline()) {
            this.internalLeave();
        }
        else {
            this.clean();
            log.webgroup("rejoin in " + REJOIN_TIMEOUT + "ms");
            this.rejoinTimer = setTimeout(function () {
                if (_this.signaling.state === SignalingState.CLOSED &&
                    isVisible() &&
                    isOnline() &&
                    _this.rejoinEnabled) {
                    _this.startJoin();
                }
                else {
                    log.webgroup('abandon rejoin because: ', {
                        isVisible: isVisible(),
                        isOnline: isOnline(),
                        signalingState: SignalingState[_this.signaling.state],
                        rejoinEnabled: _this.rejoinEnabled,
                    });
                    _this.internalLeave();
                }
                _this.rejoinTimer = undefined;
            }, REJOIN_TIMEOUT);
        }
    };
    WebChannel.prototype.reconnectToSignaling = function () {
        var _this = this;
        if (this.members.length === 1 && (!isVisible() || !isOnline())) {
            this.internalLeave();
        }
        else {
            log.webgroup("reconnect to Signaling server in " + REJOIN_TIMEOUT + "ms");
            this.setState(WebChannelState.JOINING);
            this.rejoinTimer = setTimeout(function () {
                if (_this.signaling.state === SignalingState.CLOSED) {
                    if (isVisible() && isOnline()) {
                        if (_this.rejoinEnabled) {
                            _this.signaling.connect(_this.key);
                        }
                    }
                    else if (_this.members.length === 1) {
                        _this.internalLeave();
                    }
                }
                _this.rejoinTimer = undefined;
            }, REJOIN_TIMEOUT);
        }
    };
    WebChannel.prototype.onBrowserBack = function () {
        if (isVisible() && isOnline()) {
            log.webgroup('onBrowserBack', { isVisible: isVisible(), isOnline: isOnline() });
            this.rejoinEnabled = this.autoRejoin;
            if (this.rejoinEnabled) {
                if (this.state === WebChannelState.LEFT) {
                    this.startJoin();
                }
                else if (this.signaling.state === SignalingState.CLOSED) {
                    this.signaling.connect(this.key);
                }
            }
        }
    };
    WebChannel.prototype.onMemberLeaveProxy = function (ids) {
        var _this = this;
        var atLeastOneLeft = false;
        ids.forEach(function (id) {
            if (_this.members.includes(id)) {
                _this.members.splice(_this.members.indexOf(id), 1);
                atLeastOneLeft = true;
                _this.onMemberLeave(id);
            }
        });
        return atLeastOneLeft;
    };
    WebChannel.prototype.internalLeave = function () {
        log.webgroup('internal leave');
        this.rejoinEnabled = false;
        this.signaling.close();
        this.topology.leave();
        this.clean();
        this.setState(WebChannelState.LEFT);
    };
    return WebChannel;
}());

var wcs = new WeakMap();
var WebGroup = (function () {
    function WebGroup(options) {
        if (options === void 0) { options = {}; }
        var wc = new WebChannel(options);
        wcs.set(this, wc);
        this.id = undefined;
        Reflect.defineProperty(this, 'id', { configurable: false, enumerable: true, get: function () { return wc.id; } });
        this.myId = undefined;
        Reflect.defineProperty(this, 'myId', {
            configurable: false,
            enumerable: true,
            get: function () { return wc.myId; },
        });
        this.key = undefined;
        Reflect.defineProperty(this, 'key', {
            configurable: false,
            enumerable: true,
            get: function () { return wc.key; },
        });
        this.members = undefined;
        Reflect.defineProperty(this, 'members', {
            configurable: false,
            enumerable: true,
            get: function () { return wc.members; },
        });
        this.neighbors = undefined;
        Reflect.defineProperty(this, 'neighbors', {
            configurable: false,
            enumerable: true,
            get: function () { return wc.topology.neighbors.map(function (ch) { return ch.id; }); },
        });
        this.topology = undefined;
        Reflect.defineProperty(this, 'topology', {
            configurable: false,
            enumerable: true,
            get: function () { return wc.topologyEnum; },
        });
        this.state = undefined;
        Reflect.defineProperty(this, 'state', {
            configurable: false,
            enumerable: true,
            get: function () { return wc.state; },
        });
        this.signalingState = undefined;
        Reflect.defineProperty(this, 'signalingState', {
            configurable: false,
            enumerable: true,
            get: function () { return wc.signaling.state; },
        });
        this.signalingServer = undefined;
        Reflect.defineProperty(this, 'signalingServer', {
            configurable: false,
            enumerable: true,
            get: function () { return wc.signaling.url; },
        });
        this.autoRejoin = undefined;
        Reflect.defineProperty(this, 'autoRejoin', {
            configurable: false,
            enumerable: true,
            get: function () { return wc.autoRejoin; },
            set: function (value) { return (wc.autoRejoin = value); },
        });
        this.onMessage = undefined;
        Reflect.defineProperty(this, 'onMessage', {
            configurable: true,
            enumerable: true,
            get: function () { return (wc.onMessage.name === 'none' ? undefined : wc.onMessage); },
            set: function (handler) {
                wc.onMessage = typeof handler !== 'function' ? function none() { } : handler;
            },
        });
        this.onMyId = undefined;
        Reflect.defineProperty(this, 'onMyId', {
            configurable: true,
            enumerable: true,
            get: function () { return (wc.onMyId.name === 'none' ? undefined : wc.onMyId); },
            set: function (handler) {
                wc.onMyId = typeof handler !== 'function' ? function none() { } : handler;
            },
        });
        this.onMemberJoin = undefined;
        Reflect.defineProperty(this, 'onMemberJoin', {
            configurable: true,
            enumerable: true,
            get: function () { return (wc.onMemberJoin.name === 'none' ? undefined : wc.onMemberJoin); },
            set: function (handler) {
                wc.onMemberJoin = typeof handler !== 'function' ? function none() { } : handler;
            },
        });
        this.onMemberLeave = undefined;
        Reflect.defineProperty(this, 'onMemberLeave', {
            configurable: true,
            enumerable: true,
            get: function () { return (wc.onMemberLeave.name === 'none' ? undefined : wc.onMemberLeave); },
            set: function (handler) {
                wc.onMemberLeave = typeof handler !== 'function' ? function none() { } : handler;
            },
        });
        this.onStateChange = undefined;
        Reflect.defineProperty(this, 'onStateChange', {
            configurable: true,
            enumerable: true,
            get: function () { return (wc.onStateChange.name === 'none' ? undefined : wc.onStateChange); },
            set: function (handler) {
                wc.onStateChange = typeof handler !== 'function' ? function none() { } : handler;
            },
        });
        this.onSignalingStateChange = undefined;
        Reflect.defineProperty(this, 'onSignalingStateChange', {
            configurable: true,
            enumerable: true,
            get: function () {
                return wc.onSignalingStateChange.name === 'none' ? undefined : wc.onSignalingStateChange;
            },
            set: function (handler) {
                wc.onSignalingStateChange = typeof handler !== 'function' ? function none() { } : handler;
            },
        });
    }
    WebGroup.prototype.join = function (key) {
        var wc = wcs.get(this);
        if (wc) {
            return wc.join(key);
        }
        throw new Error('WebChannel is undefined');
    };
    WebGroup.prototype.invite = function (url) {
        var wc = wcs.get(this);
        if (wc) {
            return wc.invite(url);
        }
        throw new Error('WebChannel is undefined');
    };
    WebGroup.prototype.leave = function () {
        var wc = wcs.get(this);
        if (wc) {
            return wc.leave();
        }
        throw new Error('WebChannel is undefined');
    };
    WebGroup.prototype.send = function (data) {
        var wc = wcs.get(this);
        if (wc) {
            return wc.send(data);
        }
        throw new Error('WebChannel is undefined');
    };
    WebGroup.prototype.sendTo = function (id, data) {
        var wc = wcs.get(this);
        if (wc) {
            return wc.sendTo(id, data);
        }
        throw new Error('WebChannel is undefined');
    };
    return WebGroup;
}());

export { LogLevel, setLogLevel, TopologyEnum as Topology, SignalingState, WebChannelState as WebGroupState, WebGroup };
//# sourceMappingURL=netflux.browser.es5.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/netflux/dist/netflux.browser.es5.esm.js
// module id = 239
// module chunks = 0